window.CardSearch = (function(){
  // Per-page config injected inline by snippets/card-search-engine.liquid (which owns
  // all Liquid interpolation — tokens, settings, asset URLs). This file is a static,
  // browser-cached asset with NO Liquid, so it must read everything from CS_CONFIG.
  var CS = window.CS_CONFIG || {};
  var TOKEN   = CS.token;
  var VERSION = CS.version || '2026-04';
  var ENDPOINT = '/api/' + VERSION + '/graphql.json';
  // M3 card-search index: when search_source='api', MTG single search/browse is served
  // by ttt-backend /api/search (Typesense) instead of Storefront tag queries. Default
  // 'storefront' keeps existing behavior exactly — flip on the dev theme to test.
  var SEARCH_SRC = CS.searchSrc || 'storefront';
  var API_BASE   = CS.apiBase || '';
  // Embedded mode (Commander Workbench). EMBED_CB = { onAdd(card), isInDeck(name) },
  // wired at runtime via CardSearch.embedSetup(). See snippets/commander-workbench.
  var EMBED = CS.embed || false;
  var EMBED_CB = null;
  var EMBED_DEFAULT = null; // () => Promise<{docs, status}>: the idle/default result set (EDHREC recs)
  // MTG set catalog (generated by loyalty-app/jobs/sets-sync). Icons are flat
  // assets/setsym-<code>.svg; derive their CDN base from the data file's URL.
  var CS_SETS_URL  = CS.setsUrl;
  var CS_ICON_BASE = CS_SETS_URL.split('?')[0].replace(/mtg-sets\.json$/, '');
  // Pokémon set catalog (loyalty-app/jobs/pokemon-tcg-sync) lives beside the MTG one;
  // icons are flat assets/psetsym-<code>.png sharing the same CDN base.
  var CS_PSETS_URL = CS.pokeSetsUrl || CS_SETS_URL.replace(/mtg-sets\.json/, 'pokemon-sets.json');
  // Per-format banned-card lists (from Scryfall). Prod tags format legality by
  // set-era and misses ban lists (e.g. Parallax Tide tagged Premodern though banned),
  // so we exclude banned cards client-side when a Format filter is active.
  var CS_BANS_URL = CS.bansUrl;
  var BANLISTS = {}, BANLISTS_LOADED = false, BANLISTS_LOADING = false;
  function loadBanlists(){
    if (BANLISTS_LOADED || BANLISTS_LOADING) return; BANLISTS_LOADING = true;
    fetch(CS_BANS_URL).then(function(r){ if (!r.ok) throw new Error('banlist HTTP ' + r.status); return r.json(); }).then(function(d){
      var b = (d && d.banned) || {};
      for (var fmt in b){ var m = {}; b[fmt].forEach(function(n){ m[String(n).toLowerCase()] = 1; }); BANLISTS[fmt] = m; }
      BANLISTS_LOADED = true; BANLISTS_LOADING = false;
      if (typeof cards !== 'undefined' && cards.length && facetState['Format']) render();   // re-filter once loaded
    }).catch(function(){ BANLISTS_LOADING = false; });   // leave LOADED false so a later Format selection retries
  }
  // True if `name` is banned in ANY currently-selected format (so it must be hidden).
  // Strip variant parentheticals/brackets ("Parallax Tide (Tom van de Logt)" → base name).
  function isBannedInActiveFormats(name){
    var sel = facetState['Format']; if (!sel || !sel.size) return false;
    var cn = String(name || '').replace(/\s*[\[(].*$/, '').trim().toLowerCase(), bad = false;
    sel.forEach(function(v){ var bl = BANLISTS[v]; if (bl && bl[cn]) bad = true; });
    return bad;
  }

  var CFG = {
    buyNow:       CS.buyNow !== false,
    checkoutNote: CS.checkoutNote,
    sellLabel:    CS.sellLabel || 'Sell Us Your Card',
    showPickup:   CS.showPickup !== false,
    pickupText:   CS.pickupText || 'Pickup available, usually ready in 24 hours',
    storeInfoUrl: CS.storeInfoUrl,
    // Buylist backend (the ttt-backend Cloud Run app). Blank → "Sell" shows a
    // "coming soon" message; set it to enable live cash/credit offers.
    buylistApiBase: CS.apiBase || '',
    gameIcons:    CS.gameIcons || {}
  };
  function buylistBase(){ return (CFG.buylistApiBase || '').replace(/\/$/, ''); }
  // Map a card's productType to the backend game code. '' = not a game the buylist knows.
  // Whether we take it ONLINE is a backend setting, asked separately (TTT.buylist.buysOnline).
  function buylistGame(card){
    var g = card.game || '';
    if (/mtg|magic/i.test(g)) return 'MTG';
    if (/pok[eé]mon/i.test(g)) return 'POKEMON';
    if (/riftbound/i.test(g)) return 'RIFTBOUND';
    if (/star\s*wars|swu/i.test(g)) return 'SWU';
    return '';
  }

  // condition columns (display order best → worst)
  var COLS = [
    { n:2, code:'NM',  label:'Near Mint' },
    { n:3, code:'LP',  label:'Lightly Played' },
    { n:5, code:'MP',  label:'Moderately Played' },
    { n:4, code:'HP',  label:'Heavily Played' },
    { n:1, code:'DMG', label:'Damaged' },
  ];
  var COND_BY_LABEL = {};
  COLS.forEach(function(c){ COND_BY_LABEL[c.label.toLowerCase()] = c; });

  var FIN = {
    nonfoil:        { key:'nonfoil',        label:'Non-Foil',         foil:false },
    foil:           { key:'foil',           label:'Foil',             foil:true },
    etched:         { key:'etched',         label:'Etched',           foil:true },
    coldfoil:       { key:'coldfoil',       label:'Cold Foil',        foil:true },
    holofoil:       { key:'holofoil',       label:'Holofoil',         foil:true },
    reverseholofoil:{ key:'reverseholofoil',label:'Reverse Holofoil', foil:true },
  };
  function finishFromText(t){
    t = String(t||'');
    if (/non[-\s]*foil|normal/i.test(t)) return FIN.nonfoil;
    if (/etched/i.test(t))         return FIN.etched;
    if (/reverse\s*holo/i.test(t)) return FIN.reverseholofoil;
    if (/cold\s*foil/i.test(t))    return FIN.coldfoil;
    if (/holo\s*foil|holofoil/i.test(t)) return FIN.holofoil;
    if (/foil/i.test(t))           return FIN.foil;
    return null;
  }
  function parseVariant(optTitle){
    var t = String(optTitle||'');
    var finish = finishFromText(t) || FIN.nonfoil;
    // Titles come as "Near Mint Foil" or "Lightly Played / Etched" (two-option products).
    var condLabel = t.replace(/reverse\s*holofoil|cold\s*foil|holofoil|foil\s*etched|etched|foil/ig,'').replace(/\s*\/\s*$/,'').trim();
    var col = COND_BY_LABEL[condLabel.toLowerCase()] || null;
    return { finish:finish, col:col, condLabel:condLabel };
  }

  // ── Facets (derived from namespaced Storepass tags: "Set_X", "Rarity_X", …) ──
  var FACET_ORDER = ['Category','Vendor','Format','Set','Series','Rarity','Language','Energy','Supertype','Subtype','Color','Domain','Energy Type','Card Type','Artist','Type'];
  var FACET_LABEL = { 'Type':'Product Type', 'Category':'Type', 'Vendor':'Brand', 'Energy':'Energy Type', 'Series':'Series', 'Supertype':'Card', 'Subtype':'Subtype' };
  var FACET_BLACKLIST = { 'Number':1, 'Brand':1, 'Printing':1 };
  var FACET_DEFAULT_OPEN = { 'Set':true, 'Format':true, 'Rarity':true, 'Category':true, 'Vendor':true, 'Energy':true };
  // Prod tags each MTG card with its actual per-card format legality as flat,
  // un-namespaced tags (Title-cased). Whitelist the constructed-relevant ones →
  // a real "Format" facet. (The dev seed lacks these; on dev the facet is empty.)
  var FORMAT_TAGS = ['Standard','Pioneer','Modern','Premodern','Pauper','Legacy','Vintage','Commander','Oathbreaker','Brawl','Alchemy','Historic','Timeless'];
  var FORMAT_TAG_SET = {}; FORMAT_TAGS.forEach(function(f){ FORMAT_TAG_SET[f] = 1; });
  var facetState = {};   // namespace → Set(values)

  function tagVal(tags, ns){
    var pre = ns + '_';
    for (var i=0;i<tags.length;i++){ if (tags[i].indexOf(pre)===0) return tags[i].slice(pre.length); }
    return '';
  }

  // Two independent multi-select filter dimensions, both in one dropdown. An empty
  // Set means "no filter" (all). selGames holds GAMES keys; selTypes holds
  // 'singles' | 'sealed' | 'accessories' | 'board-games'.
  var selGames = new Set();
  var selTypes = new Set();
  // The MTG-only tools (set browser, format/color/type tag facets) only make sense
  // when Magic is the sole selected game.
  function mtgOnly(){ return selGames.size === 1 && selGames.has('MTG Single'); }
  function pokemonOnly(){ return selGames.size === 1 && selGames.has('Pokemon Single'); }
  // "All games" + singles: only the M3 index carries the out-of-stock catalog, so these
  // must go through /api/search too. The Storefront fallback has only in-stock products,
  // which is why unchecking In Stock showed nothing until a single game was picked.
  function allGamesSingles(){ return selGames.size === 0 && selTypes.has('singles'); }
  // The game of the CURRENT RESULTS ('pokemon'|'mtg'), or null when empty/mixed — so
  // searching a Pokémon card while on "All"/"Singles" is recognized as a Pokémon context.
  function resultsGame(){
    var g = null;
    for (var i = 0; i < cards.length; i++){
      var cg = cards[i].game; if (!cg) continue;
      if (g === null) g = cg; else if (g !== cg){ g = null; break; }
    }
    return g === 'Pokemon Single' ? 'pokemon' : (g === 'MTG Single' ? 'mtg' : null);
  }
  // The game the FILTER CONTROLS reflect: an explicit single-game pick, else the game
  // of the current results, else Magic. Drives the advanced panel, set browser, and
  // typed filters (the actual query still commits a game — see commitGame).
  function advGame(){ return pokemonOnly() ? 'pokemon' : mtgOnly() ? 'mtg' : (resultsGame() || 'mtg'); }
  var cards = [];
  var navList = [];          // visible cards in display order (modal arrows + mobile cart swipe)
  var modalCard = null;      // card currently shown in the detail modal
  var cartCard = null;       // card currently shown in the cart / combined mobile sheet
  // pagination state
  var rawCards = [];        // accumulated normalized cards across pages (pre-merge)
  var pageCursor = null;    // Storefront endCursor for the next page
  var pageHasNext = false;
  var PAGE = { q:'*', sort:null, rev:false, recs:false, browse:true, empty:'', statusPrefix:null };  // current query params to paginate
  var sortMode = 'relevance';   // relevance | price | name
  var keepFilters = false;      // preserve facet selection across a re-fetch (e.g. sort change)
  var viewMode = 'list';        // 'list' (condition table / mobile list) | 'grid' (product squares)
  var viewExplicit = false;     // user manually picked a view → suppress auto-switch

  // ── URL deep-linking ──
  // Two independent dimensions: GAME (the TCG) and product TYPE. Each maps to a
  // product_type query fragment; the two combine in categoryFrag() so a shopper can
  // ask for e.g. Sealed + Magic ("MTG Sealed") rather than one-or-the-other.
  var GAME_CODE = { 'MTG Single':'mtg', 'Pokemon Single':'pokemon', 'Riftbound Singles':'riftbound', 'Star Wars: Unlimited Single':'swu' };
  var CODE_GAME = {}; Object.keys(GAME_CODE).forEach(function(k){ CODE_GAME[GAME_CODE[k]] = k; });
  // Per-game product_type strings (verified against the live store's productTypes).
  // Riftbound has no sealed line yet — its "Riftbound Sealed" frag simply returns 0.
  var GAMES = {
    'MTG Single':                  { single:'MTG Single',                  sealed:'MTG Sealed' },
    'Pokemon Single':              { single:'Pokemon Single',              sealed:'Pokemon Sealed' },
    'Riftbound Singles':           { single:'Riftbound Singles',           sealed:'Riftbound Sealed' },
    'Star Wars: Unlimited Single': { single:'Star Wars: Unlimited Single', sealed:'Star Wars: Unlimited Sealed' },
  };
  var TYPE_CODE = { 'singles':'singles', 'sealed':'sealed', 'accessories':'accessories', 'board-games':'boardgames' };
  var CODE_TYPE = {}; Object.keys(TYPE_CODE).forEach(function(k){ CODE_TYPE[TYPE_CODE[k]] = k; });
  // Short labels for the dropdown summary chip.
  var GAME_LABEL = { 'MTG Single':'Magic', 'Pokemon Single':'Pokémon', 'Riftbound Singles':'Riftbound', 'Star Wars: Unlimited Single':'Star Wars' };
  var TYPE_LABEL = { 'singles':'Singles', 'sealed':'Sealed', 'accessories':'Accessories', 'board-games':'Board Games' };
  // Reflect the current selection in the checkboxes + the summary label.
  function renderFilterUI(){
    Array.prototype.forEach.call(document.querySelectorAll('#cs-filter-dd .cs-fil'), function(b){
      var dim = b.dataset.dim, val = b.dataset.val, set = (dim === 'game') ? selGames : selTypes;
      var on = (val === '') ? (set.size === 0) : set.has(val);
      b.classList.toggle('sel', on);
    });
    var parts = [];
    selGames.forEach(function(g){ parts.push(GAME_LABEL[g] || g); });
    selTypes.forEach(function(t){ parts.push(TYPE_LABEL[t] || t); });
    var lbl = !parts.length ? 'All' : (parts.length <= 2 ? parts.join(' · ') : (parts.length + ' filters'));
    var el = $('cs-filter-label'); if (el) el.textContent = lbl;
  }
  // NB: the MTG card-Type facet uses `mtgtype`, NOT `type` — `type` is the product-type
  // dimension (singles/sealed/…, held in selTypes). Sharing `type` made ?type=singles
  // pollute facetState['Type'] with 'singles' → tag:'singles' → zero results on load.
  var FACET_PARAM = { 'Set':'set', 'Format':'fmt', 'Rarity':'rarity', 'Color':'color', 'Card Type':'cardtype', 'Energy Type':'energytype', 'Domain':'domain', 'Type':'mtgtype', 'Artist':'artist', 'Category':'category', 'Vendor':'vendor' };
  var PARAM_FACET = {}; Object.keys(FACET_PARAM).forEach(function(k){ PARAM_FACET[FACET_PARAM[k]] = k; });
  var DEFAULT_COND = ['NM','LP','MP'];      // conditions checked by default
  var desiredFinish = null;                 // Set of finish keys from URL (applied on first finish build), else null

  function setSortLabel(){
    var b = document.querySelector('#cs-sort-dd [data-sort="' + sortMode + '"]');
    if (b) $('cs-sort-label').textContent = b.textContent.trim();
  }
  // seed state from ?params (run before the first fetch)
  function parseUrl(){
    var p = new URLSearchParams(location.search);
    if (p.get('q')) $('cs-q').value = p.get('q');
    var gc = p.get('game');
    if (gc){ gc.split(',').forEach(function(c){ c = c.trim(); if (CODE_GAME[c]) selGames.add(CODE_GAME[c]); }); }
    var tc = p.get('type');
    if (tc){ tc.split(',').forEach(function(c){ c = c.trim(); if (CODE_TYPE[c]) selTypes.add(CODE_TYPE[c]); }); }
    // Bare landing on the dedicated card-search page (no game/type/query in the
    // URL): default to Magic singles, newest release first. Other pages hosting
    // this engine — /pages/inventory-search's shop browse (grid, sealed first) and
    // the Workbench embed — keep their own browse-all default. An explicit
    // filter/search/sort in the URL always opts out.
    // `all=1` is the explicit browse-all signal (the global header's Shop button and
    // search bar, and the footer's "Shop All"). Without it, a bare landing can't be
    // told apart from "the shopper cleared every filter", so the Magic default below
    // would fight the nav: clicking Shop would land on Magic singles, not everything.
    var onCardSearch = /\/pages\/card-search\/?$/.test(location.pathname);
    var browseAll = p.get('all') === '1';
    if (onCardSearch && !browseAll && !gc && !tc && !p.get('q')){
      selGames = new Set(['MTG Single']);
      selTypes = new Set(['singles']);
      if (!p.get('sort')){ sortMode = 'released'; setSortLabel(); }
    }
    renderFilterUI();
    var s = p.get('sort');
    if (s === 'price' || s === 'name' || s === 'relevance' || s === 'popularity' || s === 'released'){ sortMode = s; setSortLabel(); }
    // `v`, NOT `view`. `view` is Shopify's reserved alternate-template parameter: a URL
    // carrying ?view=list makes Shopify render templates/page.list, which does not exist,
    // so it falls back to the default page template and the search section is simply not
    // on the page ("Our card search is coming soon."). The bug hid because syncUrl writes
    // the param via replaceState AFTER the page has loaded — it only bites a shopper who
    // reloads, bookmarks, or shares the link. Old ?view= links are still read here so a
    // link already in the wild keeps its view once it reaches a template that renders.
    var vw = p.get('v') || p.get('view');
    if (vw === 'grid' || vw === 'list' || vw === 'sell'){ viewMode = vw; viewExplicit = true; }
    // Landing straight on ?v=sell: drop the in-stock pin before the first fetch,
    // so the sell grid opens on the whole catalog rather than just the shelf.
    if (vw === 'sell'){ var si = $('cs-instock'); if (si) si.checked = false; }
    if (p.get('instock') === '0') $('cs-instock').checked = false;
    if (p.get('pmin')) $('cs-pmin').value = p.get('pmin');
    if (p.get('pmax')) $('cs-pmax').value = p.get('pmax');
    if (p.get('cond')){
      var cs = new Set(p.get('cond').split(',').map(function(x){ return x.trim().toUpperCase(); }));
      Array.prototype.forEach.call(document.querySelectorAll('#cs-cond-menu input'), function(cb){ cb.checked = cs.has(cb.value); });
    }
    if (p.get('finish')) desiredFinish = new Set(p.get('finish').split(',').map(function(x){ return x.trim(); }).filter(Boolean));
    Object.keys(PARAM_FACET).forEach(function(param){
      var v = p.get(param);
      if (v){ facetState[PARAM_FACET[param]] = new Set(v.split(',').map(function(x){ return x.trim(); }).filter(Boolean)); }
    });
  }
  // write current state back to the URL (replaceState — no history spam)
  function syncUrl(){
    if (!window.history || !history.replaceState) return;
    var p = new URLSearchParams();
    var term = $('cs-q').value.trim(); if (term) p.set('q', term);
    if (selGames.size) p.set('game', Array.from(selGames).map(function(g){ return GAME_CODE[g]; }).filter(Boolean).join(','));
    if (selTypes.size) p.set('type', Array.from(selTypes).map(function(t){ return TYPE_CODE[t]; }).filter(Boolean).join(','));
    // Keep the browse-all signal alive while both scopes are empty. Without it, a
    // shopper who lands via Shop and then reloads or shares the link gets parseUrl's
    // Magic-singles default instead of the everything view they were looking at.
    if (!selGames.size && !selTypes.size && /\/pages\/card-search\/?$/.test(location.pathname)) p.set('all', '1');
    if (sortMode !== 'relevance') p.set('sort', sortMode);
    if (viewExplicit || sellMode()) p.set('v', viewMode);   // sell must survive in the URL even if the view choice was reset
    if (!$('cs-instock').checked) p.set('instock', '0');
    if ($('cs-pmin').value) p.set('pmin', $('cs-pmin').value);
    if ($('cs-pmax').value) p.set('pmax', $('cs-pmax').value);
    var fin = checkedValues('cs-finish-menu'), finTotal = document.querySelectorAll('#cs-finish-menu input').length;
    if (finTotal && fin.length < finTotal) p.set('finish', fin.join(','));
    var cond = checkedValues('cs-cond-menu');
    if (cond.slice().sort().join(',') !== DEFAULT_COND.slice().sort().join(',')) p.set('cond', cond.join(',') || 'none');
    for (var ns in facetState){ if (facetState[ns] && facetState[ns].size){ p.set(FACET_PARAM[ns] || ns.toLowerCase().replace(/\s+/g,''), Array.from(facetState[ns]).join(',')); } }
    var qs = p.toString();
    history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
  }

  // server sortKey for the current sortMode (price → Shopify product price; name → title)
  function serverSort(browse){
    if (sortMode === 'price') return { sort:'PRICE', rev:true };
    if (sortMode === 'name')  return { sort:'TITLE', rev:false };
    // The Storefront API has no release date, so "Release date" uses CREATED_AT (when
    // we listed it) — a proxy, but honest; without this a search fell through to
    // RELEVANCE order while the control still read "Release date". Popularity has no
    // Storefront proxy at all and keeps the default. (Singles go through the index
    // API, which sorts on the real released_at.)
    if (sortMode === 'released') return { sort:'CREATED_AT', rev:true };
    return browse ? { sort:'CREATED_AT', rev:true } : { sort:null, rev:false };
  }
  // per-card sort price = highest price the user can actually SEE for this card.
  // Must mirror the table's visibility rules (active finish/condition + in-stock /
  // price-range filters) — otherwise a hidden, out-of-stock or filtered-out variant
  // (incl. a merged foil row) can inflate the key and the order won't match the
  // displayed prices, which reads as "sort isn't working".
  function cardMaxPrice(card, f){
    if (card.kind === 'product') return card.priceHi || 0;
    var mx = 0;
    card.rows.forEach(function(r){
      if (f && !f.finishes.has(r.finish.key)) return;
      COLS.forEach(function(c){
        if (f && !f.conds.has(c.code)) return;
        var cell = r.cells[c.code];
        if (cell && (!f || cellVisible(cell, f)) && cell.price > mx) mx = cell.price;
      });
    });
    return mx;
  }
  // Relevance score of a card vs the search term, judged on the card NAME only
  // (the set is excluded). The API query matches the whole title, so e.g. "ring"
  // can match the set "Lord of the Rings"; scoring on the name pushes those down.
  function relevanceScore(name, term, toks){
    var n = String(name || '').toLowerCase();
    if (!term) return 0;
    if (n === term) return 100;                 // exact name
    if (n.indexOf(term) === 0) return 90;       // name starts with the phrase
    if (n.indexOf(term) !== -1) return 80;      // name contains the phrase
    if (toks.length && toks.every(function(t){ return n.indexOf(t) !== -1; })) return 60; // all tokens in name
    var hit = toks.filter(function(t){ return n.indexOf(t) !== -1; }).length;
    return hit ? 20 + hit : 0;                  // some / none (set-only) tokens
  }
  function relevanceSorted(list){
    var term = ($('cs-q') && $('cs-q').value || '').trim().toLowerCase();
    if (!term){
      // Browsing (no term): keep server (newest) order — but on the all-products Shop
      // browse, float non-singles (sealed / accessories / board games) to the top.
      if (isBrowseAll()){
        return list.map(function(c, i){ return { c:c, i:i }; })
          .sort(function(a, b){ var ak = a.c.kind === 'product' ? 0 : 1, bk = b.c.kind === 'product' ? 0 : 1; return ak - bk || a.i - b.i; })
          .map(function(x){ return x.c; });
      }
      return list;  // category/filter browse → keep server (newest) order
    }
    var toks = term.split(/[^\p{L}\p{N}]+/u).filter(function(t){ return t.length; });
    return list.map(function(c, i){ return { c:c, i:i, s:relevanceScore(c.name, term, toks) }; })
      .sort(function(a, b){ return b.s - a.s || a.i - b.i; })  // score desc, stable
      .map(function(x){ return x.c; });
  }
  // Display collation for every A-Z list the client sorts itself (results, facet
  // values). Intl gives human order - case- and accent-insensitive, digits compared
  // as numbers - where a raw < / .sort() files every lowercase or accented value
  // after Z ("rk post" is a real artist name, and it sorted below Z). Null-safe: a
  // card with no name would otherwise throw mid-render and blank the results.
  var NAME_COLL = (function(){
    try {
      var c = new Intl.Collator(undefined, { sensitivity:'base', numeric:true });
      return function(a, b){ return c.compare(a, b); };
    } catch (e){
      return function(a, b){ return a.localeCompare(b); };
    }
  })();
  function byName(a, b){ return NAME_COLL(a == null ? '' : String(a), b == null ? '' : String(b)); }
  function sortCards(list, f){
    if (sortMode === 'price') return list.slice().sort(function(a,b){ return cardMaxPrice(b, f) - cardMaxPrice(a, f); });
    // Same name = the same card in several printings: order those by set so the run
    // is stable instead of however the server happened to return them.
    if (sortMode === 'name')  return list.slice().sort(function(a,b){ return byName(a.name, b.name) || byName(a.set, b.set); });
    // popularity / released are SERVER orderings the client can't recompute (a card
    // carries no EDHREC rank or release date once normalized), so leave them alone.
    // Falling through to relevanceSorted here quietly turned "Release date" and
    // "Popularity" back into relevance the moment a search term was present.
    if (sortMode !== 'relevance') return list;
    return relevanceSorted(list);  // relevance: rank by card-name match, set excluded
  }

  function $(id){ return document.getElementById(id); }
  function checkedValues(menuId){ return Array.from(document.querySelectorAll('#'+menuId+' input:checked')).map(function(i){ return i.value; }); }

  // ── Storefront fetch ──
  // Abort a hung request instead of leaving the UI spinning forever, and turn a
  // non-2xx response (throttle / 5xx HTML error page) into a thrown error so the
  // callers' .catch paths handle it uniformly rather than choking on .json().
  var GQL_TIMEOUT = 15000;
  function gql(query, variables){
    var ctrl = (typeof AbortController !== 'undefined') ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function(){ ctrl.abort(); }, GQL_TIMEOUT) : null;
    function done(){ if (timer) clearTimeout(timer); }
    return fetch(ENDPOINT, {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'X-Shopify-Storefront-Access-Token':TOKEN },
      body: JSON.stringify({ query:query, variables:variables }),
      signal: ctrl ? ctrl.signal : undefined
    }).then(function(r){
      done();
      if (!r.ok) throw new Error('Storefront HTTP ' + r.status);
      return r.json();
    }, function(err){ done(); throw err; });
  }
  var NODE_FIELDS =
    'nodes{ id title handle productType vendor tags descriptionHtml' +
    '  featuredImage{ url altText }' +
    '  images(first:3){ nodes{ url } }' +   // back face for double-faced cards (front = featuredImage)
    '  variants(first:60){ nodes{ id title sku availableForSale quantityAvailable' +
    '    price{ amount currencyCode } selectedOptions{ name value } } } }';
  var SEARCH_Q = 'query Search($q:String!){ products(first:50, query:$q){ ' + NODE_FIELDS + ' } }';  // recs (no pagination)
  var PAGE_Q   = 'query Page($q:String!,$after:String,$sort:ProductSortKeys,$rev:Boolean){ products(first:50, query:$q, after:$after, sortKey:$sort, reverse:$rev){ ' + NODE_FIELDS + ' pageInfo{ hasNextPage endCursor } } }';

  // Cross-game product categories (not tied to a single TCG). Accessories has no
  // single product_type, so we OR the known Storepass types.
  var PRODUCT_CATS = {
    'accessories': { label:'Accessories', frag: "(product_type:Playmats OR product_type:'Card Sleeves' OR product_type:'Binders and Portfolios' OR product_type:'Deck Boxes' OR product_type:Dice OR product_type:'Sports Toploaders' OR product_type:'Carrying Cases' OR product_type:'Sports Mats' OR product_type:'Sports Card Sleeves' OR product_type:Accessories)" },
    'board-games': { label:'Board Games', frag: "(product_type:'Board Game' OR product_type:'Board Games' OR product_type:Boardgames)" },
  };
  // A non-singles product browse (drives grid-default + the in-stock relaxation):
  // a type filter is active and it doesn't include Singles.
  function isProductCat(){ return selTypes.size > 0 && !selTypes.has('singles'); }
  // Storefront product_type fragment for the current (game × type) multi-selection.
  // Result = (game filter) AND (type filter), expressed as an OR of the matching
  // product_type strings. Singles / Sealed are game-specific; Accessories / Board
  // Games are cross-game, so they only apply when no game is selected.
  function categoryFrag(){
    var anyGame = selGames.size === 0, anyType = selTypes.size === 0;
    if (anyGame && anyType) return '';               // no filter → browse everything
    var wantSingles = anyType || selTypes.has('singles');
    var wantSealed  = anyType || selTypes.has('sealed');
    var ors = [];
    if (anyGame){
      if (wantSingles) ors.push('product_type:*Single*');
      if (wantSealed)  ors.push('product_type:*Sealed*');
      // Cross-game categories belong here too (a game filter would exclude them).
      if (anyType || selTypes.has('accessories')) ors.push(PRODUCT_CATS.accessories.frag);
      if (anyType || selTypes.has('board-games')) ors.push(PRODUCT_CATS['board-games'].frag);
    } else {
      selGames.forEach(function(g){
        var G = GAMES[g]; if (!G) return;
        if (wantSingles) ors.push("product_type:'" + G.single + "'");
        if (wantSealed)  ors.push("product_type:'" + G.sealed + "'");
      });
    }
    // A game + only cross-game types (e.g. Magic + Accessories) has no match.
    if (!ors.length) return "product_type:'__no_match__'";
    return ors.length > 1 ? '(' + ors.join(' OR ') + ')' : ors[0];
  }

  // The set browser and the legacy Set facet always share facetState['Set'] (so
  // they stay mirrored). SET_SERVER_FILTER additionally pushes an MTG set
  // selection into the Storefront query so it filters ALL results (needed for
  // "browse a whole set"). Set it to false for a pure client-side mirror that
  // leaves the existing facet behaviour untouched.
  var SET_SERVER_FILTER = true;
  // Beyond this many selected sets the OR-tag query gets unwieldy for Shopify;
  // fall back to client-side facet filtering on the loaded results instead.
  var SET_QUERY_CAP = 25;
  // Server-side set filter for MTG: turns the shared Set selection (set names,
  // also driven by the set-browser modal) into a (tag:'Set_x' OR …) fragment.
  function mtgSetFrag(){
    if (!SET_SERVER_FILTER || !mtgOnly()) return '';
    var sel = facetState['Set'];
    if (!sel || !sel.size || sel.size > SET_QUERY_CAP) return '';
    // Match both store conventions: prod tags the set name flat (tag:'Bloomburrow',
    // mirrors the [Set Name] title bracket); the dev seed uses tag:'Set_<name>'.
    var ors = [];
    sel.forEach(function(v){ var e = String(v).replace(/'/g,''); ors.push("tag:'" + e + "'"); ors.push("tag:'Set_" + e + "'"); });
    return '(' + ors.join(' OR ') + ')';
  }
  // Per-card format legality filter (MTG/prod): tag:'Modern' etc. One tag each,
  // OR'd within the Format dimension, AND'd against set/term — accurate and
  // uncapped (no set-mapping). Empty on dev (cards aren't format-tagged there).
  function mtgFmtFrag(){
    if (!SET_SERVER_FILTER || !mtgOnly()) return '';
    var sel = facetState['Format'];
    if (!sel || !sel.size) return '';
    // Multiple formats intersect (AND): a card must be legal in EVERY selected
    // format. Legality is by card name, so any printing of a legal card qualifies.
    var ands = [];
    sel.forEach(function(v){ ands.push("tag:'" + String(v).replace(/'/g,'') + "'"); });
    return '(' + ands.join(' AND ') + ')';
  }
  // Advanced MTG facets (colors / rarity / type / supertype / subtype). All live as
  // flat tags on prod, which Shopify word-tokenizes — so tag:'Creature' matches the
  // fused "Legendary Creature" tag, tag:'Elf' matches "Elf Druid", etc.
  var ADV = { cmode: 'or', cexc: new Set(), submode: 'or' };   // cmode 'or'|'exact'; submode 'or'|'and' joins subtypes; cexc = excluded color names
  var advBuiltGame = 'mtg';   // which game the advanced panel is currently built for (rebuilt on game switch)
  /* Scryfall language codes -> the words a shopper reads. Mirrors src/lib/card-language.ts.
   *
   * The INDEX stores the code and the filter sends the code, so this table is presentation only —
   * renaming a label here can never invalidate the index or a saved URL. An unknown code falls
   * back to itself uppercased, so a language we add server-side still shows up as a usable filter
   * before the theme knows its name. */
  var LANG_NAMES = {
    en:'English', es:'Spanish', fr:'French', de:'German', it:'Italian', pt:'Portuguese',
    ja:'Japanese', ko:'Korean', ru:'Russian', zhs:'Simplified Chinese', zht:'Traditional Chinese',
    he:'Hebrew', la:'Latin', grc:'Ancient Greek', ar:'Arabic', sa:'Sanskrit', ph:'Phyrexian'
  };
  function langName(code){
    if (!code) return '';
    return LANG_NAMES[String(code).toLowerCase()] || String(code).toUpperCase();
  }
  window.langName = langName;
  /* Display name -> code. The facet UI stores LABELS (so the chips read "Japanese"), and the API
   * filters on CODES, so the round-trip needs both directions. Built from the table above rather
   * than written twice, which is what keeps them from drifting. */
  var LANG_CODES = (function(){ var o = {}; for (var k in LANG_NAMES) o[LANG_NAMES[k]] = k; return o; })();
  function langCode(name){ return LANG_CODES[name] || String(name || '').toLowerCase(); }

  var MTG_SERVER_NS = { Set:1, Format:1, Color:1, Rarity:1, Type:1, Supertype:1, Subtype:1, Keyword:1, Treatment:1, Language:1 };
  // A facet dimension that the server (Typesense) enforces for the active game — so
  // toggling it must refetch, not just re-render the loaded page. MTG namespaces plus
  // the Pokémon-only Energy/Series when Pokémon is the active game.
  function serverNs(ns){ return !!MTG_SERVER_NS[ns] || (pokemonOnly() && (ns === 'Energy' || ns === 'Series')); }
  function serverFilterActive(){ return SET_SERVER_FILTER && (mtgOnly() || pokemonOnly()); }
  var COLOR_FULL = ['White','Blue','Black','Red','Green'];
  // Newer/Secret-Lair cards namespace these facets (Rarity_Rare, Card Type_Creature)
  // where older cards use flat tags (Rare, Creature). Match BOTH schemes so a filter
  // isn't blind to a whole batch. (Supertype/Subtype stay flat — no clean namespaced form.)
  var NS_ALT_PREFIX = { 'Rarity':'Rarity_', 'Type':'Card Type_' };
  function mtgNsFrag(ns, joiner){
    if (!mtgOnly()) return '';
    var sel = facetState[ns]; if (!sel || !sel.size) return '';
    var pfx = NS_ALT_PREFIX[ns];
    var parts = []; sel.forEach(function(v){
      var val = String(v).replace(/'/g,'');
      parts.push(pfx ? "(tag:'" + val + "' OR tag:'" + pfx + val + "')" : "tag:'" + val + "'");
    });
    return parts.length > 1 ? '(' + parts.join(joiner) + ')' : parts[0];
  }
  function mtgColorFrag(){
    if (!mtgOnly()) return '';
    // Prod tags color TWO ways: flat ("Red") on older cards and namespaced
    // ("Color_Red") on newer/Secret-Lair imports. Match/exclude BOTH schemes so a
    // card is filtered regardless of which batch it came from. Colorless = a card
    // with no color in either scheme (also guarding the namespaced Color_Multicolor).
    function present(c){ return "(tag:'" + c + "' OR tag:'Color_" + c + "')"; }        // has color c
    function absent(c){ return "(-tag:'" + c + "' AND -tag:'Color_" + c + "')"; }       // lacks color c
    var HAS_COLOR = '(' + COLOR_FULL.map(present).join(' OR ') + ')';
    var NO_COLOR  = '(' + COLOR_FULL.map(absent).join(' AND ') + " AND -tag:'Color_Multicolor')";
    var inc = facetState['Color'], parts = [];
    if (inc && inc.size){
      var wantColorless = inc.has('Colorless');
      var names = []; inc.forEach(function(v){ if (v !== 'Colorless') names.push(present(v)); });
      if (ADV.cmode === 'exact'){                              // exactly these colors → AND included, exclude the rest
        if (names.length){
          parts.push(names.length > 1 ? '(' + names.join(' AND ') + ')' : names[0]);
          COLOR_FULL.forEach(function(c){ if (!inc.has(c)) parts.push(absent(c)); });
        } else {                                               // only Colorless selected → exactly colorless
          parts.push(NO_COLOR);
        }
      } else if (ADV.cmode === 'commander'){                   // color identity "within": any subset of the
        // selected colors (incl. colorless / mono), excluding any off-color card.
        COLOR_FULL.forEach(function(c){ if (!inc.has(c)) parts.push(absent(c)); });
      } else {                                                  // any of these colors (or colorless)
        var ors = names.slice(); if (wantColorless) ors.push(NO_COLOR);
        if (ors.length) parts.push(ors.length > 1 ? '(' + ors.join(' OR ') + ')' : ors[0]);
      }
    }
    // Excludes (the "Not X" swatches). "Not Colorless" = the card must have a color.
    if (ADV.cexc && ADV.cexc.size) ADV.cexc.forEach(function(c){
      parts.push(c === 'Colorless' ? HAS_COLOR : absent(c));
    });
    return parts.join(' AND ');
  }
  // Subtypes join by the advanced panel's And/Or toggle (default "Any" → OR).
  function subtypeJoiner(){ return ADV.submode === 'and' ? ' AND ' : ' OR '; }
  // Shared MTG server-side filter fragments (set / format / color / rarity / type /
  // supertype / subtype). Pushed into the Storefront query by BOTH the search path
  // (buildQuery) and the browse path (loadDefault) so the two can never drift.
  function mtgFilterParts(){
    var parts = [];
    var sf = mtgSetFrag(); if (sf) parts.push(sf);
    var ff = mtgFmtFrag(); if (ff) parts.push(ff);
    var cf = mtgColorFrag(); if (cf) parts.push(cf);
    var rf = mtgNsFrag('Rarity', ' OR '); if (rf) parts.push(rf);
    var tf = mtgNsFrag('Type', ' OR '); if (tf) parts.push(tf);
    var pf = mtgNsFrag('Supertype', ' AND '); if (pf) parts.push(pf);
    var bf = mtgNsFrag('Subtype', subtypeJoiner()); if (bf) parts.push(bf);
    return parts;
  }
  function buildQuery(term, game){
    var parts = [];
    if (term){
      // Match every search token against the card NAME (title) and require all of
      // them. A bare term searches all fields, so "ring" would match the set name
      // "The Lord of the Rings" and flood results — scoping to title fixes that.
      // Prefix-match each token (foo*) so partial names still work.
      var toks = term.toLowerCase().split(/[^\p{L}\p{N}]+/u).filter(function(t){ return t.length; });
      if (toks.length){
        parts.push('(' + toks.map(function(t){ return 'title:' + t + '*'; }).join(' AND ') + ')');
      }
    }
    var cf = categoryFrag(); if (cf) parts.push(cf);
    mtgFilterParts().forEach(function(p){ parts.push(p); });
    // when "in stock" is on, fetch in-stock products so the (50-result) page
    // isn't dominated by the out-of-stock long tail of a 100k catalog. This
    // applies to product categories too (sealed/accessories/board games) — the
    // checkbox is the single control: unchecking it surfaces in-store-only stock.
    // relaxed('instock'): honouring a pinned card (or a widened search) has to reach the
    // Storefront query too — this reads the checkbox directly rather than going through
    // activeFilters(), so without the guard the widening would be silently ignored here.
    if ($('cs-instock') && $('cs-instock').checked && !relaxed('instock')) parts.push('available_for_sale:true');
    return parts.join(' AND ') || '*';
  }

  function numericId(gid){ return String(gid).split('/').pop(); }

  // Product title → bare card name. Delegates to the ONE shared parser
  // (assets/ttt-utils.js), which knows both title shapes in the catalog: Model A's
  // "Sol Ring (C13 259) [Commander 2013]" printing hint and the old Storepass
  // "Sol Ring (Retro) [Set]" treatment parenthetical. The local copy this replaced
  // only stripped a BARE "(<number>)", so a Model-A title kept its "(SET NUM)" anchor
  // in the name — which then failed every exact-name match against the search index
  // (the sell printing picker rendered "No printings found." for every Model-A card).
  // Treatment isn't lost by dropping it here: deriveFacets reads it off the raw title,
  // and normalize() keeps it in the card KEY so two treatments of one card (which used
  // to differ only by that parenthetical) still can't merge into a single card.
  // `productType` is what tells a Magic reskin prefix apart from a Riftbound/SWU name that
  // simply contains " - " ("Ahri - Inquisitive") — see splitPrinted in ttt-utils.js.
  function cardTitleParts(title, set, number, productType){
    var T = window.TTT;
    if (T && T.cardTitle) return T.cardTitle(title, set, productType);
    var n = String(title);
    if (number) n = n.replace('(' + number + ')', '');
    if (set){ n = n.replace('[' + set + ']', '').replace('- ' + set, ''); }
    n = n.replace(/\s*\([A-Z0-9]{2,6}\s+[^()]{1,12}\)\s*$/, '');
    n = n.replace(/\b(reverse holofoil|cold foil|holofoil|foil)\b\s*$/i, '');
    return { name: n.replace(/\s+/g, ' ').replace(/[-–]\s*$/, '').trim(), treatment: '' };
  }
  function cardName(title, set, number){ return cardTitleParts(title, set, number).name; }

  // Parse the Storepass description table (<table class="singles-description-table">)
  // into a { Set, Type, Rarity, Cost, … } map. Present on old AND new products.
  function parseDescTable(html){
    var meta = {};
    if (!html) return meta;
    var tmp = document.createElement('div'); tmp.innerHTML = html;
    var tbl = tmp.querySelector('.singles-description-table');
    if (!tbl) return meta;
    Array.prototype.forEach.call(tbl.querySelectorAll('tr'), function(tr){
      var tds = tr.querySelectorAll('td');
      if (tds.length >= 2){
        var k = tds[0].textContent.replace(/:\s*$/, '').trim();
        var v = tds[1].textContent.trim();
        if (k) meta[k] = v;
      }
    });
    return meta;
  }
  var COLOR_NAME = { W:'White', U:'Blue', B:'Black', R:'Red', G:'Green' };
  function colorsFromCost(cost){
    var found = {};
    String(cost||'').replace(/\{([^}]+)\}/g, function(_, sym){
      sym.split('/').forEach(function(s){ var c = s.toUpperCase(); if (COLOR_NAME[c]) found[COLOR_NAME[c]] = 1; });
      return '';
    });
    var colors = Object.keys(found);
    return colors.length ? colors : ['Colorless'];
  }
  // Build a { namespace: [values] } facet map from namespaced tags (Storepass)
  // unioned with the description table (works for old bracket-format products too).
  function deriveFacets(node, set){
    var tags = node.tags || [], game = node.productType || '', f = {};
    function add(ns, val){ if (val==null || val==='') return; (f[ns] = f[ns] || []); if (f[ns].indexOf(val) < 0) f[ns].push(val); }
    tags.forEach(function(t){ var u = t.indexOf('_'); if (u > 0){ var ns = t.slice(0,u); if (!FACET_BLACKLIST[ns]) add(ns, t.slice(u+1)); } });
    // MTG per-card format legality lives in flat tags on prod (no underscore, so
    // skipped above). Pull the whitelisted ones into a Format facet.
    if (game === 'MTG Single'){ tags.forEach(function(t){ if (FORMAT_TAG_SET[t]) add('Format', t); }); }
    var meta = parseDescTable(node.descriptionHtml);
    add('Set', set || meta.Set || meta['Set Name']);
    add('Rarity', meta.Rarity);
    if (meta.Type){
      var primary = meta.Type.split(/[—–-]/)[0].trim();
      if (game === 'Pokemon Single') add('Energy Type', primary); else add('Card Type', primary);
    }
    add('Card Type', meta['Card Type']);   // Riftbound table uses this key
    add('Domain', meta.Domain);            // Riftbound
    if (game === 'MTG Single' && meta.Cost){ colorsFromCost(meta.Cost).forEach(function(c){ add('Color', c); }); }
    // Treatment (Showcase, Borderless, Extended Art, …) lives in the title
    // parentheticals on prod (e.g. "Card (Borderless) (Raised Foil) [Set]"), not in
    // tags. Extract recognized ones so the Treatment filter matches (after the group
    // merge unions member facets). Uses the canonical vocabulary, which means the
    // premium foils now match here too: they were excluded as "finishes, not
    // treatments", but each is its own separately-priced printing and the index files
    // them under `treatments` — so excluding them just hid "(Raised Foil)" titles from
    // the very filter meant to find them. Same for "(Oversized)".
    var TREATMENTS = (window.PrintingUtils && window.PrintingUtils.TREATMENT_ORDER)
      || ['Showcase','Borderless','Extended Art','Retro Frame','Full Art','Foil Etched','Reserved List','Promo'];
    (String(node.title).match(/\(([^)]+)\)/g) || []).forEach(function(grp){
      var inner = grp.slice(1, -1).toLowerCase();
      TREATMENTS.forEach(function(t){ if (inner.indexOf(t.toLowerCase()) >= 0) add('Treatment', t); });
    });
    return f;
  }

  // A product is a "single" (condition/finish table model) when its product type
  // ends in "Single"/"Singles". Everything else — sealed, accessories, board games —
  // is a plain "product" rendered as a square / compact row.
  function isSingleType(pt){ return /\bsingles?$/i.test(String(pt||'')); }

  // Normalize a non-single product (sealed / accessory / board game). One price,
  // no condition or finish. `noPrice` items (price 0 or the Storepass "noPrice"
  // tag) are in-store-only — shown as "Reserve / ask in store", never add-to-cart.
  function normalizeProduct(node){
    var tags = node.tags || [];
    var noPriceTag = tags.some(function(t){ return /^no\s*price$/i.test(t); });
    var variants = (node.variants.nodes||[]).map(function(v){
      return {
        variantId: numericId(v.id),
        title: (v.title && v.title !== 'Default Title') ? v.title : '',
        price: parseFloat(v.price.amount) || 0,
        currency: v.price.currencyCode,
        qty: v.quantityAvailable != null ? v.quantityAvailable : (v.availableForSale ? 1 : 0),
        available: !!v.availableForSale,
      };
    });
    var prices = variants.map(function(v){ return v.price; }).filter(function(p){ return p > 0; });
    var priceLo = prices.length ? Math.min.apply(null, prices) : 0;
    var priceHi = prices.length ? Math.max.apply(null, prices) : 0;
    var totalQty = variants.reduce(function(a,v){ return a + Math.max(0, v.qty); }, 0);
    var noPrice = noPriceTag || priceHi <= 0;
    // Any non-single (sealed / accessory / board game) is real inventory: if it has a
    // price AND stock, it's buyable online even when it carries the Storepass "noPrice"
    // tag (which we ignore here). Only items with no price or no stock stay in-store-only.
    if (noPrice && priceHi > 0 && totalQty > 0) noPrice = false;
    return {
      id: node.id, kind: 'product', key: 'prod|' + node.id,
      name: cleanProductTitle(node.title), set: '', number: '',
      game: node.productType, productType: node.productType || '',
      vendor: node.vendor || '', tags: tags,
      facets: deriveProductFacets(node),
      image: node.featuredImage ? node.featuredImage.url : null,
      descriptionHtml: node.descriptionHtml || '',
      variants: variants, priceLo: priceLo, priceHi: priceHi,
      totalQty: totalQty, noPrice: noPrice, rows: [],
    };
  }
  // Storepass accessory titles are often "Brand: Real Product Name" — keep the full
  // string but trim a leading vendor prefix when it duplicates the vendor field.
  function cleanProductTitle(title){ return String(title || '').trim(); }
  // Lightweight facets for products: their category (product type) and brand (vendor).
  function deriveProductFacets(node){
    var f = {};
    if (node.productType) f['Category'] = [node.productType];
    if (node.vendor) f['Vendor'] = [node.vendor];
    return f;
  }

  // Prod cards carry the collector number only in the SKU, not a Number_ tag. Two
  // shapes are in the catalog and the number sits in a different segment in each:
  //   Storepass  <SETCODE>-<number>-<LANG>-<NF|F>-<cond>   MH3-102-EN-NF-2   → [1]
  //   Model A    <GAME>-<SETCODE>-<number>-<FIN>-<COND>    MTG-MSC-835-NF-LP → [2]
  // Reading [1] only meant every Model-A card came through with number '' — harmless
  // while the "(SET NUM)" title anchor still separated them, but the card key is
  // name|set|number, so two printings from the same set would now merge into one card.
  // Only these two positions are considered: the rest is language/finish/condition.
  function numberFromSku(variants){
    var v = (variants && variants.nodes || [])[0];
    var p = String((v && v.sku) || '').split('-');
    if (p.length < 5) return '';
    if (/^[0-9]/.test(p[1])) return p[1];
    return /^[0-9]/.test(p[2]) ? p[2] : '';
  }

  function normalize(node){
    if (!isSingleType(node.productType)) return normalizeProduct(node);
    var tags = node.tags || [];
    var set = tagVal(tags, 'Set') || (String(node.title).match(/\[([^\]]+)\]\s*$/) || [])[1] || '';
    // Prefer the full "num/total" from the title (Pokémon, e.g. "(063/165)") — the
    // set size makes it set-unique so the buylist can pin it without a set-code
    // bridge. Fall back to a Number tag, then the SKU numerator (MTG).
    var number = (String(node.title).match(/\((\d+\/\d+)\)/) || [])[1]
      || tagVal(tags, 'Number') || numberFromSku(node.variants);
    var parsed = cardTitleParts(node.title, set, number, node.productType);
    var name = parsed.name;

    // product-level finish (separate-foil model): from Printing tag or title suffix
    var prodFinish = finishFromText(tagVal(tags, 'Printing')) || finishFromText(node.title);

    var rowsByFinish = {};
    (node.variants.nodes||[]).forEach(function(v){
      var opts = v.selectedOptions || [];
      // NEW two-option model: Option1 "Condition" + Option2 "Finish" as separate options.
      // LEGACY model: one "Title"/"Condition" option carrying "Near Mint Foil" combined.
      var condVal = (opts.find(function(o){ return /^(title|condition)$/i.test(o.name); })||{}).value;
      var finOpt  = opts.find(function(o){ return /finish/i.test(o.name); });
      var col, finish;
      if (finOpt){
        col = COND_BY_LABEL[String(condVal||'').trim().toLowerCase()] || null;
        finish = finishFromText(finOpt.value) || FIN.nonfoil;
      } else {
        var p = parseVariant(condVal != null ? condVal : v.title);
        col = p.col;
        finish = (p.finish.key === 'nonfoil' && prodFinish) ? prodFinish : p.finish;
      }
      if (!col) return;
      var fk = finish.key;
      if (!rowsByFinish[fk]) rowsByFinish[fk] = { finish:finish, cells:{} };
      rowsByFinish[fk].cells[col.code] = {
        variantId: numericId(v.id),
        price: parseFloat(v.price.amount) || 0,
        currency: v.price.currencyCode,
        qty: v.quantityAvailable != null ? v.quantityAvailable : (v.availableForSale ? 1 : 0),
      };
    });
    var rows = Object.keys(rowsByFinish).map(function(k){ return rowsByFinish[k]; })
      .sort(function(a,b){ return (a.finish.foil?1:0)-(b.finish.foil?1:0); });
    return {
      // Treatment is part of the key, not the name: "Sol Ring (Retro)" and "Sol Ring"
      // are different printings, and the name alone no longer tells them apart.
      id: node.id, kind: 'single', key: (name + '|' + set + '|' + number + '|' + (parsed.treatment || '')).toLowerCase(),
      name: name, set: set, number: number, game: node.productType, tags: tags,
      facets: deriveFacets(node, set),
      image: node.featuredImage ? node.featuredImage.url : null,
      back: backFace(node, name),
      descriptionHtml: node.descriptionHtml || '', rows: rows,
    };
  }
  // Back-face image for a double-faced card (transform/MDFC). True DFCs carry a "//"
  // name AND a product image distinct from the front (featuredImage); split/adventure
  // cards have a "//" name but only the single front image, so they get no flip.
  function backFace(node, name){
    if (String(name).indexOf('//') < 0) return null;
    var feat = node.featuredImage ? node.featuredImage.url : null;
    var imgs = (node.images && node.images.nodes) || [];
    for (var i = 0; i < imgs.length; i++){ if (imgs[i].url && imgs[i].url !== feat) return imgs[i].url; }
    return null;
  }
  // Append a flip control to an image container (position:relative) for DFCs. Toggles
  // the <img> between front/back with a quick rotateY; the card text is on the face image.
  function attachFlip(container, imgEl, card, small){
    if (!card || !card.back || !imgEl) return;
    container.classList.add('cs-flipwrap');
    var b = document.createElement('button'); b.type = 'button'; b.className = 'cs-flip' + (small ? ' cs-flip-sm' : ''); b.title = 'Flip card'; b.setAttribute('aria-label','Flip card');
    b.innerHTML = '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 12a9 9 0 0 1 15-6.7L21 8"/><path d="M21 3v5h-5"/><path d="M21 12a9 9 0 0 1-15 6.7L3 16"/><path d="M3 21v-5h5"/></svg>';
    var flipped = false;
    b.onclick = function(e){ e.preventDefault(); e.stopPropagation();
      imgEl.style.transition = 'transform .16s ease'; imgEl.style.transform = 'rotateY(90deg)';
      setTimeout(function(){ flipped = !flipped; imgEl.src = flipped ? card.back : card.image; imgEl.style.transform = 'rotateY(0deg)'; }, 150);
    };
    container.appendChild(b);
  }

  // Merge separate-finish products (e.g. Riftbound "…- Unleashed" + "…- Unleashed Foil")
  // that represent the same physical card into one card with multiple finish rows.
  function mergeCards(list){
    var byKey = {}, order = [];
    list.forEach(function(c){
      if (!byKey[c.key]){ byKey[c.key] = c; order.push(c.key); return; }
      var m = byKey[c.key];
      c.rows.forEach(function(r){
        var ex = m.rows.find(function(x){ return x.finish.key === r.finish.key; });
        if (ex){ Object.keys(r.cells).forEach(function(cc){ if (!ex.cells[cc]) ex.cells[cc] = r.cells[cc]; }); }
        else m.rows.push(r);
      });
      m.rows.sort(function(a,b){ return (a.finish.foil?1:0)-(b.finish.foil?1:0); });
      var ts = {}; m.tags.forEach(function(t){ ts[t]=1; }); c.tags.forEach(function(t){ ts[t]=1; });
      m.tags = Object.keys(ts);
      // union facets too
      var cf = c.facets || {}; m.facets = m.facets || {};
      Object.keys(cf).forEach(function(ns){
        m.facets[ns] = m.facets[ns] || [];
        cf[ns].forEach(function(v){ if (m.facets[ns].indexOf(v) < 0) m.facets[ns].push(v); });
      });
      if (!m.image && c.image) m.image = c.image;
      if (!m.descriptionHtml && c.descriptionHtml) m.descriptionHtml = c.descriptionHtml;
    });
    return order.map(function(k){ return byKey[k]; });
  }

  // ── Filters ──
  /* ── Zero-result relaxation ───────────────────────────────────────────────────
   * When a query matches nothing we widen it rather than showing a dead end. Server
   * dimensions (in-stock, price, facets, game) are relaxed by /api/search itself and
   * reported back in `relaxed`; the two CLIENT-only filters (condition and finish)
   * are relaxed here, in render().
   *
   * This is deliberately transient state. It is never written into facetState /
   * selGames / selTypes and never reaches syncUrl(), because the shopper's filters
   * are still their filters — we're showing a widened view of them, not silently
   * editing what they asked for. Restoring is then just "stop relaxing".
   */
  var RELAX = [];          // dropped by the server: 'instock' | 'price' | 'filters' | 'game'
  var RELAX_CLIENT = [];   // dropped here: 'conds' | 'finish' (recomputed every render)
  var relaxSuppress = false;   // one-shot: "show me the strict result" from the banner
  /* Dimensions forced off to honour an explicit card pick from the typeahead —
   * see checkPinned(). Unlike RELAX these are set BEFORE the request rather than
   * reported back by it, and they're sent as `relaxed=` so the server drops them
   * without needing a zero-result trigger. Server-unknown keys ('conds'/'finish')
   * are ignored server-side and applied here. */
  var RELAX_FORCE = [];
  function relaxed(k){ return RELAX.indexOf(k) >= 0 || RELAX_CLIENT.indexOf(k) >= 0 || RELAX_FORCE.indexOf(k) >= 0; }
  function anyRelaxed(){ return RELAX.length > 0 || RELAX_CLIENT.length > 0 || RELAX_FORCE.length > 0; }
  var RELAX_LABEL = { instock:'In stock', price:'Price range', filters:'Filters', game:'Game / category', conds:'Condition', finish:'Finish' };
  function allValues(menuId){
    var s = new Set();
    Array.prototype.forEach.call(document.querySelectorAll('#' + menuId + ' input'), function(i){ s.add(i.value); });
    return s;
  }

  // A relaxed dimension must be neutralised HERE as well as server-side. The result
  // rows are re-checked client-side on every render, so a server that helpfully
  // dropped in-stock would otherwise have its rows filtered straight back out and the
  // page would still read as empty.
  function activeFilters(){
    return {
      finishes: relaxed('finish') ? allValues('cs-finish-menu') : new Set(checkedValues('cs-finish-menu')),
      conds:    relaxed('conds')  ? allValues('cs-cond-menu')   : new Set(checkedValues('cs-cond-menu')),
      pmin: relaxed('price') ? NaN : parseFloat($('cs-pmin').value),
      pmax: relaxed('price') ? NaN : parseFloat($('cs-pmax').value),
      instock: relaxed('instock') ? false : $('cs-instock').checked,
    };
  }
  function cellVisible(cell, f){
    if (!cell) return false;
    if (f.instock && cell.qty <= 0) return false;
    if (!isNaN(f.pmin) && cell.price < f.pmin) return false;
    if (!isNaN(f.pmax) && cell.price > f.pmax) return false;
    return true;
  }
  function rowVisible(row, f){
    // An empty finish/condition set means "no filter on this dimension" (match all),
    // so an all-unchecked state never silently hides every row (→ zero results).
    if (f.finishes.size && !f.finishes.has(row.finish.key)) return false;
    return COLS.some(function(c){ return (!f.conds.size || f.conds.has(c.code)) && cellVisible(row.cells[c.code], f); });
  }
  function cardPassesFacets(card){
    // The server dropped the facet filters to find these rows at all — re-applying
    // them here would throw the relaxed results away again.
    if (relaxed('filters')) return true;
    var fac = card.facets || {};
    for (var ns in facetState){
      // Type/Supertype/Subtype (and Color exact/exclude) are enforced server-side via
      // flat tags and aren't derived onto cards here, so skip them client-side.
      if (ns === 'Type' || ns === 'Supertype' || ns === 'Subtype') continue;
      // Pokémon energy/series are enforced server-side too (energy/series params).
      if (ns === 'Energy' || ns === 'Series') continue;
      // Set is enforced server-side too (setcode/set param). Its indexed set_name can
      // differ from the picker's name (Scryfall vs indexed naming, colon variants), so
      // a client re-check by exact set_name wrongly drops EVERY server-filtered result
      // (e.g. a whole set showing "0 results" while in-stock copies exist). Trust the
      // server filter.
      if (ns === 'Set') continue;
      // Exact/Commander color identity is enforced server-side; checking the
      // include-set client-side here would wrongly drop in-identity colorless/mono cards.
      if (ns === 'Color' && ADV.cmode !== 'or') continue;
      var sel = facetState[ns], vals = fac[ns] || [], lookup = {};
      for (var i=0;i<vals.length;i++) lookup[vals[i]] = 1;
      if (ns === 'Format'){
        // Formats intersect (AND): the card must carry EVERY selected format tag.
        var all = true;
        sel.forEach(function(v){ if (!lookup[v]) all = false; });
        if (!all) return false;
        // …and must not be on that format's ban list (prod tags by era, not legality).
        if (isBannedInActiveFormats(card.name)) return false;
      } else {
        // Other facets union (OR): any one selected value is enough.
        var ok = false;
        sel.forEach(function(v){ if (lookup[v]) ok = true; });
        if (!ok) return false;
      }
    }
    return true;
  }

  // ── Facet drawer ──
  function updateFacetToggle(){
    var n = 0; for (var ns in facetState) n += facetState[ns].size;
    var btn = $('cs-facets-toggle');
    btn.innerHTML = '☰ Filters' + (n ? ' <span style="background:#D8A43C;color:#1C1712;border-radius:999px;font-size:.7rem;padding:0 .4rem;font-weight:700;line-height:1.3">' + n + '</span>' : '');
  }
  function buildFacets(){
    var host = $('cs-facets-body'); host.innerHTML = '';
    var groups = {};
    if (useApiSearch() && SERVER_FACETS){
      // API mode: counts come from the server over the whole filtered set.
      groups = serverGroups(SERVER_FACETS);
    } else {
      cards.forEach(function(card){
        var fac = card.facets || {};
        Object.keys(fac).forEach(function(ns){
          if (FACET_BLACKLIST[ns]) return;
          if (!groups[ns]) groups[ns] = {};
          fac[ns].forEach(function(val){ groups[ns][val] = (groups[ns][val] || 0) + 1; });
        });
      });
    }
    var nsList = Object.keys(groups);
    if (!nsList.length){
      // mobile: the drawer still holds the folded controls, so keep it reachable
      $('cs-facets').style.display = isMobile() ? '' : 'none';
      $('cs-facets-toggle').style.display = isMobile() ? 'inline-flex' : 'none';
      return;
    }
    $('cs-facets').style.display = '';
    $('cs-facets-toggle').style.display = 'inline-flex';
    updateFacetToggle();
    nsList.sort(function(a,b){
      var ia = FACET_ORDER.indexOf(a), ib = FACET_ORDER.indexOf(b);
      return (ia<0?99:ia) - (ib<0?99:ib) || a.localeCompare(b);
    });
    nsList.forEach(function(ns){
      var det = document.createElement('details');
      det.className = 'cs-facet-group';
      det.dataset.ns = ns;
      det.open = !!FACET_DEFAULT_OPEN[ns];
      var sum = document.createElement('summary');
      sum.innerHTML = '<span>' + (FACET_LABEL[ns] || ns) + '</span><span class="cs-fi"></span>';
      det.appendChild(sum);
      var vals = document.createElement('div'); vals.className = 'cs-facet-vals';
      var list = document.createElement('div'); list.className = 'cs-facet-list';
      var valKeys = Object.keys(groups[ns]).sort(byName);

      // big groups (Set, Artist, Card Type…) get a search box that filters the list
      if (valKeys.length > 8){
        var search = document.createElement('input');
        search.className = 'cs-facet-search'; search.type = 'text';
        search.placeholder = 'Search ' + (FACET_LABEL[ns] || ns);
        search.oninput = function(){
          var qq = search.value.toLowerCase(), any = false;
          Array.prototype.forEach.call(list.querySelectorAll('label'), function(l){
            var match = l.dataset.val.indexOf(qq) >= 0;
            l.style.display = match ? '' : 'none'; if (match) any = true;
          });
          empty.style.display = any ? 'none' : '';
        };
        vals.appendChild(search);
      }

      valKeys.forEach(function(val){
        var lab = document.createElement('label'); lab.dataset.val = val.toLowerCase();
        var cb = document.createElement('input'); cb.type = 'checkbox'; cb.value = val; cb.dataset.ns = ns;
        if (facetState[ns] && facetState[ns].has(val)) cb.checked = true;
        cb.onchange = function(){
          if (!facetState[ns]) facetState[ns] = new Set();
          if (cb.checked) facetState[ns].add(val);
          else { facetState[ns].delete(val); if (!facetState[ns].size) delete facetState[ns]; }
          // MTG Set selection drives the server query (see mtgSetFrag) → refetch
          // so it filters all results, not just the loaded page. Other facets stay
          // client-side. Keep the "Sets" button count mirrored either way.
          if (serverNs(ns)){ updateSetBrowseCount(); if (serverFilterActive()){ refilter(); return; } }
          render();
        };
        var txt = document.createElement('span');
        txt.appendChild(document.createTextNode(val + ' '));   // value is a merchant tag — escape it
        var fc = document.createElement('span'); fc.className = 'cs-fcount';
        fc.textContent = '(' + groups[ns][val] + ')';
        txt.appendChild(fc);
        lab.appendChild(cb); lab.appendChild(txt); list.appendChild(lab);
      });
      var empty = document.createElement('div'); empty.className = 'cs-facet-empty'; empty.textContent = 'No matches'; empty.style.display = 'none';
      list.appendChild(empty);
      vals.appendChild(list);
      det.appendChild(vals); host.appendChild(det);
    });
    updateFacetBadges();
  }
  // Show a count badge on each facet group's header so active selections are visible
  // even when the group is collapsed. Recomputed from facetState on every render.
  function updateFacetBadges(){
    Array.prototype.forEach.call(document.querySelectorAll('#cs-facets-body .cs-facet-group'), function(det){
      var ns = det.dataset.ns; if (!ns) return;
      var lab = det.querySelector('summary > span'); if (!lab) return;
      var badge = lab.querySelector('.cs-facet-badge');
      var sel = facetState[ns], cnt = sel ? sel.size : 0;
      if (cnt){
        if (!badge){ badge = document.createElement('span'); badge.className = 'cs-facet-badge'; lab.appendChild(badge); }
        badge.textContent = cnt;
      } else if (badge){ badge.parentNode.removeChild(badge); }
    });
  }

  // ── Applied-filter chips ──
  function chipEl(label, onclick){
    var el = document.createElement('button'); el.className = 'cs-chip'; el.type = 'button';
    el.appendChild(document.createTextNode(label + ' '));
    var x = document.createElement('span'); x.className = 'cs-x'; x.textContent = '✕'; el.appendChild(x);
    el.onclick = onclick; return el;
  }
  // Workbench: the commander's Format + colour-identity filters are locked — render
  // them as a non-removable chip (a small lock, no ✕) and block clearing.
  function embedLocked(ns){ return EMBED && (ns === 'Color' || ns === 'Format'); }
  function chipLocked(label){
    var el = document.createElement('span'); el.className = 'cs-chip cs-locked'; el.title = 'Locked to your commander';
    el.appendChild(document.createTextNode(label + ' '));
    var lk = document.createElement('span'); lk.className = 'cs-lock';
    lk.innerHTML = '<svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>';
    el.appendChild(lk);
    return el;
  }
  // Populate `host` with a removable chip for every active filter — generic facets,
  // the advanced MTG color mode/excludes, and price. Returns the chip count. Shared
  // by the top chip bar and the no-results panel so both stay complete and in sync.
  // withInStock: only the no-results panel wants an In-stock chip. In the normal chip
  // row it just echoes the toggle sitting a few pixels above it; in the empty state it
  // is often the ONLY removable thing, and without it the panel doesn't render at all.
  function buildActiveChips(host, withInStock){
    host.innerHTML = '';
    var n = 0;
    var pmin = $('cs-pmin').value, pmax = $('cs-pmax').value;
    var hasPrice = pmin !== '' || pmax !== '';
    var nsList = Object.keys(facetState).filter(function(ns){ return facetState[ns].size; });

    // Order: Format and Set first (the set-browser dimensions), then the rest.
    nsList.sort(function(a,b){ var r = {Format:0, Set:1}; return (r[a]==null?2:r[a]) - (r[b]==null?2:r[b]) || a.localeCompare(b); });
    nsList.forEach(function(ns){
      var vals = Array.from(facetState[ns]), label = FACET_LABEL[ns] || ns;
      // Color carries its mode so the chip is honest about Exact / Identity matching.
      var pfx = (ns === 'Color' && ADV.cmode === 'exact') ? 'Exactly ' : (ns === 'Color' && ADV.cmode === 'commander') ? 'Identity ' : '';
      // Many values (e.g. a whole rotation zone) collapse to one clearable chip.
      if (vals.length > 6 && !embedLocked(ns)){
        host.appendChild(chipEl(label + ': ' + vals.length + ' selected', function(){ removeAllInNs(ns); })); n++;
      } else {
        vals.forEach(function(val){
          if (embedLocked(ns)) host.appendChild(chipLocked(pfx + label + ': ' + val));
          else host.appendChild(chipEl(pfx + label + ': ' + val, function(){ removeFacet(ns, val); }));
          n++;
        });
      }
    });
    // Excluded colors (the "NOT" chips from the advanced color picker) are server-side.
    if (ADV.cexc && ADV.cexc.size){
      Array.from(ADV.cexc).forEach(function(name){
        host.appendChild(chipEl('Not ' + name, function(){ ADV.cexc.delete(name); advChipChanged(); })); n++;
      });
    }
    // An Exact / Identity mode with no included colors still constrains the query
    // (e.g. Exact of nothing = colorless) — surface it so it can be cleared.
    if (ADV.cmode !== 'or' && !(facetState['Color'] && facetState['Color'].size)){
      if (EMBED) host.appendChild(chipLocked('Colors: Identity'));   // colourless commander — still locked
      else host.appendChild(chipEl('Colors: ' + (ADV.cmode === 'exact' ? 'Exact' : 'Identity'), function(){ ADV.cmode = 'or'; advChipChanged(); }));
      n++;
    }
    if (hasPrice){
      host.appendChild(chipEl('Price: ' + (pmin ? '$' + pmin : '$0') + '–' + (pmax ? '$' + pmax : '∞'), function(){ $('cs-pmin').value = ''; $('cs-pmax').value = ''; render(); })); n++;
    }
    // In stock is a filter like any other and is usually the ONLY one narrowing a
    // search, so it has to be chipped — otherwise buildActiveChips returns 0 and the
    // "remove some filters" panel never renders, leaving a dead end. It also gives the
    // toggle a second home, which matters on mobile where the real control is behind
    // the Filters drawer.
    var isc = $('cs-instock');
    if (withInStock && isc && isc.checked && !relaxed('instock')){
      host.appendChild(chipEl('In stock only', function(){ setInStock(false); })); n++;
    }
    // Condition / finish aren't in facetState, but when narrowed from their defaults they
    // silently hide cards (e.g. "NM only" hides staples we stock as Lightly Played) — so
    // surface them as clearable chips, otherwise a "no results" panel is un-actionable.
    var condSel = checkedValues('cs-cond-menu');
    if (condSel.length && condSel.slice().sort().join(',') !== DEFAULT_COND.slice().sort().join(',')){
      host.appendChild(chipEl('Condition: ' + condSel.join('/'), function(){
        Array.prototype.forEach.call(document.querySelectorAll('#cs-cond-menu input'), function(cb){ cb.checked = DEFAULT_COND.indexOf(cb.value) >= 0; });
        render();
      })); n++;
    }
    var finInputs = document.querySelectorAll('#cs-finish-menu input');
    var finSel = checkedValues('cs-finish-menu');
    if (finInputs.length > 1 && finSel.length && finSel.length < finInputs.length){
      host.appendChild(chipEl('Finish: ' + finSel.join('/'), function(){
        Array.prototype.forEach.call(finInputs, function(cb){ cb.checked = true; });
        render();
      })); n++;
    }
    return n;
  }
  // Re-run after clearing an advanced color mode/exclude from a chip. Color is
  // server-side, so this refetches (like removeFacet does for MTG_SERVER_NS).
  function advChipChanged(){
    if (typeof advRender === 'function') advRender();
    if (typeof updateSetBrowseCount === 'function') updateSetBrowseCount();
    if (SET_SERVER_FILTER && mtgOnly()){ syncUrl(); refilter(); }
    else render();
  }
  function renderChips(){
    var host = $('cs-chips');
    var n = buildActiveChips(host);
    if (!n){ host.style.display = 'none'; return; }
    host.style.display = 'flex';
    var clr = document.createElement('button'); clr.className = 'cs-chip-clear'; clr.type = 'button';
    clr.textContent = 'Clear all'; clr.onclick = clearAllFilters;
    host.appendChild(clr);
  }
  /* Banner above the results explaining that what's on screen is a WIDENED search,
   * and which constraints were set aside to get it. Without this the shopper reads
   * relaxed rows as their filters being ignored (or broken).
   *
   * "Show strict results" is one-shot: it re-runs with relaxation disarmed, which
   * lands on the real empty state and its remove-a-filter panel. Any subsequent
   * filter change re-arms it.
   */
  function renderRelaxBanner(show){
    var host = $('cs-relax');
    if (!host) return;
    if (show === false || !anyRelaxed()){ host.style.display = 'none'; host.innerHTML = ''; return; }
    var seen = {}, names = [];
    RELAX.concat(RELAX_CLIENT, RELAX_FORCE).forEach(function(k){
      var l = RELAX_LABEL[k] || k;
      if (!seen[l]){ seen[l] = 1; names.push(l); }
    });
    var human = names.length === 1 ? names[0]
      : names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
    var term = $('cs-q').value.trim();
    host.style.display = 'flex';
    // Two different situations, and saying "no matches" for the pinned one would be a
    // lie — there WERE matches, just not the card the shopper actually clicked.
    // Only the pinned case gets the "showing results for X" wording; a plain widened
    // search reuses the generic one below.
    if (RELAX_FORCE.length && pinnedName){
      // Naming each set-aside dimension here read as a list of things that had gone
      // wrong; the shopper only needs to know the filters aren't fully applied, and
      // the button beside it is how they get the strict list back.
      host.innerHTML =
        '<span>Showing results for <strong></strong>, some filters were disabled.</span>' +
        '<button type="button" id="cs-relax-strict">Show strict results</button>';
      host.querySelector('strong').textContent = pinnedName || term;
    } else {
      host.innerHTML =
        '<span>No matches' + (term ? ' for <strong></strong>' : ' with your filters') +
        ' — showing results with <strong class="cs-relax-dims"></strong> set aside.</span>' +
        '<button type="button" id="cs-relax-strict">Show strict results</button>';
      // textContent for the user-supplied term (never interpolate it into innerHTML).
      if (term) host.querySelector('strong').textContent = term;
    }
    var dims = host.querySelector('.cs-relax-dims');   // pinned wording names none of them
    if (dims) dims.textContent = human;
    $('cs-relax-strict').onclick = function(){
      relaxSuppress = true;
      RELAX = []; RELAX_CLIENT = []; RELAX_FORCE = [];
      pinnedName = null; pendingPin = null; pinStage = 0;
      refilter();
    };
  }
  // Prominent "what's filtering everything out" panel appended to an empty result
  // box. Lists every active filter as a removable chip + a clear-all, and hides the
  // thin top chip bar so the filters appear in exactly one (prominent) place.
  function noResultsFilters(box){
    var chips = document.createElement('div');
    var n = buildActiveChips(chips, true);
    if (!n) return;
    $('cs-chips').style.display = 'none';
    chips.className = 'cs-nores-chips';
    var panel = document.createElement('div'); panel.className = 'cs-nores';
    var h = document.createElement('div'); h.className = 'cs-nores-h'; h.textContent = 'Active filters: remove some to see results';
    var clr = document.createElement('button'); clr.type = 'button'; clr.className = 'cs-nores-clear'; clr.textContent = 'Clear all filters'; clr.onclick = clearAllFilters;
    panel.appendChild(h); panel.appendChild(chips); panel.appendChild(clr);
    box.appendChild(panel);
  }
  // Clear an entire filter dimension at once (the summary chip's ✕).
  function removeAllInNs(ns){
    if (embedLocked(ns)) return;   // commander lock
    delete facetState[ns];
    if (ns === 'Color') ADV.cmode = 'or';   // no colors → drop Exact/Identity mode
    Array.prototype.forEach.call(document.querySelectorAll('#cs-facets-body input:checked'), function(cb){ if (cb.dataset.ns === ns) cb.checked = false; });
    if (typeof advRender === 'function') advRender();   // keep the advanced panel in sync
    if (serverNs(ns)){ updateSetBrowseCount(); if (serverFilterActive()){ syncUrl(); refilter(); return; } }
    render();
  }
  function removeFacet(ns, val){
    if (embedLocked(ns)) return;   // commander lock (Format/Color)
    if (facetState[ns]){ facetState[ns].delete(val); if (!facetState[ns].size) delete facetState[ns]; }
    // Clearing the last included color also drops the Exact/Identity mode, else it
    // orphans as a confusing "Exact of nothing" state.
    if (ns === 'Color' && !(facetState['Color'] && facetState['Color'].size)) ADV.cmode = 'or';
    Array.prototype.forEach.call(document.querySelectorAll('#cs-facets-body input'), function(cb){
      if (cb.dataset.ns === ns && cb.value === val) cb.checked = false;
    });
    if (typeof advRender === 'function') advRender();   // keep the advanced panel in sync
    // Set/Format drive the server query for MTG → refetch, not just re-render.
    if (serverNs(ns)){ updateSetBrowseCount(); if (serverFilterActive()){ syncUrl(); refilter(); return; } }
    render();
  }
  // Uncheck In stock and re-run. Client-side refiltering can't do this: the loaded set
  // is in-stock-only, so the out-of-stock cards simply aren't there yet.
  function setInStock(on){
    var el = $('cs-instock');
    if (!el || el.checked === on) return;
    el.checked = on;
    syncUrl();
    if ($('cs-q').value.trim()) doSearch(); else loadDefault();
  }
  function clearAllFilters(){
    var hadServer = (ADV.cexc.size || ADV.cmode !== 'or');
    for (var sns in facetState){ if (serverNs(sns) && facetState[sns].size) hadServer = true; }
    // Workbench: preserve the commander lock (Format=Commander + colour identity).
    var keepFmt = EMBED ? facetState['Format'] : null;
    var keepColor = EMBED ? facetState['Color'] : null;
    facetState = {}; ADV.cmode = 'or'; ADV.cexc = new Set(); ADV.submode = 'or';
    if (EMBED){ if (keepFmt) facetState['Format'] = keepFmt; if (keepColor) facetState['Color'] = keepColor; ADV.cmode = 'commander'; hadServer = true; }
    if (typeof advRender === 'function') advRender();
    Array.prototype.forEach.call(document.querySelectorAll('#cs-facets-body input:checked'), function(cb){ cb.checked = false; });
    // Condition/Finish live in their own menus (not #cs-facets-body), so restore their
    // defaults here — otherwise "Clear all" could leave zero conditions and show nothing.
    Array.prototype.forEach.call(document.querySelectorAll('#cs-cond-menu input'), function(cb){ cb.checked = DEFAULT_COND.indexOf(cb.value) >= 0; });
    Array.prototype.forEach.call(document.querySelectorAll('#cs-finish-menu input'), function(cb){ cb.checked = true; });
    $('cs-pmin').value = ''; $('cs-pmax').value = '';
    if (typeof SETB !== 'undefined'){ SETB.sel = SETB.sel && {}; SETB.fmtSel = SETB.fmtSel && {}; }
    if (typeof updateSetBrowseCount === 'function') updateSetBrowseCount();
    // In stock needs a refetch rather than a refilter, and it owns that itself.
    var isc2 = $('cs-instock');
    if (isc2 && isc2.checked){ setInStock(false); return; }
    if (hadServer && serverFilterActive()){ syncUrl(); refilter(); }
    else render();
  }

  // ── Render ──
  function fmt(n){ return '$' + n.toFixed(2); }
  // Base card name for grouping: drop art-variant / printing parentheticals and
  // set brackets so every treatment of a card ("Sol Ring", "Sol Ring (Rainbow
  // Foil)", "Sol Ring (Borderless Alternate Art)") collapses under one row.
  function baseName(name){ return String(name || '').replace(/\s*[\[(].*$/, '').trim(); }
  // Player-facing title for a reskinned printing: lead with the printed (vanity) name and
  // keep the real card name in parens — "Ifrit (Fury)" — so a shopper who searched the
  // vanity name sees it, while the oracle name stays visible for what the card actually is.
  // "<printed name> - <oracle name>" for a reskin, via the shared helper so the tile, the
  // typeahead, the product title and the buylist line all name the card the same way.
  function dispName(card){
    if (!card) return '';
    var P = window.PrintingUtils;
    return P && P.printedHeadline ? P.printedHeadline(card.flavorName, card.name)
      : (card.flavorName && card.flavorName !== card.name ? card.flavorName + ' - ' + card.name : card.name);
  }
  /* The treatments on a result row, canonicalized.
   *
   * `card.name` is the BARE name — cardTitleParts strips the "(Borderless)" parenthetical
   * so that two treatments of one card don't look like two different cards — which left
   * the list view unable to say which printing a row actually is. deriveFacets keeps the
   * treatment as a facet, so read it back from there.
   */
  function cardTreatments(card){
    var u = window.PrintingUtils;
    var raw = (card && card.facets && card.facets.Treatment) || [];
    return u ? u.normalizeTreatments(raw) : [].concat(raw);
  }
  /* Treatment chips for a row name ('' when the printing is plain).
   *
   * No cap by default: a result row spans the full width of the results table, so there
   * is no reason to hide labels behind a "+N" here. The tight surfaces that DO need a
   * budget (the sell drawer, the buylist table, the admin tables) pass their own. */
  /* A language chip for a row name — '' for English, which is every card unless a store takes in
   * foreign stock.
   *
   * Rendered BEFORE the treatments and in its own chip, mirroring the product title. A shopper
   * scanning a results table has no other way to tell a Japanese copy from an English one: the
   * card name, set and collector number are identical by construction, because a foreign printing
   * shares all three with its English counterpart. */
  /* The language as a word, or '' for English. Split out from cardLangHtml because the detail
   * modal builds DOM nodes rather than an HTML string — and because it going missing there was
   * the bug: the chip shipped on the list row and the tile, and the one surface with an Add to
   * Cart button on it said nothing. A shopper cannot tell a Japanese copy from an English one by
   * looking: name, set and collector number are identical by construction, and the card IMAGE is
   * the English art (Scryfall has no Japanese image for these printings), so the picture actively
   * argues the wrong way. */
  function cardLangName(card){
    var code = (card && card.facets && card.facets.Language && card.facets.Language[0]) || '';
    return (!code || code === 'English') ? '' : code;
  }
  function cardLangHtml(card){
    var code = cardLangName(card);
    if (!code) return '';
    /* INLINE STYLE, not a utility class: this theme's Tailwind build is purged against the
     * templates, so a class invented in a JS string is compiled away and renders as nothing. The
     * treatment chip beside it solves the same problem the same way (see printing-utils.js).
     *
     * A DIFFERENT COLOUR from the gold treatment chip on purpose — the two sit side by side and
     * say different kinds of thing ("this printing looks like X" versus "this card is in another
     * language"), so they should not read as one run of decoration. */
    return ' <span class="ttt-lang" style="display:inline-block;margin-left:.35em;padding:0 .3em;'
      + 'border-radius:3px;background:rgba(49,78,120,.12);color:#31527A;font-weight:600;'
      + 'font-size:.85em;vertical-align:1px">' + escHtml(code) + '</span>';
  }
  function cardTreatHtml(card, max, finish){
    var u = window.PrintingUtils;
    var t = cardTreatments(card);
    if (!t.length) return '';
    return u && u.treatmentHtml ? u.treatmentHtml(t, max == null ? Infinity : max, { finish: finish }) : '';
  }
  /* The finish a row or tile is actually offering, when it offers exactly one.
   *
   * The index doc is one PRINTING, and both catalog sources hang the foil-layer promo type
   * (surgefoil, ripplefoil, …) on the printing even when it holds a plain nonfoil copy too —
   * a Commander-deck printing is one card object with both finishes under one collector
   * number. Feeding this to the treatment renderer keeps a shopper from being shown
   * "SURGE FOIL" over the plain nonfoil copy that is the only one we stock. Null when
   * several finishes are on offer, where the label describes the printing and belongs. */
  function soleVisibleFinish(rows){
    var seen = {}, keys = [];
    (rows || []).forEach(function(r){
      var k = r && r.finish && r.finish.key;
      if (k && !seen[k]){ seen[k] = 1; keys.push(k); }
    });
    return keys.length === 1 ? keys[0] : null;
  }
  function escHtml(s){
    var u = window.PrintingUtils;
    if (u && u.esc) return u.esc(s);
    return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  function showTip(el, text){
    var tip = $('cs-tip');
    tip.textContent = text;
    tip.style.display = 'block';
    var r = el.getBoundingClientRect();
    tip.style.left = Math.round(r.left + r.width/2) + 'px';
    tip.style.top  = Math.round(r.top - 6) + 'px';
  }
  function hideTip(){ var t = $('cs-tip'); if (t) t.style.display = 'none'; }

  function isMobile(){ return window.matchMedia('(max-width:680px)').matches; }
  // On mobile, fold In-stock / Sort / Finish / Condition / Price into the Filters
  // drawer as inline sections; on desktop, restore them to their inline homes.
  function placeFilters(){
    var instock = $('cs-instock-lbl'), sort = $('cs-sort-dd'),
        finish = $('cs-finish-dd'), cond = $('cs-cond-dd'), price = $('cs-price-el'),
        setb = $('cs-setbrowse-btn');
    if (isMobile()){
      var host = $('cs-mfilters');
      // Sets joins the drawer: it's a browse aid rather than something you toggle
      // mid-search, and the row only has space for the controls worth a permanent slot.
      if (host) [setb, sort, finish, cond, price].forEach(function(el){ if (el) host.appendChild(el); });
      /* In stock does NOT go in the drawer. It is the filter most likely to be the
         reason a page looks empty, and hiding it behind "Filters" turned that into a
         dead end on a phone. It sits in the filters row instead, styled as a pill —
         always visible, always one tap, and it covers nothing. */
      var cfm = $('cs-filters');
      if (cfm && instock){
        var acts = cfm.querySelector('.cs-bar-actions');   // menu/account/cart move here on mobile
        if (acts) cfm.insertBefore(instock, acts); else cfm.appendChild(instock);
      }
    } else {
      var form = $('cs-form'), go = $('cs-go');
      if (form && instock && go) form.insertBefore(instock, go);
      var sortHome = $('cs-sort-home');
      if (sortHome && sort) sortHome.appendChild(sort);
      var cf = $('cs-filters');
      // setb first — it sits next to the Filters toggle in the row's resting order.
      if (cf){ [setb, finish, cond, price].forEach(function(el){ if (el) cf.appendChild(el); }); }
    }
  }
  function render(){
    // Results may have arrived for a different game than the panel is built for (e.g.
    // a Pokémon card searched from "All") — reflect that in the controls before drawing.
    if (typeof updateSetBrowseVisibility === 'function') updateSetBrowseVisibility();
    updateCounts();
    updateFacetToggle();
    updateFacetBadges();
    renderChips();
    var box = $('cs-results'); box.innerHTML = '';
    // Recomputed from scratch each render, so re-ticking a condition immediately
    // stops the relaxation instead of leaving it latched on.
    RELAX_CLIENT = [];
    var f = activeFilters();
    // Format ban filtering needs the ban lists; if a Format is active but they
    // haven't loaded yet (or an earlier load failed), kick a deduped (re)load.
    if (facetState['Format'] && !BANLISTS_LOADED) loadBanlists();
    // cardPassesFacets depends only on facetState (not on f), so evaluate it once
    // per render and cache it — the render path below reads it several times per card.
    cards.forEach(function(c){ c._pass = cardPassesFacets(c); });
    var view = sortCards(cards, f);
    // Ordered list of the cards actually on screen — drives detail-modal arrow
    // navigation and the mobile combined cart sheet (swipe = next/prev card).
    var visibleIn = function(list, ff){
      return list.filter(function(c){
        if (!c._pass) return false;
        return c.kind === 'product' ? productVisible(c, ff) : c.rows.some(function(r){ return rowVisible(r, ff); });
      });
    };
    navList = visibleIn(view, f);
    /* The server returned rows but every one is hidden by a client-side filter, leaving
     * a blank grid under a non-zero result count.
     *
     * Deliberately does NOT include in-stock. That filter is applied SERVER-side too, so
     * the rows we hold are already only the in-stock ones — un-hiding them would
     * "succeed" with whatever thin fuzzy match happened to have stock ("Windswept Heath"
     * → the one in-stock "Adagia, Windswept Bastion") and, worse, would suppress the
     * refetch in checkWidenNeeded that actually surfaces the card. In-stock is widened
     * by re-querying, not by un-hiding.
     *
     * Bounded by the ladder length, so it terminates. */
    var CLIENT_LADDER = ['price', 'conds', 'finish'];
    while (cards.length && !navList.length && RELAX_CLIENT.length < CLIENT_LADDER.length){
      RELAX_CLIENT.push(CLIENT_LADDER[RELAX_CLIENT.length]);
      f = activeFilters();
      navList = visibleIn(view, f);
    }
    // Widening produced nothing visible after all — say nothing rather than advertise
    // a broadened search above an empty grid.
    renderRelaxBanner(navList.length > 0);
    decideView(view);
    updateFilterVisibility();
    applySellUi();
    syncUrl();
    if (sellMode()){ renderSellView(box, view); return; }
    if (viewMode === 'grid'){ renderGrid(box, f, view); return; }
    showCondNotice(f);
    if (isMobile()){ renderMobileList(box, f, view); }
    else { renderTable(box, f, view); }
    renderProductRows(box, f, view);   // sealed / accessories / board games, below the singles
  }
  // Auto-pick the view unless the user toggled it: grid for a chosen product
  // category, or when the (filtered) result set is mostly non-single products.
  function countKinds(view){
    var p = 0, s = 0;
    view.forEach(function(c){ if (!c._pass) return; if (c.kind === 'product') p++; else s++; });
    return { product:p, single:s };
  }
  // The all-products Shop browse: no search term and no specific category chosen
  // (PAGE.browse is set by loadDefault). Drives grid-default + non-singles-first.
  function isBrowseAll(){ return !!(typeof PAGE !== 'undefined' && PAGE && PAGE.browse) && selGames.size === 0 && selTypes.size === 0 && !($('cs-q') && $('cs-q').value.trim()); }
  function decideView(view){
    if (viewMode === 'sell') return;   // Sell is a mode, never auto-selected or auto-left
    if (viewExplicit) return;
    if (isProductCat()){ viewMode = 'grid'; return; }
    if (selTypes.has('singles')){ viewMode = 'list'; return; }  // a pure singles browse reads best as a list
    if (isBrowseAll()){ viewMode = 'grid'; return; }  // Shop landing → grid, non-singles first
    var k = countKinds(view);
    viewMode = (k.product > k.single) ? 'grid' : 'list';
  }
  // Toggle active state + hide single-only controls (finish/condition) when the
  // result set has no singles, and suppress the condition notice in grid view.
  function updateFilterVisibility(){
    Array.prototype.forEach.call(document.querySelectorAll('#cs-view-toggle .cs-vt-btn'), function(b){
      b.classList.toggle('active', b.dataset.view === viewMode);
    });
    var hasSingle = cards.some(function(c){ return c.kind === 'single'; });
    var cond = $('cs-cond-dd'); if (cond) cond.style.display = hasSingle ? '' : 'none';
    if (!hasSingle){ var fin = $('cs-finish-dd'); if (fin) fin.style.display = 'none'; }
    if (viewMode === 'grid'){ $('cs-cond-notice').style.display = 'none'; }
  }
  // Notice when in-stock copies exist in hidden conditions (HP / Damaged off by default)
  function showCondNotice(f){
    var host = $('cs-cond-notice');
    var hidden = COLS.filter(function(c){ return (c.code==='HP' || c.code==='DMG') && !f.conds.has(c.code); });
    if (!hidden.length){ host.style.display = 'none'; return; }
    var n = 0;
    cards.forEach(function(card){
      if (!card._pass) return;
      var hit = card.rows.some(function(row){ return hidden.some(function(c){ var cell = row.cells[c.code]; return cell && cellVisible(cell, f); }); });
      if (hit) n++;
    });
    if (!n){ host.style.display = 'none'; return; }
    host.style.display = 'flex';
    var labels = hidden.map(function(c){ return c.label; }).join(' / ');
    host.innerHTML = '<span>' + n + ' card' + (n!==1?'s':'') + ' also have copies in <strong>' + labels + '</strong>.</span>' +
      '<button type="button" id="cs-cond-show">Show ' + (hidden.length>1?'these':'this') + '</button>';
    $('cs-cond-show').onclick = function(){
      hidden.forEach(function(c){
        var cb = document.querySelector('#cs-cond-menu input[value="' + c.code + '"]'); if (cb) cb.checked = true;
      });
      render();
    };
  }
  function renderTable(box, f, list){
    var visibleCols = f.conds.size ? COLS.filter(function(c){ return f.conds.has(c.code); }) : COLS.slice();
    var shown = 0;

    var table = document.createElement('table');
    table.style.cssText = 'width:100%;border-collapse:separate;border-spacing:0;font-family:var(--font-body,sans-serif)';

    var thead = document.createElement('thead');
    var hr = document.createElement('tr');
    function th(txt, extra, tip){
      var el = document.createElement('th');
      el.textContent = txt;
      if (tip){
        el.addEventListener('mouseenter', function(){ showTip(el, tip); });
        el.addEventListener('mouseleave', hideTip);
      }
      el.style.cssText = 'text-align:left;font-family:var(--font-display,sans-serif);font-size:.7rem;letter-spacing:.06em;text-transform:uppercase;color:#8A8378;padding:.5rem .75rem;border-bottom:2px solid rgba(28,23,18,.1);white-space:nowrap;' + (extra||'');
      return el;
    }
    hr.appendChild(th('Card'));
    hr.appendChild(th('Finish'));
    visibleCols.forEach(function(c){ hr.appendChild(th(c.code, 'text-align:center;cursor:help;text-decoration:underline dotted rgba(138,131,120,.6);text-underline-offset:3px', c.label)); });
    hr.appendChild(th(''));
    thead.appendChild(hr); table.appendChild(thead);

    var tbody = document.createElement('tbody');

    // Group visible printings by card name. A name with 2+ printings collapses into
    // one expandable parent row (default-on); single-printing names render flat.
    var groups = [], byName = {};
    (list || cards).forEach(function(card){
      if (!card._pass) return;
      var vrows = card.rows.filter(function(r){ return rowVisible(r, f); });
      if (!vrows.length) return;
      card._vrows = vrows;
      var base = baseName(card.name), key = base.toLowerCase();
      if (byName[key] == null){ byName[key] = groups.length; groups.push({ name: base, cards: [] }); }
      groups[byName[key]].cards.push(card);
    });
    // In-stock printings first within each card (stable) so buyable copies aren't buried under OOS.
    groups.forEach(function(g){ g.cards.sort(function(a,b){ return (firstBuyableCell(b)?1:0) - (firstBuyableCell(a)?1:0); }); });
    shown = groups.length;

    // Aggregate a group's visible cells → total qty, price range, cheapest printing.
    function groupSummary(g){
      var qty = 0, prices = [], cheapCard = g.cards[0], cheap = Infinity;
      g.cards.forEach(function(card){
        card._vrows.forEach(function(row){
          visibleCols.forEach(function(c){
            var cell = row.cells[c.code];
            if (cell && cellVisible(cell, f)){
              qty += cell.qty;
              // Range + cheapest reflect only BUYABLE (in-stock) cells — never OOS market/last
              // prices — so "$X–$Y" is what a customer can actually purchase (— when none in stock).
              if (cell.qty > 0 && cell.price != null){ prices.push(cell.price); if (cell.price < cheap){ cheap = cell.price; cheapCard = card; } }
            }
          });
        });
      });
      return { qty: qty, lo: prices.length ? Math.min.apply(null, prices) : null, hi: prices.length ? Math.max.apply(null, prices) : null, cheapCard: cheapCard, count: g.cards.length };
    }

    // Summary row for a multi-printing card; tap toggles its child rows. Groups open
    // EXPANDED — a shopper searching a card wants to see which printings we actually
    // have, and one extra click per card to reach that was pure friction.
    function appendGroupParent(g, groupId){
      var s = groupSummary(g);
      var tr = document.createElement('tr');
      tr.style.cssText = 'border-bottom:1px solid rgba(28,23,18,.09);cursor:pointer;background:rgba(216,164,60,.05)';
      var td = document.createElement('td');
      td.colSpan = visibleCols.length + 3;
      td.style.cssText = 'padding:.6rem .75rem';
      var wrap = document.createElement('div');
      wrap.style.cssText = 'display:flex;align-items:center;gap:.7rem';
      var chev = document.createElement('span');
      chev.textContent = '▸';
      chev.style.cssText = 'color:#8A8378;font-size:.9rem;transition:transform .15s;flex-shrink:0;width:.9rem;text-align:center';
      wrap.appendChild(chev);
      if (s.cheapCard && s.cheapCard.image){
        var img = document.createElement('img');
        img.src = s.cheapCard.image; img.alt = g.name; img.loading = 'lazy';
        img.style.cssText = 'width:54px;height:76px;object-fit:cover;border-radius:5px;flex-shrink:0;box-shadow:0 1px 4px rgba(0,0,0,.2)';
        wrap.appendChild(img);
      }
      var mid = document.createElement('div'); mid.style.cssText = 'flex:1;min-width:0';
      var nm = document.createElement('div');
      nm.textContent = g.name;
      nm.style.cssText = 'font-family:var(--font-display,sans-serif);font-weight:700;font-size:.92rem;color:#1C1712;line-height:1.15';
      var sub = document.createElement('div');
      sub.textContent = s.count + ' printings' + (s.qty ? ' · ' + s.qty + ' in stock' : '');
      sub.style.cssText = 'font-size:.78rem;color:#8A8378;margin-top:1px';
      mid.appendChild(nm); mid.appendChild(sub);
      wrap.appendChild(mid);
      var pr = document.createElement('div');
      pr.textContent = s.lo == null ? '—' : (s.lo === s.hi ? fmt(s.lo) : fmt(s.lo) + '–' + fmt(s.hi));
      pr.style.cssText = 'font-weight:700;font-size:.9rem;color:#1C1712;white-space:nowrap;margin-right:.5rem';
      wrap.appendChild(pr);
      var exp = document.createElement('span');
      exp.textContent = 'Hide ' + s.count + ' \u25B4';
      exp.style.cssText = 'font-size:.78rem;font-weight:700;color:#9a7517;white-space:nowrap';
      wrap.appendChild(exp);
      // Match the expanded children below; the click handler toggles from here.
      tr.classList.add('open');
      chev.style.transform = 'rotate(90deg)';
      // Workbench: add the card to the deck straight from the collapsed row (no need
      // to expand); the printings inside are for buying a specific one.
      if (EMBED && EMBED_CB){
        var inDk = EMBED_CB.isInDeck && EMBED_CB.isInDeck(g.name);
        var addBtn = actionBtn(inDk ? '✓ In deck' : '+ Add', function(){}, true);
        addBtn.disabled = inDk; addBtn.style.marginLeft = '.5rem';
        addBtn.onclick = function(e){ e.stopPropagation(); if (EMBED_CB.onAdd) EMBED_CB.onAdd(s.cheapCard); addBtn.textContent = '✓ In deck'; addBtn.disabled = true; };
        wrap.appendChild(addBtn);
      }
      td.appendChild(wrap); tr.appendChild(td);
      tr.onclick = function(){
        var open = tr.classList.toggle('open');
        chev.style.transform = open ? 'rotate(90deg)' : '';
        exp.textContent = (open ? 'Hide ' : 'Show ') + s.count + (open ? ' ▴' : ' ▾');
        Array.prototype.forEach.call(tbody.querySelectorAll('.cs-grp-' + groupId), function(r){ r.style.display = open ? '' : 'none'; });
      };
      tbody.appendChild(tr);
    }

    // Render one printing's finish/condition rows. groupId>0 → child rows toggled by
    // their parent, keyed off the printing's set instead of the name. Visible from the
    // start; the parent renders itself in the matching open state.
    function appendPrintingRows(card, groupId){
      card._vrows.forEach(function(row, ri){
        var tr = document.createElement('tr');
        tr.style.cssText = 'border-bottom:1px solid rgba(28,23,18,.07)';
        if (groupId){ tr.className = 'cs-grp-' + groupId; }

        var cardCell = document.createElement('td');
        cardCell.style.cssText = 'padding:.6rem .75rem;vertical-align:middle;min-width:220px' + (groupId ? ';padding-left:1.5rem;box-shadow:inset 3px 0 0 rgba(216,164,60,.4)' : '');
        if (ri === 0){
          var wrap = document.createElement('div');
          wrap.style.cssText = 'display:flex;align-items:center;gap:.7rem';
          if (card.image){
            var iw = document.createElement('div'); iw.style.cssText = 'position:relative;flex-shrink:0;width:54px;height:76px';
            var img = document.createElement('img');
            img.src = card.image; img.alt = card.name; img.loading = 'lazy';
            img.style.cssText = 'width:54px;height:76px;object-fit:cover;border-radius:5px;cursor:pointer;display:block;box-shadow:0 1px 4px rgba(0,0,0,.2)';
            img.onclick = function(){ openCart(card); };
            iw.appendChild(img); attachFlip(iw, img, card, true);
            wrap.appendChild(iw);
          }
          // In a group the name is on the parent; lead the child with its treatment
          // (art-variant suffix, e.g. "Rainbow Foil"), falling back to the set. Prefer the
          // canonical facet over the title suffix so a child reads the same words the
          // filters and the sell list use.
          var treatList = cardTreatments(card);
          var treat = (treatList.length ? treatList.join(' · ') : '')
            || card.flavorName || card.name.slice(baseName(card.name).length).trim().replace(/^\(([^()]*)\)$/, '$1');
          var txt = document.createElement('div');
          var nm = document.createElement('div');
          // Ungrouped rows carry the bare card name, so append the treatment there too —
          // otherwise "Toxic Deluge" appears eight times with nothing to tell the
          // printings apart until you open one.
          nm.className = 'cs-rowname';   // carries the treatment spacing/case rule
          /* GROUPED CHILD ROWS NEED THE LANGUAGE TOO, and they are the rows that need it MOST.
           * A group is one card's printings stacked together — the name is already on the parent,
           * so each child reads as its treatment ("Showcase · Full Art") and the printings are
           * distinguished by that line alone. Two children differing only by language would be
           * indistinguishable, which is precisely the case a shopper has to be able to see.
           * The chip is appended, not spliced into `treat`, so the treatment text stays the
           * treatment text. */
          if (groupId) nm.innerHTML = escHtml(treat || card.set || card.name) + cardLangHtml(card);
          else nm.innerHTML = escHtml(dispName(card)) + cardLangHtml(card) + cardTreatHtml(card, null, soleVisibleFinish(card._vrows));
          nm.style.cssText = 'font-family:var(--font-display,sans-serif);font-weight:700;font-size:.92rem;color:#1C1712;cursor:pointer;line-height:1.15';
          nm.onclick = function(){ openCart(card); };
          var st = document.createElement('div');
          st.textContent = groupId ? (treat ? (card.set + (card.number ? ' · #' + card.number : '')) : (card.number ? '#' + card.number : '')) : card.set;
          st.style.cssText = 'font-size:.78rem;color:#8A8378;margin-top:1px';
          txt.appendChild(nm); txt.appendChild(st); wrap.appendChild(txt);
          cardCell.appendChild(wrap);
        }
        tr.appendChild(cardCell);

        var finCell = document.createElement('td');
        finCell.style.cssText = 'padding:.6rem .75rem;vertical-align:middle';
        var badge = document.createElement('span');
        badge.textContent = row.finish.label;
        var foilStyle = row.finish.foil
          ? 'background:linear-gradient(90deg,#fde68a,#fca5f1,#a5f3fc);color:#1C1712'
          : 'background:rgba(28,23,18,.07);color:#5b5448';
        badge.style.cssText = 'display:inline-block;font-size:.68rem;font-weight:700;letter-spacing:.04em;text-transform:uppercase;padding:3px 9px;border-radius:999px;white-space:nowrap;' + foilStyle;
        finCell.appendChild(badge);
        tr.appendChild(finCell);

        visibleCols.forEach(function(c){
          var td = document.createElement('td');
          td.style.cssText = 'padding:.5rem .75rem;text-align:center;vertical-align:middle';
          var cell = row.cells[c.code];
          if (cell && cellVisible(cell, f)){
            td.appendChild(buildCell(card, row, c, cell));
          } else {
            td.innerHTML = '<span style="color:rgba(28,23,18,.2)">·</span>';
          }
          tr.appendChild(td);
        });

        var act = document.createElement('td');
        act.style.cssText = 'padding:.5rem .75rem;text-align:right;white-space:nowrap';
        if (ri === 0){
          if (EMBED && EMBED_CB){
            if (groupId){
              // A specific printing under a multi-printing card → add THAT printing to the deck.
              var inDp = EMBED_CB.isInDeck && EMBED_CB.isInDeck(card.name);
              var pAdd = actionBtn(inDp ? '✓' : '+ Add', function(){ if (EMBED_CB.onAdd) EMBED_CB.onAdd(card); pAdd.textContent = '✓'; }, false);
              act.appendChild(pAdd);
            } else {
              // Single-printing card → add the card to the deck.
              var inDk = EMBED_CB.isInDeck && EMBED_CB.isInDeck(card.name);
              var addBtn = actionBtn(inDk ? '✓ In deck' : '+ Add', function(){ if (EMBED_CB.onAdd) EMBED_CB.onAdd(card); addBtn.textContent = '✓ In deck'; addBtn.disabled = true; }, true);
              addBtn.disabled = inDk;
              act.appendChild(addBtn);
            }
          } else {
            // In stock → Buy; fully out of stock → Save (wishlist / restock alert),
            // since there's nothing to add to the cart.
            var sv = firstBuyableCell(card) ? null : saveBtn(card);
            if (sv) act.appendChild(sv);
            else act.appendChild(actionBtn('Buy', function(){ openCart(card); }, true));
            act.appendChild(actionBtn('Sell', function(){ openSell(card); }, false));
          }
        }
        tr.appendChild(act);

        tbody.appendChild(tr);
      });
    }

    var gid = 0;
    groups.forEach(function(g){
      if (g.cards.length >= 2){ gid++; appendGroupParent(g, gid); g.cards.forEach(function(card){ appendPrintingRows(card, gid); }); }
      else { appendPrintingRows(g.cards[0], 0); }
    });
    table.appendChild(tbody);
    box.appendChild(table);

    $('cs-status').textContent = cards.length ? (shown + ' card' + (shown!==1?'s':'') + ' shown') : '';
    if (cards.length && !shown){ box.innerHTML = '<div style="padding:1.5rem 0;text-align:center;color:#8A8378">No results match your filters.</div>'; noResultsFilters(box); }
  }

  // ── Mobile: collapse condition columns into a tappable summary row ──
  function renderMobileList(box, f, view){
    var visCols = COLS.filter(function(c){ return f.conds.has(c.code); });
    var shown = 0;
    var list = document.createElement('div');

    // Group visible printings by name; 2+ printings collapse under a tappable parent.
    var groups = [], byName = {};
    (view || cards).forEach(function(card){
      if (!card._pass) return;
      var vrows = card.rows.filter(function(r){ return rowVisible(r, f); });
      if (!vrows.length) return;
      card._mrows = vrows;
      var base = baseName(card.name), key = base.toLowerCase();
      if (byName[key] == null){ byName[key] = groups.length; groups.push({ name: base, cards: [] }); }
      groups[byName[key]].cards.push(card);
    });
    // In-stock printings first within each card (stable) so buyable copies aren't buried under OOS.
    groups.forEach(function(g){ g.cards.sort(function(a,b){ return (firstBuyableCell(b)?1:0) - (firstBuyableCell(a)?1:0); }); });
    shown = groups.length;

    // One tappable row for a single printing-finish. groupId>0 → child of a parent,
    // labelled by set instead of name (the name is on the parent). Visible from the
    // start, matching the desktop table.
    function buildItem(card, row, groupId){
      var qs = [], ps = [];
      visCols.forEach(function(c){ var cell = row.cells[c.code]; if (cell && cellVisible(cell, f)){ qs.push(cell.qty); ps.push(cell.price); } });
      if (!ps.length) return null;
      var totalQty = qs.reduce(function(a,b){ return a+b; }, 0);
      var lo = Math.min.apply(null, ps), hi = Math.max.apply(null, ps);

      var item = document.createElement('div');
      item.style.cssText = 'display:flex;align-items:center;gap:.7rem;padding:.7rem .25rem;border-bottom:1px solid rgba(28,23,18,.08);cursor:pointer' + (groupId ? ';padding-left:1rem;box-shadow:inset 3px 0 0 rgba(216,164,60,.4)' : '');
      if (groupId){ item.className = 'cs-mgrp-' + groupId; }
      item.onclick = function(){ openCart(card); };

      if (card.image){
        var img = document.createElement('img');
        img.src = card.image; img.alt = card.name; img.loading = 'lazy';
        img.style.cssText = 'width:48px;height:67px;object-fit:cover;border-radius:5px;flex-shrink:0;box-shadow:0 1px 4px rgba(0,0,0,.2)';
        item.appendChild(img);
      }

      var treat = card.flavorName || card.name.slice(baseName(card.name).length).trim().replace(/^\(([^()]*)\)$/, '$1');
      var mid = document.createElement('div');
      mid.style.cssText = 'flex:1;min-width:0';
      var nm = document.createElement('div');
      nm.textContent = groupId ? (treat || card.set || card.name) : dispName(card);
      nm.style.cssText = 'font-family:var(--font-display,sans-serif);font-weight:700;font-size:.92rem;color:#1C1712;line-height:1.15;white-space:nowrap;overflow:hidden;text-overflow:ellipsis';
      var sub = document.createElement('div');
      sub.style.cssText = 'display:flex;align-items:center;gap:.4rem;margin-top:2px';
      var st = document.createElement('span');
      st.textContent = groupId ? (treat ? (card.set + (card.number ? ' · #' + card.number : '')) : (card.number ? '#' + card.number : '')) : card.set;
      st.style.cssText = 'font-size:.75rem;color:#8A8378;white-space:nowrap;overflow:hidden;text-overflow:ellipsis';
      var badge = document.createElement('span');
      badge.textContent = row.finish.label;
      var foilStyle = row.finish.foil ? 'background:linear-gradient(90deg,#fde68a,#fca5f1,#a5f3fc);color:#1C1712' : 'background:rgba(28,23,18,.07);color:#5b5448';
      badge.style.cssText = 'flex-shrink:0;font-size:.62rem;font-weight:700;letter-spacing:.04em;text-transform:uppercase;padding:2px 7px;border-radius:999px;' + foilStyle;
      sub.appendChild(st); sub.appendChild(badge);
      /* Language rides in the SUB line on mobile, not the name line: the name is clamped with
       * text-overflow:ellipsis, so a chip appended there is the first thing a narrow screen throws
       * away — and this is the one surface where a phone in the shop is the whole audience. Sits
       * beside the finish badge, which is the same kind of fact. */
      var mLang = cardLangName(card);
      if (mLang){
        var lb = document.createElement('span');
        lb.className = 'ttt-lang';
        lb.textContent = mLang;
        lb.style.cssText = 'flex-shrink:0;font-size:.62rem;font-weight:700;letter-spacing:.04em;'
          + 'text-transform:uppercase;padding:2px 7px;border-radius:999px;'
          + 'background:rgba(49,78,120,.12);color:#31527A';
        sub.appendChild(lb);
      }
      mid.appendChild(nm); mid.appendChild(sub);
      item.appendChild(mid);

      var right = document.createElement('div');
      right.style.cssText = 'text-align:right;flex-shrink:0;display:flex;flex-direction:column;align-items:flex-end;gap:1px';
      var pr = document.createElement('div');
      pr.textContent = totalQty <= 0 ? '—' : (lo === hi ? fmt(lo) : fmt(lo) + '–' + fmt(hi));
      pr.style.cssText = 'font-weight:700;font-size:.9rem;color:#1C1712;white-space:nowrap';
      var qt = document.createElement('div');
      qt.textContent = totalQty + ' in stock';
      qt.style.cssText = 'font-size:.72rem;color:#8A8378;white-space:nowrap';
      right.appendChild(pr); right.appendChild(qt);
      item.appendChild(right);

      var chev = document.createElement('span');
      chev.textContent = '›';
      chev.style.cssText = 'color:#c9c2b5;font-size:1.3rem;flex-shrink:0;margin-left:.1rem';
      item.appendChild(chev);
      return item;
    }

    // Collapsed summary row for a card with multiple printings; tap toggles children.
    function buildParent(g, groupId){
      var qty = 0, prices = [], cheapCard = g.cards[0], cheap = Infinity;
      g.cards.forEach(function(card){
        card._mrows.forEach(function(row){
          visCols.forEach(function(c){ var cell = row.cells[c.code]; if (cell && cellVisible(cell, f)){ qty += cell.qty; if (cell.qty > 0 && cell.price != null){ prices.push(cell.price); if (cell.price < cheap){ cheap = cell.price; cheapCard = card; } } } });
        });
      });
      var lo = prices.length ? Math.min.apply(null, prices) : null, hi = prices.length ? Math.max.apply(null, prices) : null;

      var item = document.createElement('div');
      item.style.cssText = 'display:flex;align-items:center;gap:.7rem;padding:.7rem .25rem;border-bottom:1px solid rgba(28,23,18,.09);cursor:pointer;background:rgba(216,164,60,.05)';
      if (cheapCard && cheapCard.image){
        var img = document.createElement('img');
        img.src = cheapCard.image; img.alt = g.name; img.loading = 'lazy';
        img.style.cssText = 'width:48px;height:67px;object-fit:cover;border-radius:5px;flex-shrink:0;box-shadow:0 1px 4px rgba(0,0,0,.2)';
        item.appendChild(img);
      }
      var mid = document.createElement('div'); mid.style.cssText = 'flex:1;min-width:0';
      var nm = document.createElement('div');
      nm.textContent = g.name;
      nm.style.cssText = 'font-family:var(--font-display,sans-serif);font-weight:700;font-size:.92rem;color:#1C1712;line-height:1.15;white-space:nowrap;overflow:hidden;text-overflow:ellipsis';
      var sub = document.createElement('div');
      sub.textContent = g.cards.length + ' printings' + (qty ? ' · ' + qty + ' in stock' : '');
      sub.style.cssText = 'font-size:.75rem;color:#8A8378;margin-top:2px';
      mid.appendChild(nm); mid.appendChild(sub);
      item.appendChild(mid);
      var right = document.createElement('div');
      right.style.cssText = 'text-align:right;flex-shrink:0;display:flex;flex-direction:column;align-items:flex-end;gap:1px';
      var pr = document.createElement('div');
      pr.textContent = qty <= 0 ? '—' : (lo === hi ? fmt(lo) : fmt(lo) + '–' + fmt(hi));
      pr.style.cssText = 'font-weight:700;font-size:.9rem;color:#1C1712;white-space:nowrap';
      var exp = document.createElement('div');
      exp.textContent = 'Hide ' + g.cards.length;
      exp.style.cssText = 'font-size:.72rem;font-weight:700;color:#9a7517;white-space:nowrap';
      right.appendChild(pr); right.appendChild(exp);
      item.appendChild(right);
      var chev = document.createElement('span');
      chev.textContent = '▸';
      chev.style.cssText = 'color:#8A8378;font-size:1rem;flex-shrink:0;margin-left:.1rem;transition:transform .15s';
      item.appendChild(chev);
      // Open to match the expanded children; the click handler toggles from here.
      item.classList.add('open');
      chev.style.transform = 'rotate(90deg)';
      item.onclick = function(){
        var open = item.classList.toggle('open');
        chev.style.transform = open ? 'rotate(90deg)' : '';
        exp.textContent = (open ? 'Hide ' : 'Show ') + g.cards.length;
        Array.prototype.forEach.call(list.querySelectorAll('.cs-mgrp-' + groupId), function(r){ r.style.display = open ? '' : 'none'; });
      };
      return item;
    }

    var gid = 0;
    groups.forEach(function(g){
      if (g.cards.length >= 2){
        gid++;
        list.appendChild(buildParent(g, gid));
        g.cards.forEach(function(card){ card._mrows.forEach(function(row){ var it = buildItem(card, row, gid); if (it) list.appendChild(it); }); });
      } else {
        var card = g.cards[0];
        card._mrows.forEach(function(row){ var it = buildItem(card, row, 0); if (it) list.appendChild(it); });
      }
    });
    box.appendChild(list);
    $('cs-status').textContent = cards.length ? (shown + ' result' + (shown!==1?'s':'')) : '';
    if (cards.length && !shown){ box.innerHTML = '<div style="padding:1.5rem 0;text-align:center;color:#8A8378">No results match your filters.</div>'; noResultsFilters(box); }
  }

  // ── Grid view (squares for singles + products) ──
  function cartPlusIcon(){
    return '<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" style="margin-right:1px"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
  }
  function productVisible(card, f){
    if (!isNaN(f.pmin) && card.priceHi && card.priceHi < f.pmin) return false;
    if (!isNaN(f.pmax) && card.priceLo && card.priceLo > f.pmax) return false;
    // in-stock filter hides buyable-but-sold-out items; in-store-only (reserve) items
    // have no online stock signal and are always shown for discovery.
    if (f.instock && !card.noPrice && card.totalQty <= 0) return false;
    return true;
  }
  function buyableVariants(card){
    return (card.variants || []).filter(function(v){ return v.price > 0 && (v.qty > 0 || v.available); });
  }
  function singleVisibleSummary(card, f){
    var ps = [], qs = 0, anyFoil = false;
    card.rows.forEach(function(r){
      if (!f.finishes.has(r.finish.key)) return;
      var rowHit = false;
      COLS.forEach(function(c){
        if (!f.conds.has(c.code)) return;
        var cell = r.cells[c.code];
        if (cell && cellVisible(cell, f)){ ps.push(cell.price); qs += cell.qty; rowHit = true; }
      });
      if (rowHit && r.finish.foil) anyFoil = true;
    });
    return { prices: ps, qty: qs, foil: anyFoil };
  }
  function tileImg(card, contain){
    var wrap = document.createElement('div');
    wrap.className = 'cs-tile-img' + (contain ? ' cs-contain' : '');
    if (card.image){
      var img = document.createElement('img');
      img.src = card.image; img.alt = card.name; img.loading = 'lazy';
      wrap.appendChild(img);
      attachFlip(wrap, img, card);
    } else {
      // The game's card back rather than a bare label — card-shaped, so a printing
      // with no art on file occupies the same space as one that has it.
      wrap.appendChild(TTT.cardPlaceholder(card.productType, { name: card.name, sub: card.set || '' }));
    }
    return wrap;
  }
  function buildSingleTile(card, f){
    var s = singleVisibleSummary(card, f);
    var tile = document.createElement('div'); tile.className = 'cs-tile';
    tile.onclick = function(){ openCart(card); };
    var imgwrap = tileImg(card, true);
    if (s.foil){ var fb = document.createElement('span'); fb.className = 'cs-tag cs-tag-foil cs-tag-corner'; fb.textContent = 'Foil'; imgwrap.appendChild(fb); }
    tile.appendChild(imgwrap);
    var body = document.createElement('div'); body.className = 'cs-tile-body';
    var nm = document.createElement('div'); nm.className = 'cs-tile-name'; nm.textContent = dispName(card); body.appendChild(nm);
    if (card.set){ var sub = document.createElement('div'); sub.className = 'cs-tile-sub'; sub.textContent = card.set; body.appendChild(sub); }
    // Treatment sits under the set, where it reads as another fact about the printing.
    // Capped at 2 here (unlike the list row): a tile is one of seven across, and its name
    // already clamps to two lines, so there genuinely isn't room — the rest stays on hover.
    var tTreat = cardLangHtml(card) + cardTreatHtml(card, 2, soleVisibleFinish(card.rows.filter(function(r){ return rowVisible(r, f); })));
    if (tTreat){ var tt = document.createElement('div'); tt.className = 'cs-tile-treat'; tt.innerHTML = tTreat; body.appendChild(tt); }
    if (s.qty){ var q = document.createElement('div'); q.className = 'cs-tile-qty'; q.textContent = s.qty + ' in stock'; body.appendChild(q); }
    var foot = document.createElement('div'); foot.className = 'cs-tile-foot';
    var pr = document.createElement('div'); pr.className = 'cs-tile-price';
    if (s.qty > 0 && s.prices.length){ var lo = Math.min.apply(null, s.prices), hi = Math.max.apply(null, s.prices); pr.textContent = lo === hi ? fmt(lo) : fmt(lo) + '–' + fmt(hi); }
    else pr.textContent = '—';
    var view = document.createElement('button'); view.className = 'cs-tile-add'; view.textContent = 'View';
    view.onclick = function(e){ e.stopPropagation(); openCart(card); };
    foot.appendChild(pr); foot.appendChild(view);
    body.appendChild(foot); tile.appendChild(body);
    if (EMBED && EMBED_CB){
      var inD = EMBED_CB.isInDeck && EMBED_CB.isInDeck(card.name);
      var plus = document.createElement('button');
      plus.type = 'button'; plus.className = 'cs-tile-plus' + (inD ? ' in' : '');
      plus.textContent = inD ? '✓' : '+'; plus.title = inD ? 'In your deck' : 'Add to deck';
      plus.onclick = function(e){ e.stopPropagation(); if (EMBED_CB.onAdd) EMBED_CB.onAdd(card); plus.textContent = '✓'; plus.className = 'cs-tile-plus in'; plus.title = 'In your deck'; };
      imgwrap.appendChild(plus);
    }
    return tile;
  }
  // Pre-order products are flagged with a `preorder` tag (same signal the shop carousel uses).
  function isPreorder(card){ return (card.tags || []).some(function(t){ return String(t).toLowerCase() === 'preorder'; }); }
  function buildProductTile(card, f){
    var tile = document.createElement('div'); tile.className = 'cs-tile';
    tile.onclick = function(){ openProductDetail(card); };
    var imgwrap = tileImg(card, false);
    if (isPreorder(card)){ var pb = document.createElement('span'); pb.className = 'cs-tag cs-tag-preorder cs-tag-corner'; pb.textContent = 'Pre-order'; imgwrap.appendChild(pb); }
    else if (card.noPrice){ var b = document.createElement('span'); b.className = 'cs-tag cs-tag-instore cs-tag-corner'; b.textContent = 'In-store only'; imgwrap.appendChild(b); }
    tile.appendChild(imgwrap);
    var body = document.createElement('div'); body.className = 'cs-tile-body';
    var nm = document.createElement('div'); nm.className = 'cs-tile-name'; nm.textContent = card.name; body.appendChild(nm);
    var subtxt = card.vendor || card.productType;
    if (subtxt){ var sub = document.createElement('div'); sub.className = 'cs-tile-sub'; sub.textContent = subtxt; body.appendChild(sub); }
    if (!card.noPrice && card.totalQty){ var q = document.createElement('div'); q.className = 'cs-tile-qty'; q.textContent = card.totalQty + ' in stock'; body.appendChild(q); }
    var foot = document.createElement('div'); foot.className = 'cs-tile-foot';
    if (card.noPrice){
      foot.style.justifyContent = 'flex-end';
      var rsv = document.createElement('button'); rsv.className = 'cs-tile-reserve'; rsv.textContent = 'Ask in store';
      rsv.onclick = function(e){ e.stopPropagation(); openProductDetail(card); };
      foot.appendChild(rsv);
    } else {
      var pr = document.createElement('div'); pr.className = 'cs-tile-price';
      pr.textContent = card.priceLo === card.priceHi ? fmt(card.priceHi) : fmt(card.priceLo) + '–' + fmt(card.priceHi);
      var add = document.createElement('button'); add.className = 'cs-tile-add';
      add.innerHTML = cartPlusIcon() + 'Add';
      add.onclick = function(e){ e.stopPropagation(); quickAddProduct(card, add); };
      foot.appendChild(pr); foot.appendChild(add);
    }
    body.appendChild(foot); tile.appendChild(body);
    return tile;
  }
  // Single buyable variant → add straight to cart; multiple → open the modal to choose.
  function quickAddProduct(card, btn){
    var buyable = buyableVariants(card);
    if (buyable.length !== 1){ openProductDetail(card); return; }
    if (btn.dataset.loading) return;
    btn.dataset.loading = '1';
    var prev = btn.innerHTML;
    btn.innerHTML = '<span class="cs-spinner" style="width:11px;height:11px;border-width:2px;border-color:rgba(28,23,18,.4);border-top-color:#1C1712"></span>';
    addToCart([{ id: buyable[0].variantId, quantity:1 }], '1 × ' + card.name).then(function(){
      btn.innerHTML = prev; delete btn.dataset.loading;
    });
  }
  // ── Sell view ───────────────────────────────────────────────────────────────
  // A third view alongside list/grid that puts the page into selling mode: one tile
  // per PRINTING with a counter per finish, feeding window.SellDraft (and so the
  // bottom drawer → /pages/sell-cards → quote → submit). Rendering lives in the
  // shared assets/sell-grid.js so the sell page can mount the same grid.
  function sellMode(){ return viewMode === 'sell'; }
  var sellPrevPlaceholder = null;
  /* Sell mode keeps the full search toolkit — typeahead, game/type, the facet
   * drawer, the set browser, sort and the price range all still apply, and price in
   * particular earns its place ("what's worth bringing in?").
   *
   * Only the three controls that are actively WRONG when selling come off: in-stock
   * (we buy printings we've never carried), condition (everything comes in at LP and
   * the store grades at intake) and finish (that filter is built from what we STOCK,
   * while the tiles offer every finish a printing was issued in — so it would appear
   * to contradict them).
   */
  function applySellUi(){
    var on = sellMode();
    var q = $('cs-q');
    if (q){
      if (on){ if (sellPrevPlaceholder === null) sellPrevPlaceholder = q.placeholder; q.placeholder = 'Search a card you want to sell…'; }
      else if (sellPrevPlaceholder !== null){ q.placeholder = sellPrevPlaceholder; sellPrevPlaceholder = null; }
    }
    var il = $('cs-instock-lbl'); if (il) il.style.display = on ? 'none' : '';
    var cond = $('cs-cond-dd'); if (cond && on) cond.style.display = 'none';
    var fin = $('cs-finish-dd'); if (fin && on) fin.style.display = 'none';
    var notice = $('cs-cond-notice'); if (notice && on) notice.style.display = 'none';
  }
  // Entering or leaving Sell changes both the search source and the in-stock filter,
  // so the current result set is the wrong one — refetch rather than re-render.
  function toggleSellMode(on){
    var ic = $('cs-instock');
    if (on && ic) ic.checked = false;   // we buy what we don't stock
    applySellUi();
    refilter();
  }
  // The Sell grid works from raw index docs (it needs catalog_finishes), which only
  // the API path carries — cards from the Storefront path have no `doc` and are
  // skipped. useApiSearch() forces the API path in sell mode, so that's belt-and-braces.
  function renderSellView(box, list){
    var docs = [];
    (list || cards).forEach(function(c){ if (c._pass && c.kind === 'single' && c.doc) docs.push(c.doc); });
    if (!window.SellGrid){
      box.innerHTML = '<div style="padding:2rem 1rem;text-align:center;font-family:var(--font-body,sans-serif);color:#8A8378">Sell view isn’t available here.</div>';
      return;
    }
    window.SellGrid.renderInto(box, docs, {
      // Relevance ties across every printing of one card, so let the grid impose a
      // real within-card order (newest first). Any explicit sort is a total order the
      // seller asked for and is left alone.
      groupPrintings: sortMode === 'relevance',
      emptyText: 'No printings to sell here — try another card name.'
    });
    $('cs-status').textContent = docs.length ? (docs.length + ' printing' + (docs.length !== 1 ? 's' : '')) : '';
  }

  function renderGrid(box, f, list){
    var grid = document.createElement('div'); grid.className = 'cs-grid';
    var shown = 0;
    (list || cards).forEach(function(card){
      if (!card._pass) return;
      var tile = null;
      if (card.kind === 'product'){
        if (!productVisible(card, f)) return;
        tile = buildProductTile(card, f);
      } else {
        if (!card.rows.some(function(r){ return rowVisible(r, f); })) return;
        tile = buildSingleTile(card, f);
      }
      if (tile){ grid.appendChild(tile); shown++; }
    });
    box.appendChild(grid);
    $('cs-status').textContent = cards.length ? (shown + ' result' + (shown!==1?'s':'')) : '';
    if (cards.length && !shown){ box.innerHTML = '<div style="padding:1.5rem 0;text-align:center;color:#8A8378">No results match your filters.</div>'; noResultsFilters(box); }
  }

  // ── List view: products as compact rows below the singles table ──
  function renderProductRows(box, f, list){
    var prods = (list || cards).filter(function(c){ return c.kind === 'product' && c._pass && productVisible(c, f); });
    if (!prods.length) return;
    var wrap = document.createElement('div'); wrap.id = 'cs-prodrows';
    var head = document.createElement('div'); head.className = 'cs-pr-head';
    head.textContent = 'Sealed, accessories & more';
    var sub = document.createElement('div'); sub.className = 'cs-pr-sub';
    sub.textContent = prods.length + ' product' + (prods.length!==1?'s':'') + '; switch to grid view for larger images';
    wrap.appendChild(head); wrap.appendChild(sub);
    prods.forEach(function(card){
      var row = document.createElement('div'); row.className = 'cs-pr-row';
      row.onclick = function(){ openProductDetail(card); };
      if (card.image){ var img = document.createElement('img'); img.src = card.image; img.alt = card.name; img.loading = 'lazy'; row.appendChild(img); }
      var mid = document.createElement('div'); mid.className = 'cs-pr-mid';
      var nm = document.createElement('div'); nm.className = 'cs-pr-name'; nm.textContent = card.name;
      if (isPreorder(card)){ var pc = document.createElement('span'); pc.className = 'cs-tag cs-tag-preorder'; pc.textContent = 'Pre-order'; pc.style.cssText = 'font-size:.52rem;padding:2px 6px;margin-left:.45rem;vertical-align:middle'; nm.appendChild(pc); }
      mid.appendChild(nm);
      var meta = document.createElement('div'); meta.className = 'cs-pr-meta';
      meta.textContent = [card.vendor, card.productType].filter(Boolean).join(' · ');
      mid.appendChild(meta); row.appendChild(mid);
      var right = document.createElement('div'); right.style.cssText = 'text-align:right;flex-shrink:0;display:flex;align-items:center;gap:.7rem';
      if (card.noPrice){
        var tag = document.createElement('span'); tag.className = 'cs-tag cs-tag-instore'; tag.textContent = 'In-store only';
        right.appendChild(tag);
      } else {
        var pr = document.createElement('div'); pr.className = 'cs-tile-price';
        pr.textContent = card.priceLo === card.priceHi ? fmt(card.priceHi) : fmt(card.priceLo) + '–' + fmt(card.priceHi);
        right.appendChild(pr);
        var add = document.createElement('button'); add.className = 'cs-tile-add'; add.innerHTML = cartPlusIcon() + 'Add';
        add.onclick = function(e){ e.stopPropagation(); quickAddProduct(card, add); };
        right.appendChild(add);
      }
      row.appendChild(right);
      wrap.appendChild(row);
    });
    box.appendChild(wrap);
  }

  // ── Product detail modal (sealed / accessories / board games) ──
  var PRODUCT_MEDIA_Q = 'query M($id:ID!){ product(id:$id){ images(first:8){ nodes{ url altText } } } }';
  function openProductDetail(card){
    modalCard = card; updateDetailNav();
    var body = $('cs-detail-body'); body.innerHTML = '';
    // Wishlist star — sits in the close-button row, and works for OOS items too.
    mountStar($('cs-detail-actions'), function(){ return productWishPayload(modalCard); }, 'inline');

    var gallery = document.createElement('div');
    gallery.style.cssText = 'width:300px;max-width:46%;flex-shrink:0;display:flex;flex-direction:column;gap:.6rem';
    var main = document.createElement('div');
    main.style.cssText = 'aspect-ratio:1/1;background:#efe9df;border-radius:12px;overflow:hidden;display:flex;align-items:center;justify-content:center;box-shadow:0 4px 16px rgba(0,0,0,.18)';
    var mainImg = document.createElement('img');
    mainImg.alt = card.name;
    mainImg.style.cssText = 'width:100%;height:100%;object-fit:contain;padding:.5rem';
    // An <img> with no src renders as an empty box, which is what made a missing
    // card look broken here. Fall back to the game's card back instead.
    if (card.image) mainImg.src = card.image;
    else mainImg.src = TTT.cardBack(card.productType) || '';
    if (mainImg.src) { main.appendChild(mainImg); attachFlip(main, mainImg, card); }
    else main.appendChild(TTT.cardPlaceholder(card.productType, { name: card.name, sub: card.set || '' }));
    gallery.appendChild(main);
    var thumbs = document.createElement('div');
    thumbs.style.cssText = 'display:flex;gap:.4rem;flex-wrap:wrap';
    gallery.appendChild(thumbs);
    body.appendChild(gallery);

    var info = document.createElement('div');
    info.style.cssText = 'flex:1;min-width:240px;display:flex;flex-direction:column';
    var h = document.createElement('h2');
    h.textContent = card.name;
    h.style.cssText = 'font-family:var(--font-display,sans-serif);font-weight:800;font-size:1.5rem;color:#1C1712;margin:.25rem 0 .1rem';
    var s = document.createElement('div');
    s.textContent = [card.vendor, card.productType].filter(Boolean).join(' · ');
    s.style.cssText = 'font-size:.8rem;letter-spacing:.05em;text-transform:uppercase;color:#8A8378;margin-bottom:.75rem';
    info.appendChild(h); info.appendChild(s);

    if (!card.noPrice){
      var price = document.createElement('div');
      price.textContent = card.priceLo === card.priceHi ? fmt(card.priceHi) : fmt(card.priceLo) + '–' + fmt(card.priceHi);
      price.style.cssText = 'font-family:var(--font-display,sans-serif);font-weight:800;font-size:1.35rem;color:#1C1712;margin-bottom:.2rem';
      info.appendChild(price);
      if (card.totalQty){
        var q = document.createElement('div');
        q.textContent = card.totalQty + ' in stock';
        q.style.cssText = 'font-size:.8rem;color:#8A8378;margin-bottom:.6rem';
        info.appendChild(q);
      }
    }

    if (card.descriptionHtml){
      var desc = document.createElement('div');
      desc.innerHTML = card.descriptionHtml;
      desc.style.cssText = 'font-family:var(--font-body,sans-serif);font-size:.88rem;color:#3a342c;line-height:1.5;margin:.4rem 0 .2rem;max-width:46ch';
      desc.querySelectorAll('img').forEach(function(im){ im.style.maxWidth = '100%'; im.style.height = 'auto'; });
      desc.querySelectorAll('table').forEach(function(t){ t.style.cssText = 'font-size:.84rem;border-collapse:collapse'; });
      info.appendChild(desc);
    }

    var actions = document.createElement('div');
    actions.style.cssText = 'display:flex;flex-direction:column;gap:.5rem;margin-top:auto;padding-top:1.25rem';
    var buyable = buyableVariants(card);
    if (card.noPrice || !buyable.length){
      var note = document.createElement('div');
      note.style.cssText = 'font-family:var(--font-body,sans-serif);font-size:.85rem;color:#5b5448;background:rgba(216,164,60,.1);border:1px solid rgba(216,164,60,.3);border-radius:8px;padding:.7rem .9rem';
      note.innerHTML = 'This item is available <strong>in store</strong>' + (CFG.pickupText ? '. ' + CFG.pickupText.replace(/</g,'&lt;') : '') + '.';
      actions.appendChild(note);
      if (CFG.storeInfoUrl){
        var link = fullBtn('Store information & hours', 'outline');
        link.onclick = function(){ window.location.href = CFG.storeInfoUrl; };
        actions.appendChild(link);
      }
    } else if (buyable.length === 1){
      var add1 = fullBtn('Add to cart', 'primary');
      add1.onclick = function(){ detailAdd(card, buyable[0].variantId, add1); };
      actions.appendChild(add1);
    } else {
      // multi-variant: a select + add
      var sel = document.createElement('select');
      sel.style.cssText = 'width:100%;border:1px solid rgba(28,23,18,.2);border-radius:8px;padding:.7rem .8rem;font-family:var(--font-body,sans-serif);font-size:.9rem;margin-bottom:.2rem';
      buyable.forEach(function(v){
        var o = document.createElement('option'); o.value = v.variantId;
        o.textContent = (v.title || 'Option') + ' · ' + fmt(v.price) + (v.qty ? '' : ' (sold out)');
        sel.appendChild(o);
      });
      actions.appendChild(sel);
      var addM = fullBtn('Add to cart', 'primary');
      addM.onclick = function(){ detailAdd(card, sel.value, addM); };
      actions.appendChild(addM);
    }
    info.appendChild(actions);
    body.appendChild(info);
    $('cs-detail').style.display = 'flex';

    // lazy-load the rest of the product's images for the thumbnail strip
    fetchProductMedia(card.id, mainImg, thumbs);
  }
  function detailAdd(card, variantId, btn){
    if (btn.disabled) return;
    var label = btn.textContent; btn.disabled = true;
    btn.innerHTML = '<span class="cs-spinner" style="border-color:rgba(28,23,18,.35);border-top-color:#1C1712"></span> Adding…';
    addToCart([{ id: variantId, quantity:1 }], '1 × ' + card.name).then(function(ok){
      btn.disabled = false; btn.textContent = label;
      if (ok) closeDetail();
    });
  }
  function fetchProductMedia(id, mainImg, thumbs){
    gql(PRODUCT_MEDIA_Q, { id: id }).then(function(res){
      var imgs = (res && res.data && res.data.product && res.data.product.images && res.data.product.images.nodes) || [];
      if (imgs.length < 2) return;
      if (!mainImg.src && imgs[0]) mainImg.src = imgs[0].url;
      imgs.forEach(function(im){
        var t = document.createElement('img');
        t.src = im.url; t.alt = im.altText || ''; t.loading = 'lazy';
        t.style.cssText = 'width:52px;height:52px;object-fit:cover;border-radius:7px;cursor:pointer;border:1px solid rgba(28,23,18,.12)';
        t.onclick = function(){ mainImg.src = im.url; };
        thumbs.appendChild(t);
      });
    }).catch(function(){});
  }

  function buildCell(card, row, col, cell){
    var div = document.createElement('div');
    div.style.cssText = 'position:relative;display:inline-flex;flex-direction:column;align-items:center;line-height:1.2;white-space:nowrap';
    var dim = cell.qty <= 0 ? 'opacity:.4' : '';
    var price = document.createElement('span');
    // Zero-stock conditions show a dash rather than a stale/last-known price, so we
    // never imply a price we can't honour and don't have to keep OOS prices current.
    price.textContent = cell.qty <= 0 ? '—' : fmt(cell.price);
    price.style.cssText = 'font-weight:600;font-size:.86rem;color:#1C1712;' + dim;
    var q = document.createElement('span');
    q.textContent = cell.qty + ' in stock';
    q.style.cssText = 'font-size:.68rem;color:#8A8378;' + dim;
    div.appendChild(price); div.appendChild(q);

    if (cell.qty > 0 && !EMBED){   // workbench adds to the DECK, not the cart
      var quick = document.createElement('button');
      quick.className = 'cs-quick';
      quick.textContent = '＋';
      quick.title = 'Quick add to cart';
      quick.style.cssText = 'position:absolute;top:-9px;right:-16px;width:20px;height:20px;border-radius:50%;border:none;background:#D8A43C;color:#1C1712;font-size:.8rem;line-height:1;cursor:pointer;display:none;align-items:center;justify-content:center;padding:0';
      quick.onclick = function(e){
        e.stopPropagation();
        if (quick.dataset.loading) return;
        quick.dataset.loading = '1';
        quick.innerHTML = '<span class="cs-spinner" style="width:11px;height:11px;border-width:2px;border-color:rgba(28,23,18,.4);border-top-color:#1C1712"></span>';
        var note = '1 × ' + card.name + ' (' + col.code + (row.finish.foil?' '+row.finish.label:'') + ')';
        addToCart([{ id:cell.variantId, quantity:1 }], note).then(function(){
          quick.textContent = '＋'; delete quick.dataset.loading;
        });
      };
      div.appendChild(quick);
      div.onmouseenter = function(){ quick.style.display = 'flex'; };
      div.onmouseleave = function(){ if (!quick.dataset.loading) quick.style.display = 'none'; };
    }
    return div;
  }

  function actionBtn(label, fn, primary){
    var b = document.createElement('button');
    b.className = 'cs-actbtn';
    b.textContent = label; b.onclick = fn;
    b.style.cssText = 'font-family:var(--font-display,sans-serif);font-weight:600;font-size:.78rem;border-radius:7px;padding:.35rem .9rem;margin-left:.4rem;cursor:pointer;border:1px solid ' +
      (primary ? '#D8A43C;background:#D8A43C;color:#1C1712' : 'rgba(28,23,18,.2);background:transparent;color:#1C1712');
    return b;
  }

  // ── Filter summary counts ──
  function updateCounts(){
    [['cs-finish-menu','cs-finish-cnt'],['cs-cond-menu','cs-cond-cnt']].forEach(function(t){
      var total = document.querySelectorAll('#'+t[0]+' input').length;
      var n = checkedValues(t[0]).length, el = $(t[1]);
      if (total && n < total){ el.textContent = n; el.style.display = 'inline-block'; } else { el.style.display = 'none'; }
    });
  }

  // Build the Finish filter from finishes actually present in the results
  // (Magic → Non-Foil/Foil, Pokémon → Non-Foil/Holofoil/Reverse Holofoil, …)
  function buildFinishFilter(){
    var present = {};
    cards.forEach(function(c){ c.rows.forEach(function(r){ present[r.finish.key] = r.finish; }); });
    var order = ['nonfoil','foil','etched','coldfoil','holofoil','reverseholofoil'];
    // Any present finish MUST get a checkbox: rowVisible() filters on the checked set, so a
    // finish missing from the menu is silently hidden whenever another finish is present
    // (etched was missing — CLB 476 vanished beside its non-foil printings).
    var keys = order.filter(function(k){ return present[k]; })
      .concat(Object.keys(present).filter(function(k){ return order.indexOf(k) < 0; }));
    $('cs-finish-menu').innerHTML = keys.map(function(k){
      var checked = (!desiredFinish || desiredFinish.has(k)) ? ' checked' : '';
      return '<label><input type="checkbox" value="' + k + '"' + checked + '> ' + present[k].label + '</label>';
    }).join('');
    desiredFinish = null;  // only honor the URL finish on the first build
    $('cs-finish-dd').style.display = keys.length > 1 ? '' : 'none';
  }

  // ── Detail modal (products only; singles use the unified card modal below) ──
  function closeDetail(){ $('cs-detail').style.display = 'none'; modalCard = null; }
  // Product-modal prev/next over the on-screen card order (navList). Singles hand
  // off to the unified card modal so arrows browse seamlessly across both kinds.
  function detailNav(delta){
    var i = navList.indexOf(modalCard); if (i < 0) return;
    var ni = i + delta; if (ni < 0 || ni >= navList.length) return;
    var c = navList[ni];
    if (c.kind === 'product') openProductDetail(c);
    else { closeDetail(); openCart(c); }
  }
  function updateDetailNav(){
    var i = navList.indexOf(modalCard);
    var prev = $('cs-detail-prev'), next = $('cs-detail-next');
    if (!prev || !next) return;
    var has = i >= 0 && navList.length > 1;
    prev.disabled = !has || i <= 0;
    next.disabled = !has || i >= navList.length - 1;
  }

  // ── Cart modal ──
  function fullBtn(label, kind){
    var b = document.createElement('button');
    b.className = 'cs-actbtn'; b.textContent = label;
    var base = 'width:100%;font-family:var(--font-display,sans-serif);font-weight:700;border-radius:7px;padding:.8rem;cursor:pointer;font-size:.95rem;margin-bottom:.5rem;';
    if (kind === 'primary') b.style.cssText = base + 'background:#D8A43C;color:#1C1712;border:none';
    else if (kind === 'dark') b.style.cssText = base + 'background:#1C1712;color:#FCFAF5;border:none';
    else b.style.cssText = base + 'background:transparent;color:#1C1712;border:1px solid rgba(28,23,18,.25);font-weight:600';
    return b;
  }
  // First in-stock printing of a single (best condition first) — the variant a
  // "Add to wishlist" click tracks. Returns null if nothing is buyable.
  function firstBuyableCell(card){
    for (var ri = 0; ri < card.rows.length; ri++){
      var row = card.rows[ri];
      for (var ci = 0; ci < COLS.length; ci++){
        var cell = row.cells[COLS[ci].code];
        if (cell && cell.qty > 0 && cell.variantId){
          return {
            variantId: String(cell.variantId), price: cell.price,
            label: COLS[ci].label + (row.finish.foil ? ' · ' + row.finish.label : ''),
            finishKey: row.finish.key,
          };
        }
      }
    }
    return null;
  }
  // Like firstBuyableCell, but falls back to ANY printing that has a variantId when the
  // card is fully out of stock — so an OOS single can still be saved to a wishlist (the
  // customer gets a restock email). Returns null when no printing has a variant, which is
  // the normal case for a catalog-only printing (one we have never carried): those are
  // wishlisted on card identity instead — see cardWishPayload.
  function firstWishlistCell(card){
    var buyable = firstBuyableCell(card);
    if (buyable) return buyable;
    for (var ri = 0; ri < card.rows.length; ri++){
      var row = card.rows[ri];
      for (var ci = 0; ci < COLS.length; ci++){
        var cell = row.cells[COLS[ci].code];
        if (cell && cell.variantId){
          return {
            variantId: String(cell.variantId), price: cell.price,
            label: COLS[ci].label + (row.finish.foil ? ' · ' + row.finish.label : ''),
            finishKey: row.finish.key,
          };
        }
      }
    }
    return null;
  }
  // Wishlist "Save" button for a single — reuses the shared Wishlist toggle (auth gate,
  // restock-alert signup, saved state) but labelled "Save"/"Saved" and styled like the
  // other row/modal actions. Returns null when the card can't be wishlisted (no variant
  // or the wishlist layer isn't loaded), so callers can fall back gracefully.
  function saveBtn(card, opts){
    if (!window.Wishlist) return null;
    var payload = cardWishPayload(card);
    if (!payload) return null;
    var b = window.Wishlist.makeButton(payload,
      { label: true, labelOff: 'Save', labelOn: 'Saved', px: (opts && opts.px) || 14 });
    b.style.cssText = (opts && opts.css) ||
      'font-family:var(--font-display,sans-serif);font-weight:600;font-size:.78rem;border-radius:7px;padding:.35rem .9rem;margin-left:.4rem;cursor:pointer;opacity:1;display:inline-flex;align-items:center;line-height:1;border:1px solid rgba(28,23,18,.2);background:transparent;color:#1C1712';
    return b;
  }
  // ---- corner wishlist star (shared by every card modal) ----
  /** Wishlist payload for a single.
   *
   *  The card ref is the load-bearing half, not the variant: the backend keys a single's
   *  wishlist line on the PRINTING (game/set/number/finish), so a card we have never
   *  carried — which has no variant at all, and is most of what anyone wants to wishlist
   *  — is savable, and a card that sells out and comes back as a different Shopify
   *  product still notifies. A variant is included when one exists, purely so the line is
   *  immediately buyable and giftable.
   *
   *  `card.game` must be the GAME, not the Shopify product type the normalized card
   *  carries ("MTG Single"); the backend normalizes both, but sending the doc's own value
   *  keeps the two sides honest.
   */
  function cardWishPayload(card){
    if (!card) return null;
    var d = card.doc || {};
    // setCode/number come from the INDEX doc only. Do NOT reach for card.set as a
    // fallback: on the Storefront-API path (normalize(), used by the workbench) `set` is
    // the set NAME off the "[Modern Horizons 2]" title bracket and `number` can be a
    // Pokémon "063/165" — neither matches the key the backend fires on, so a want built
    // from them would be written and then never triggered. Cards from that path have a
    // variant by construction (Storefront search only sees products), so they fall
    // through to the variant-keyed payload below, which is correct for them.
    var setCode = card.setCode || d.set_code || '';
    var number = card.number || d.collector_number || '';
    // No printing identity and no variant: nothing the backend could ever match. Rare —
    // a doc missing set or collector number.
    var wc = card.rows ? firstWishlistCell(card) : null;
    if (!setCode || !number) return wc ? variantOnlyPayload(card, wc) : null;
    return {
      variantId: wc ? wc.variantId : '', productId: wc ? numericId(card.id) : '',
      title: card.name,
      variantTitle: wc ? wc.label : finishLabel(card),
      image: card.image || null,
      price: wc ? wc.price : (card.price || 0),
      card: {
        name: card.name, setCode: setCode, collectorNumber: number,
        finish: wc ? wc.finishKey : defaultFinish(card),
        game: d.game || card.game || 'MTG'
      },
    };
  }
  // A single with a variant but no usable printing identity — keeps the old variant-keyed
  // behaviour rather than dropping the star.
  function variantOnlyPayload(card, wc){
    return {
      variantId: wc.variantId, productId: numericId(card.id),
      title: card.name, variantTitle: wc.label, image: card.image || null, price: wc.price,
    };
  }
  /** The finish a want defaults to when nothing is in stock to infer one from: the
   *  printing's own first catalog finish (a foil-only printing must not mint a nonfoil
   *  want that can never fire), else non-foil. */
  function defaultFinish(card){
    var cf = (card.doc && card.doc.catalog_finishes) || [];
    return cf.length ? String(cf[0]) : 'nonfoil';
  }
  function finishLabel(card){
    // Index finish keys may carry underscores ("reverse_holofoil"); FIN's don't — same
    // stripped-key fallback docRows uses, so the label doesn't come out as a raw key.
    var f = defaultFinish(card);
    var fo = FIN[f] || FIN[String(f).replace(/_/g, '')];
    return fo ? fo.label : (f === 'nonfoil' ? 'Non-Foil' : f);
  }
  // Wishlist payload for a sealed/accessory product (variants, not condition rows).
  function productWishPayload(card){
    if (!card || !card.variants || !card.variants.length) return null;
    var wv = card.variants.filter(function(v){ return v.available; })[0] || card.variants[0];
    if (!wv || !wv.variantId) return null;
    return {
      variantId: String(wv.variantId), productId: numericId(card.id),
      title: card.name, variantTitle: wv.title || null, image: card.image || null, price: wv.price || 0,
    };
  }
  /** Mount the icon-only star into a modal's top-right corner, replacing any star from
   *  the previously-shown card. `payloadFn` resolves at click time, so the star mounts
   *  even when the card turns out not to be wishlistable (it says so on tap rather than
   *  silently vanishing). `mode`: 'corner' absolutely-positions it beside the close
   *  button; 'inline' lets the host's flex row place it. */
  function mountStar(host, payloadFn, mode){
    if (!host) return;
    var old = host.querySelector('.cs-star-btn');
    if (old) old.parentNode.removeChild(old);
    if (!window.Wishlist) return;
    var b = window.Wishlist.makeButton(payloadFn, {
      className: 'cs-star-btn' + (mode === 'corner' ? ' cs-cm-star' : ''), px: 19,
    });
    if (mode === 'corner') host.appendChild(b); else host.insertBefore(b, host.firstChild);
  }
  // Card-level rules text by Scryfall oracle id (ttt-backend /api/oracle), cached.
  // Used only as a modal fallback for products with no Storepass description table.
  var ORACLE_CACHE = {};
  function fetchOracle(oid, cb){
    if (!oid || !API_BASE) { cb(null); return; }
    if (ORACLE_CACHE.hasOwnProperty(oid)) { cb(ORACLE_CACHE[oid]); return; }
    fetch(API_BASE.replace(/\/+$/, '') + '/api/oracle?ids=' + encodeURIComponent(oid))
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ var o = (j && j.oracles && j.oracles[oid]) || null; ORACLE_CACHE[oid] = o; cb(o); })
      .catch(function(){ cb(null); });
  }

  function openCart(card){
    cartCard = card;
    var ce = $('cs-cart-card'); if (ce) ce.classList.remove('cs-varmode'); // restore the two-column card view
    // Wishlist star, beside the close button. Mounted before the in-stock/OOS split so
    // both paths get it, and re-mounted per card so prev/next nav retracks the star.
    mountStar(ce, function(){ return cardWishPayload(cartCard); }, 'corner');
    var titleEl = $('cs-cart-title');
    titleEl.textContent = dispName(card);
    // Foil chip rides beside the name rather than over the art (it used to cover the
    // card's own title). Setting textContent above clears the previous card's chip.
    var foilRow = card.rows.filter(function(r){ return r.finish.foil && COLS.some(function(c){ var cell = r.cells[c.code]; return cell && cell.qty > 0; }); })[0];
    if (foilRow){
      var chip = document.createElement('span');
      chip.className = 'cs-cm-foilchip';
      chip.textContent = foilRow.finish.label;
      titleEl.appendChild(chip);
    }
    /* Language chip beside the name. Same colour as the list row's so the two surfaces read as
     * one system, and INLINE for the same reason: Tailwind is purged against the templates, so a
     * class invented here compiles away to nothing. */
    var langName = cardLangName(card);
    if (langName){
      var lchip = document.createElement('span');
      lchip.className = 'ttt-lang';
      lchip.textContent = langName;
      lchip.style.cssText = 'display:inline-block;margin-left:.4em;padding:0 .35em;border-radius:3px;'
        + 'background:rgba(49,78,120,.12);color:#31527A;font-weight:600;font-size:.72em;vertical-align:3px';
      titleEl.appendChild(lchip);
    }
    var sub2 = $('cs-cart-sub2');
    if (sub2) sub2.textContent = (card.set || '') + (card.game ? ' · ' + card.game.replace(/ Singles?$/,'') : '');

    // LEFT column — card image (DFC flip) plus the rules/meta/flavor
    // block. The block is hidden by CSS ≤680px so the modal becomes the mobile sheet.
    var left = $('cs-cart-left'); left.innerHTML = '';
    if (card.image){
      var hero = document.createElement('div');
      hero.style.cssText = 'display:flex;justify-content:center;perspective:1200px';
      var iw = document.createElement('div'); iw.style.cssText = 'position:relative;display:inline-flex';
      var himg = document.createElement('img'); himg.src = card.image; himg.alt = card.name;
      himg.style.cssText = 'width:auto;max-width:300px;max-height:64vh;border-radius:12px;box-shadow:0 6px 22px rgba(0,0,0,.28);backface-visibility:hidden;display:block';
      iw.appendChild(himg);
      attachFlip(iw, himg, card);   // DFC flip control, same placement as elsewhere
      hero.appendChild(iw); left.appendChild(hero);
    }
    /* Treatment belongs in the spec table beside Collector Number and Rarity: it IS a
     * spec of the printing, and it's the one that explains why two otherwise identical
     * printings of a card carry different prices. Appended AFTER the per-cell styling
     * loop below runs, so it styles its own cells. Two spec tables exist (the Storepass
     * description table and the Scryfall-facet fallback) and this feeds both. */
    var modalTreatments = cardTreatments(card);
    /* ...and as a SPEC ROW. The chip catches the eye; this is where someone checks. It sits with
     * Collector Number and Rarity because that is what it is — a fact about which printing this
     * is, and the one fact the card image cannot show. */
    function appendLanguageRow(table){
      var ln = cardLangName(card);
      if (!ln || !table) return;
      var tr = document.createElement('tr');
      var k = document.createElement('td'), v = document.createElement('td');
      k.textContent = 'Language';
      v.textContent = ln;
      k.style.cssText = 'padding:2px 10px 2px 0;color:#8A8378;white-space:nowrap;vertical-align:top';
      v.style.cssText = 'padding:2px 10px 2px 0;font-weight:600;color:#31527A';
      tr.appendChild(k); tr.appendChild(v);
      (table.tBodies && table.tBodies[0] ? table.tBodies[0] : table).appendChild(tr);
    }
    function appendTreatmentRow(table){
      if (!modalTreatments.length || !table) return;
      var tr = document.createElement('tr');
      var k = document.createElement('td'), v = document.createElement('td');
      k.textContent = modalTreatments.length > 1 ? 'Treatments' : 'Treatment';
      v.textContent = modalTreatments.join(' · ');
      k.style.cssText = 'padding:2px 10px 2px 0;color:#8A8378;white-space:nowrap;vertical-align:top';
      v.style.cssText = 'padding:2px 10px 2px 0;font-weight:600;color:#8A6D1F';
      tr.appendChild(k); tr.appendChild(v);
      // A parsed table has a tbody; one we built with createElement does not.
      (table.tBodies && table.tBodies[0] ? table.tBodies[0] : table).appendChild(tr);
    }

    var info = document.createElement('div'); info.className = 'cs-cm-info';
    var tmp = document.createElement('div'); tmp.innerHTML = card.descriptionHtml || '';
    var tbl = tmp.querySelector('.singles-description-table');
    if (tbl){
      tbl.style.cssText = 'font-size:.85rem;color:#3a342c;border-collapse:collapse;margin-bottom:.4rem';
      tbl.querySelectorAll('td').forEach(function(td,i){ td.style.cssText = 'padding:2px 10px 2px 0;' + (i%2===0?'color:#8A8378;white-space:nowrap':'font-weight:600'); });
      appendLanguageRow(tbl);
      appendTreatmentRow(tbl);
      info.appendChild(tbl);
    }
    // Rules text sits under a different class depending on which generator wrote the
    // listing: Storepass imports use `.oracle-text`, our own Model-A generator writes
    // `.description-text` (inside `.single-description-div`). Reading only the first one
    // is why every Scryfall-generated listing showed no rules text — most visibly on
    // DFCs, whose whole point is the text on both faces.
    // NOTE: check for the text BEFORE the loop below — appendChild MOVES the node out
    // of `tmp`, so re-querying `tmp` afterward (the fallback guard below) would wrongly
    // report it missing and render the rules text a second time.
    var hadOracleText = !!tmp.querySelector('.oracle-text, .description-text');
    ['.oracle-text','.description-text','.flavor-text'].forEach(function(selr){
      var el = tmp.querySelector(selr);
      if (el){
        el.style.cssText = 'font-size:.88rem;color:#3a342c;line-height:1.45;margin-top:.5rem;' + (selr==='.flavor-text'?'font-style:italic;color:#8A8378':'');
        info.appendChild(el);
      }
    });
    // Fallback for products with no Storepass description table (Secret Lair, newer
    // sets): show Set/Type/Rarity/Cost from the search index (Scryfall facets), and
    // fetch the rules text by oracle id (shared across every printing of the card).
    if (!tbl && (card.typeLine || card.manaCost || card.rarity)){
      var ft = document.createElement('table');
      ft.style.cssText = 'font-size:.85rem;color:#3a342c;border-collapse:collapse;margin-bottom:.4rem';
      var mrow = function(k, v){
        if (!v) return;
        var tr = document.createElement('tr'), a = document.createElement('td'), b = document.createElement('td');
        a.textContent = k; b.textContent = v;
        a.style.cssText = 'padding:2px 10px 2px 0;color:#8A8378;white-space:nowrap';
        b.style.cssText = 'padding:2px 10px 2px 0;font-weight:600';
        tr.appendChild(a); tr.appendChild(b); ft.appendChild(tr);
      };
      mrow('Set', card.set);
      mrow('Type', card.typeLine);
      mrow('Rarity', card.rarity ? card.rarity.charAt(0).toUpperCase() + card.rarity.slice(1) : '');
      mrow('Cost', card.manaCost);
      appendLanguageRow(ft);
      appendTreatmentRow(ft);
      if (ft.children.length) info.appendChild(ft);
    }
    if (!hadOracleText && card.oracleId){
      fetchOracle(card.oracleId, function(o){
        if (!o || !o.oracleText || cartCard !== card) return; // modal moved on
        var ot = document.createElement('div');
        ot.style.cssText = 'font-size:.88rem;color:#3a342c;line-height:1.45;margin-top:.5rem;white-space:pre-wrap';
        ot.textContent = o.oracleText;
        info.appendChild(ot);
      });
    }

    // RIGHT column — card text on top, then buy controls
    var body = $('cs-cart-body'); body.innerHTML = '';
    // Embedded (workbench): add-to-deck sits above the buy controls; the buy rows
    // below double as the variant/upgrade explorer.
    if (EMBED && EMBED_CB){
      var inDeck = EMBED_CB.isInDeck && EMBED_CB.isInDeck(card.name);
      var deckBtn = document.createElement('button');
      deckBtn.type = 'button'; deckBtn.className = 'cs-cm-deckbtn';
      deckBtn.textContent = inDeck ? '✓ In your deck' : '+ Add to deck'; deckBtn.disabled = !!inDeck;
      deckBtn.onclick = function(){ if (EMBED_CB.onAdd) EMBED_CB.onAdd(card); deckBtn.textContent = '✓ In your deck'; deckBtn.disabled = true; };
      body.appendChild(deckBtn);
    }
    // Card text (rules / meta / flavor) sits above the buy controls on the right.
    if (info.childNodes.length){
      info.style.cssText = 'padding-bottom:.9rem;margin-bottom:.35rem;border-bottom:1px solid rgba(28,23,18,.1)';
      body.appendChild(info);
    }
    var steppers = [];
    updateCartNav();

    var list = document.createElement('div');
    card.rows.forEach(function(row){
      COLS.forEach(function(c){
        var cell = row.cells[c.code];
        if (!cell || cell.qty <= 0) return;
        var line = document.createElement('div');
        line.style.cssText = 'display:flex;align-items:center;justify-content:space-between;gap:.75rem;padding:.55rem 0;border-bottom:1px solid rgba(28,23,18,.08)';
        var lft = document.createElement('div');
        lft.innerHTML = '<div style="font-weight:600;font-size:.9rem;color:#1C1712">' + c.label + (row.finish.foil ? ' · ' + row.finish.label : '') +
          '<span style="color:#C2902C;margin-left:.5rem">' + fmt(cell.price) + '</span></div>' +
          '<div class="cs-cm-stock" style="font-size:.78rem;color:#8A8378">' + cell.qty + ' in stock</div>';
        // Say so when part of that stock is already spoken for, otherwise the
        // stepper capping below the shelf count looks like a bug.
        (function(cellRef, stockEl){
          TTT.cart.load().then(function(){
            var held = TTT.cart.inCart(cellRef.variantId);
            if (held && stockEl) stockEl.textContent = cellRef.qty + ' in stock · ' + held + ' in your cart';
          });
        })(cell, lft.querySelector('.cs-cm-stock'));
        var st = makeStepper(cell.variantId, cell.qty, updateSummary);
        steppers.push({ box: st, price: cell.price });
        line.appendChild(lft); line.appendChild(st);
        list.appendChild(line);
      });
    });

    var sell = fullBtn(CFG.sellLabel || 'Sell Us Your Card', 'outline');
    sell.onclick = function(){ openSell(card); };

    if (!steppers.length){
      var none = document.createElement('div');
      none.style.cssText = 'color:#8A8378;padding:.5rem 0 1rem;text-align:center';
      none.textContent = 'No conditions in stock right now.';
      body.appendChild(none);
      // Still savable while out of stock — the corner star signs the customer up for
      // the restock email.
      body.appendChild(sell);
      $('cs-cart').style.display = 'flex';
      return;
    }
    body.appendChild(list);

    // Only one buyable version of this card → pre-select quantity 1 so the buyer
    // doesn't have to bump the stepper before adding to cart.
    if (steppers.length === 1 && steppers[0].box.setQty) steppers[0].box.setQty(1);

    // subtotal
    var subRow = document.createElement('div');
    subRow.style.cssText = 'display:flex;align-items:baseline;justify-content:space-between;margin:.95rem 0 .25rem';
    subRow.innerHTML = '<span style="font-family:var(--font-display,sans-serif);font-weight:600;color:#1C1712">Subtotal</span>' +
      '<span id="cs-cart-sub" style="font-family:var(--font-display,sans-serif);font-weight:800;font-size:1.2rem;color:#1C1712">$0.00</span>';
    body.appendChild(subRow);

    if (CFG.checkoutNote){
      var note = document.createElement('div');
      note.style.cssText = 'font-size:.76rem;color:#8A8378;margin:0 0 .8rem';
      note.textContent = CFG.checkoutNote;
      body.appendChild(note);
    } else {
      body.appendChild(document.createElement('div')).style.cssText = 'height:.6rem';
    }

    var addBtn = fullBtn('Add to cart', 'primary'); addBtn.id = 'cs-cart-add';
    addBtn.onclick = function(){ submitCart(false); };
    body.appendChild(addBtn);

    if (CFG.buyNow){
      var buyBtn = fullBtn('Buy it now', 'dark'); buyBtn.id = 'cs-cart-buynow';
      buyBtn.onclick = function(){ submitCart(true); };
      body.appendChild(buyBtn);
    }

    body.appendChild(sell);

    if (CFG.showPickup && CFG.pickupText){
      var pu = document.createElement('div');
      pu.style.cssText = 'display:flex;gap:.5rem;align-items:flex-start;margin-top:1rem;font-family:var(--font-body,sans-serif)';
      pu.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2e7d46" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:2px"><path d="M20 6L9 17l-5-5"/></svg>' +
        '<div><div style="font-size:.85rem;color:#1C1712;font-weight:600"></div>' +
        (CFG.storeInfoUrl ? '<a href="' + CFG.storeInfoUrl + '" style="font-size:.78rem;color:#8A8378;text-decoration:underline">View store information</a>' : '') + '</div>';
      pu.querySelector('div > div').textContent = CFG.pickupText;
      body.appendChild(pu);
    }

    updateSummary();
    $('cs-cart').style.display = 'flex';

    function updateSummary(){
      var total = 0;
      steppers.forEach(function(s){ total += (parseInt(s.box.dataset.qty, 10) || 0) * s.price; });
      var subEl = $('cs-cart-sub'); if (subEl) subEl.textContent = fmt(total);
      var disabled = total <= 0;
      [$('cs-cart-add'), $('cs-cart-buynow')].forEach(function(b){
        if (b){ b.disabled = disabled; b.style.opacity = disabled ? '.5' : '1'; b.style.cursor = disabled ? 'default' : 'pointer'; }
      });
    }
  }
  function closeCart(){ $('cs-cart').style.display = 'none'; cartCard = null; }
  // Prev/next over the on-screen card order (navList). Products hand off to the
  // product detail modal so arrows browse seamlessly across both kinds.
  function cartNav(delta){
    var i = navList.indexOf(cartCard); if (i < 0) return;
    var ni = i + delta; if (ni < 0 || ni >= navList.length) return;
    var c = navList[ni];
    if (c.kind === 'product'){ closeCart(); openProductDetail(c); }
    else openCart(c);
  }
  // Toggle/disable both the desktop side arrows and the mobile window-corner arrows.
  function updateCartNav(){
    var i = navList.indexOf(cartCard);
    var has = i >= 0 && navList.length > 1;
    var sp = $('cs-cart-arrow-prev'), sn = $('cs-cart-arrow-next');
    if (sp && sn){ sp.disabled = !has || i <= 0; sn.disabled = !has || i >= navList.length - 1; }
    var prev = $('cs-cart-prev'), next = $('cs-cart-next');
    if (prev && next){
      var show = isMobile() && has;
      prev.style.display = next.style.display = show ? 'flex' : 'none';
      prev.disabled = i <= 0;
      next.disabled = i >= navList.length - 1;
    }
  }
  // `max` is the shelf count. The real ceiling is what's left after whatever the
  // shopper already has in their cart — without that, two passes through this modal
  // happily ask for 8 copies of a card we have 4 of, and Shopify 422s at the end.
  function makeStepper(variantId, max, onChange){
    var box = document.createElement('div');
    box.className = 'cs-stepper';
    box.dataset.variant = variantId;
    box.dataset.qty = '0';
    box.style.cssText = 'display:inline-flex;align-items:center;border:1px solid rgba(28,23,18,.2);border-radius:8px;overflow:hidden;flex-shrink:0';
    function mkBtn(sym){
      var b = document.createElement('button');
      b.type = 'button'; b.textContent = sym;
      b.style.cssText = 'width:32px;height:32px;border:none;background:#f3f0ea;color:#1C1712;font-size:1.15rem;line-height:1;cursor:pointer;display:flex;align-items:center;justify-content:center';
      return b;
    }
    var minus = mkBtn('−'), plus = mkBtn('+');
    var val = document.createElement('span');
    val.style.cssText = 'min-width:36px;text-align:center;font-size:.9rem;font-weight:600;color:#1C1712';
    function ceiling(){ return TTT.cart.remaining(variantId, max); }
    function set(n){
      var cap = ceiling();
      n = Math.max(0, Math.min(cap, n));
      box.dataset.qty = String(n); val.textContent = String(n);
      minus.style.opacity = n <= 0 ? '.35' : '1';
      plus.style.opacity  = n >= cap ? '.35' : '1';
      if (onChange) onChange();
    }
    minus.onclick = function(){ set(parseInt(box.dataset.qty, 10) - 1); };
    plus.onclick  = function(){ set(parseInt(box.dataset.qty, 10) + 1); };
    set(0);
    // The ledger loads async, so re-clamp once it lands — this stepper may have
    // been built before /cart.js came back.
    TTT.cart.load().then(function(){ set(parseInt(box.dataset.qty, 10) || 0); });
    box.setQty = set;   // lets callers pre-select a quantity (e.g. single-variant default)
    box.appendChild(minus); box.appendChild(val); box.appendChild(plus);
    return box;
  }
  function submitCart(buyNow){
    var items = [];
    $('cs-cart-body').querySelectorAll('.cs-stepper').forEach(function(box){
      var qty = parseInt(box.dataset.qty, 10);
      if (qty > 0) items.push({ id: box.dataset.variant, quantity: qty });
    });
    if (!items.length){ return; }
    var count = items.reduce(function(a,b){ return a+b.quantity; }, 0);
    var btn = buyNow ? $('cs-cart-buynow') : $('cs-cart-add');
    if (!btn || btn.disabled) return;
    var label = btn.textContent;
    btn.disabled = true;
    var spinCol = buyNow ? 'border-color:rgba(252,250,245,.4);border-top-color:#FCFAF5' : 'border-color:rgba(28,23,18,.35);border-top-color:#1C1712';
    btn.innerHTML = '<span class="cs-spinner" style="' + spinCol + '"></span> ' + (buyNow ? 'Checkout…' : 'Adding…');
    addToCart(items, count + ' item' + (count!==1?'s':'') + ' added').then(function(ok){
      if (ok && buyNow){ window.location.href = '/checkout'; return; }
      btn.disabled = false;
      btn.textContent = label;
      if (ok) closeCart();
    });
  }
  // ── Sell / buylist (posts to the ttt-backend buylist API) ──
  function sellEsc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }
  function openSell(card, unpinned){
    var base = buylistBase();
    var body = $('cs-sell-body');
    $('cs-sell-title').textContent = 'Sell: ' + card.name;
    if (!base){
      body.innerHTML = '<p style="font-family:var(--font-body,sans-serif);color:#5b5448;font-size:.92rem">Our online buylist isn’t live yet. Bring your cards to the counter and we’ll make you an offer.</p>';
      $('cs-sell').style.display = 'flex'; return;
    }
    var game = buylistGame(card);
    var BL = window.TTT && TTT.buylist;
    // The games we take online are a backend setting — wait for it rather than answer from the default.
    if (game && BL && !BL.loaded()){ BL.load(base).then(function(){ openSell(card, unpinned); }); return; }
    if (!game || (BL && !BL.buysOnline(game))){
      var names = BL ? BL.onlineGameNames() : 'Magic: The Gathering';
      body.innerHTML = '<p style="font-family:var(--font-body,sans-serif);color:#5b5448;font-size:.92rem">We currently buy <strong>' + sellEsc(names) + '</strong> singles online. Bring ' + sellEsc(card.name) + ' to the store for an in-person offer.</p>';
      $('cs-sell').style.display = 'flex'; return;
    }
    // Preferred path: the shared image-tile printing picker (same UX the sell page
    // uses) — the seller points at the exact printing AND finish in one tap, instead
    // of a finish dropdown that guesses which printing they're bringing in.
    if (window.PrintingPicker){
      // Sell was opened FROM a printing (card modal / result row), so the printing is
      // already settled — hand the picker that doc and it opens as just that printing's
      // finish counters, instead of asking the seller to re-find it in a grid of every
      // printing of the card. `unpinned` is the "different printing?" escape hatch.
      var pinDoc = (!unpinned && card.doc && card.doc.name) ? card.doc : null;
      var pinLbl = (card.set || '') + (card.number ? ' · #' + card.number : '');
      window.PrintingPicker.open(card.name, {
        apiBase: base, neutralStock: true, multi: true, game: game,
        docs: pinDoc ? [pinDoc] : null,
        addLabel: 'This printing',
        subtitle: (pinDoc && pinLbl) ? (pinLbl + ' · tap a finish once per copy') : 'Tap a finish once per copy you’re selling',
        confirmLabel: 'Add',
        moreLabel: 'Selling a different printing?',
        onMore: pinDoc ? function(){ openSell(card, true); } : null,
        footNote: 'We grade condition when you bring the cards in. Review & get your cash / store-credit offer on the sell list.',
        onConfirm: function(picks){ sellAddPrintings(card, game, picks); }
      });
      return;
    }
    // Fallback (picker snippet not on the page): the original finish + qty form.
    // Finish choices are game-scoped: Pokémon splits Normal / Holofoil / Reverse
    // Holofoil (priced independently); Magic is nonfoil / foil.
    var finishes;
    if (game === 'POKEMON') {
      finishes = [['normal','Normal'],['holofoil','Holofoil'],['reverse_holofoil','Reverse Holofoil']];
    } else {
      // Offer finish choices from the card's actual rows when known, else both. Etched is a
      // DISTINCT product from traditional foil and prices very differently (STA #76: foil vs
      // etched can be ~2×), so surface it separately when the card has an etched row — never
      // fold it into "Foil" (that mislabels the submission and overpays on the buy side).
      var hasEtched = (card.rows||[]).some(function(r){ return r.finish && r.finish.key === 'etched'; });
      var hasFoil = (card.rows||[]).some(function(r){ return r.finish && r.finish.foil && r.finish.key !== 'etched'; });
      var hasNon  = (card.rows||[]).some(function(r){ return r.finish && !r.finish.foil; });
      finishes = [];
      if (hasNon || (!hasFoil && !hasEtched)) finishes.push(['nonfoil','Non-Foil']);
      if (hasFoil) finishes.push(['foil','Foil']);
      if (hasEtched) finishes.push(['etched','Etched']);
      if (!finishes.length) finishes = [['nonfoil','Non-Foil'],['foil','Foil']];
    }
    var fieldCss = 'width:100%;margin-top:3px;padding:.5rem;border:1px solid rgba(28,23,18,.2);border-radius:7px;font-family:var(--font-body,sans-serif)';
    body.innerHTML =
      '<div style="font-family:var(--font-body,sans-serif);color:#1C1712">' +
        '<div style="font-size:.8rem;color:#8A8378;margin-bottom:.8rem">' + sellEsc(card.set || '') + (card.number ? ' · #' + sellEsc(card.number) : '') + '</div>' +
        '<div style="display:flex;gap:.6rem;margin-bottom:.9rem">' +
          '<label style="flex:1;font-size:.74rem;color:#5b5448">Finish<select id="cs-sell-finish" style="' + fieldCss + '">' +
            finishes.map(function(f){ return '<option value="'+f[0]+'">'+f[1]+'</option>'; }).join('') + '</select></label>' +
          '<label style="width:64px;font-size:.74rem;color:#5b5448">Qty<input id="cs-sell-qty" type="number" min="1" value="1" style="' + fieldCss + '"></label>' +
        '</div>' +
        '<button id="cs-sell-add" style="width:100%;font-family:var(--font-display,sans-serif);font-weight:700;border:none;background:#D8A43C;color:#1C1712;border-radius:7px;padding:.75rem;cursor:pointer">Add to sell list</button>' +
        '<div style="font-size:.72rem;color:#8A8378;margin-top:.55rem;text-align:center">We grade condition when you bring the cards in. Review &amp; get your cash / store-credit offer on the sell list.</div>' +
      '</div>';
    $('cs-sell').style.display = 'flex';
    $('cs-sell-add').onclick = function(){ sellAddToDraft(card, game); };
  }
  // Derive the (set code, number) that pins a printing on quote. Normally the search
  // doc carries set_code/collector_number, but a doc whose Scryfall join failed at index
  // time has both blank — its Model-A SKU (MTG-<SET>-<NUM>-…) and handle still encode the
  // printing, so fall back to those. (Mirrors pinFromDoc in sections/buylist.liquid.)
  function sellPinFromDoc(doc){
    var set = (doc.set_code || '').toLowerCase(), num = doc.collector_number || '';
    if (set && num) return { set: set, number: num };
    var sku = '', cs = doc.conditions || [];
    for (var k=0;k<cs.length;k++){ if (cs[k] && cs[k].sku){ sku = cs[k].sku; break; } }
    var m = String(sku).toUpperCase().match(/^[A-Z]+-([A-Z0-9]+)-([0-9][^-]*)/);
    if (m) return { set: m[1].toLowerCase(), number: m[2] };
    var hm = String(doc.handle || '').match(/-([a-z0-9]+)-([0-9][a-z0-9]*)$/i);
    if (hm) return { set: hm[1].toLowerCase(), number: hm[2] };
    return { set: set, number: num };
  }
  // Commit everything the seller counted up in the tile modal: one draft line per
  // printing+finish, qty = how many times they tapped it.
  function sellAddPrintings(card, game, picks){
    if (!window.SellDraft || !picks || !picks.length) return;
    var n = 0;
    picks.forEach(function(p){ sellAddPrinting(card, game, p.doc, p.finish, p.qty); n += Math.max(1, p.qty || 1); });
    toast('Added ' + n + ' card' + (n===1?'':'s') + ' to sell list', {ok:true});
  }
  // Add one picked printing to the sell draft. Condition isn't chosen here — the store
  // audits the real grade at intake; qty/offer stay editable on the sell list.
  function sellAddPrinting(card, game, doc, finish, qty){
    if (!window.SellDraft) return;
    var pin = sellPinFromDoc(doc);
    var fin = finish || (game === 'MTG' ? 'nonfoil' : 'normal');
    window.SellDraft.add({
      name: doc.name || card.name,
      setName: doc.set_name || card.set || '',
      setCode: pin.set || '',
      number: pin.number || '',
      finish: fin,
      // Condition is not picked by the shopper — everything comes in as LP and the
      // store audits the real grade at intake. (LP pays the same as NM.)
      condition: 'LP',
      qty: Math.max(1, qty || 1),
      game: game,
      image: doc.image_url || card.image || '',
      // Display-only, but the whole reason a seller can tell their borderless surge foil
      // apart from the plain printing once both are sitting in the sell list. Scoped to the
      // picked finish — a dual-finish printing carries the foil-layer label on the printing,
      // so the plain nonfoil copy would otherwise be listed as the surge foil it isn't.
      treatments: (window.PrintingUtils && window.PrintingUtils.treatmentsForFinish
        ? window.PrintingUtils.treatmentsForFinish(window.PrintingUtils.treatmentsOf(doc), fin)
        : (doc.treatments || [])),
    });
  }
  function sellAddToDraft(card, game){
    if (!window.SellDraft) return;
    window.SellDraft.add({
      name: card.name,
      setName: card.set || '',
      number: card.number || '',
      finish: $('cs-sell-finish').value,
      // Condition is no longer picked by the shopper — everything comes in as LP
      // and the store audits the real grade at intake. (LP pays the same as NM.)
      condition: 'LP',
      qty: Math.max(1, parseInt($('cs-sell-qty').value, 10) || 1),
      game: game,
      image: card.image || '',
    });
    closeSell();
    toast('Added to sell list', {ok:true});
  }
  function closeSell(){ $('cs-sell').style.display = 'none'; }

  // ── Cart add (native theme cart) — resolves true on success, false on error ──
  function addToCart(items, note){
    return fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function(r){ if (!r.ok) return r.json().then(function(e){ throw new Error(e.description || 'cart'); }); return r.json(); })
      .then(function(){ refreshCart(); toast(note || 'Added to cart', 'cart'); return true; })
      .catch(function(err){ toast(err && err.message ? err.message : 'Could not add to cart', 'error'); return false; });
  }
  function refreshCart(){
    fetch('/cart.js', { headers:{ 'Accept':'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(c){
        // One read serves both the badge and the shared per-variant ledger the
        // steppers cap against.
        TTT.cart.sync(c);
        var el = $('cs-cart-count'); if (!el) return;
        el.textContent = c.item_count;
        el.setAttribute('data-empty', c.item_count > 0 ? '0' : '1');
      }).catch(function(){});
  }
  // toast() is provided globally by assets/ttt-utils.js (this file's original
  // toast was promoted to that shared util). Loaded before this asset runs.
  var toast = window.toast;

  // ── Empty / skeleton state ──
  function skel(w, h, extra){
    var d = document.createElement('div');
    d.className = 'cs-skel';
    d.style.cssText = 'width:' + w + ';height:' + h + ';' + (extra||'');
    return d;
  }
  function skeletonTable(){
    var table = document.createElement('table');
    table.style.cssText = 'width:100%;border-collapse:separate;border-spacing:0';
    var tbody = document.createElement('tbody');
    for (var r=0; r<6; r++){
      var tr = document.createElement('tr');
      tr.style.cssText = 'border-bottom:1px solid rgba(28,23,18,.06)';
      // card cell
      var c1 = document.createElement('td');
      c1.style.cssText = 'padding:.65rem .75rem';
      var wrap = document.createElement('div');
      wrap.style.cssText = 'display:flex;align-items:center;gap:.7rem';
      wrap.appendChild(skel('44px','61px'));
      var lines = document.createElement('div');
      lines.appendChild(skel('130px','11px','margin-bottom:6px'));
      lines.appendChild(skel('80px','9px'));
      wrap.appendChild(lines); c1.appendChild(wrap); tr.appendChild(c1);
      // finish
      var c2 = document.createElement('td'); c2.style.cssText='padding:.65rem .75rem';
      c2.appendChild(skel('64px','18px','border-radius:999px')); tr.appendChild(c2);
      // condition cells
      for (var k=0;k<5;k++){
        var td = document.createElement('td'); td.style.cssText='padding:.65rem .75rem;text-align:center';
        var b = skel('38px','13px','margin:0 auto'); td.appendChild(b); tr.appendChild(td);
      }
      // action
      var c3 = document.createElement('td'); c3.style.cssText='padding:.65rem .75rem;text-align:right';
      c3.appendChild(skel('92px','26px','border-radius:999px;display:inline-block')); tr.appendChild(c3);
      tbody.appendChild(tr);
    }
    table.appendChild(tbody);
    return table;
  }
  function renderEmpty(){
    var box = $('cs-results'); box.innerHTML = '';
    $('cs-status').textContent = '';
    $('cs-recs-wrap').style.display = 'none';
    var wrap = document.createElement('div');
    wrap.style.cssText = 'position:relative;min-height:340px';
    wrap.appendChild(skeletonTable());

    var overlay = document.createElement('div');
    overlay.className = 'cs-empty';
    var card = document.createElement('div');
    card.className = 'cs-empty-card';
    card.innerHTML =
      '<svg width="38" height="38" viewBox="0 0 24 24" fill="none" stroke="#D8A43C" stroke-width="1.8" stroke-linecap="round" style="margin:0 auto">' +
        '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.3-4.3"/></svg>' +
      '<h3>Search our card inventory</h3>' +
      '<p>Type a card name to see live prices and stock for every condition and finish. ' +
      'Pick a game on the left to narrow it down, then filter by finish, condition, or price.</p>';
    var egg = document.createElement('div');
    egg.className = 'cs-egg';
    ['Lightning Bolt','Tunnel Rats','99 Puppies'].forEach(function(t){
      var b = document.createElement('button');
      b.textContent = t;
      b.onclick = function(){ $('cs-q').value = t; doSearch(); };
      egg.appendChild(b);
    });
    var hint = document.createElement('div');
    hint.style.cssText = 'font-family:var(--font-body,sans-serif);font-size:.75rem;color:#b3ac9f;margin-bottom:.5rem';
    hint.textContent = 'Try one:';
    card.appendChild(hint); card.appendChild(egg);
    overlay.appendChild(card);
    wrap.appendChild(overlay);
    box.appendChild(wrap);
  }

  // ── Recommendations carousel ──
  function inStockSummary(card){
    var qs = [], ps = [];
    card.rows.forEach(function(r){ COLS.forEach(function(c){ var cell = r.cells[c.code]; if (cell && cell.qty > 0){ qs.push(cell.qty); ps.push(cell.price); } }); });
    if (!ps.length) return null;
    return { qty: qs.reduce(function(a,b){ return a+b; }, 0), lo: Math.min.apply(null, ps), hi: Math.max.apply(null, ps) };
  }
  function fetchRecs(q){
    return gql(SEARCH_Q, { q:q }).then(function(res){
      if (res.errors || !res.data) return [];
      return mergeCards((res.data.products.nodes||[]).map(normalize)).filter(function(c){ return inStockSummary(c); });
    }).catch(function(){ return []; });
  }
  function loadRecommendations(resultCards){
    var wrap = $('cs-recs-wrap');
    if (!resultCards.length){ wrap.style.display = 'none'; return; }
    var seen = {}; resultCards.forEach(function(c){ seen[c.id] = 1; });
    var game = resultCards[0].game;
    var esc = function(s){ return String(s).replace(/'/g,''); };
    // Format-aware: respect the active Format filter so recs match its legality
    // (e.g. Premodern → only Premodern-legal cards are recommended).
    var fmtFrag = '', fmtLabel = '';
    if (game === 'MTG Single' && facetState['Format'] && facetState['Format'].size){
      var fors = []; facetState['Format'].forEach(function(f){ fors.push("tag:'" + esc(f) + "'"); });
      fmtFrag = ' AND (' + fors.join(' OR ') + ')';
      fmtLabel = Array.from(facetState['Format']).join('/');
    }
    // Carry the active advanced facets (color/rarity/type/super/subtype) into the
    // recs so "you might also like" matches what the shopper filtered to.
    var advFrag = '', advLabel = [];
    if (game === 'MTG Single'){
      var cf = mtgColorFrag(); if (cf) advFrag += ' AND ' + cf;
      var rf = mtgNsFrag('Rarity', ' OR '); if (rf) advFrag += ' AND ' + rf;
      var tf = mtgNsFrag('Type', ' OR '); if (tf) advFrag += ' AND ' + tf;
      var pf = mtgNsFrag('Supertype', ' AND '); if (pf) advFrag += ' AND ' + pf;
      var bf = mtgNsFrag('Subtype', subtypeJoiner()); if (bf) advFrag += ' AND ' + bf;
      ['Color','Rarity','Type','Supertype','Subtype'].forEach(function(ns){ if (facetState[ns]) facetState[ns].forEach(function(v){ advLabel.push(v); }); });
    }
    var inStockGame = "product_type:'" + esc(game) + "' AND available_for_sale:true" + fmtFrag + advFrag;

    // Recommend more from the SAME SET as the best-matching result. resultCards is
    // relevance-sorted, so we take the set of the top result. (Dual tag convention:
    // prod tags the set name flat, the dev seed uses Set_<name>.)
    var setVal = '', setLabel = '';
    for (var i = 0; i < resultCards.length; i++){
      var sv = tagVal(resultCards[i].tags || [], 'Set') || resultCards[i].set;
      if (sv){ setVal = sv; setLabel = resultCards[i].set || sv; break; }
    }
    var primaryQ = setVal ? inStockGame + " AND (tag:'" + esc(setVal) + "' OR tag:'Set_" + esc(setVal) + "')" : inStockGame;

    var setCount = 0;   // how many recs actually came from the seed set
    fetchRecs(primaryQ).then(function(list){
      var recs = list.filter(function(c){ return !seen[c.id] && !isBannedInActiveFormats(c.name); });
      setCount = recs.length;
      if (recs.length >= 6 || !setVal) return recs;
      // not enough in the set — top up with other in-stock cards from the game
      return fetchRecs(inStockGame).then(function(more){
        more.forEach(function(c){ if (!seen[c.id] && !isBannedInActiveFormats(c.name) && !recs.some(function(r){ return r.id===c.id; })) recs.push(c); });
        return recs;
      });
    }).then(function(recs){
      recs = recs.slice(0, 15);
      // Need a couple to make a carousel worth showing; below that it reads as broken.
      if (recs.length < 2){ wrap.style.display = 'none'; return; }
      var gameLabel = game.replace(/ Singles?$/,'');
      var descr = []; if (fmtLabel) descr.push(fmtLabel); advLabel.forEach(function(l){ descr.push(l); });
      var prefix = descr.length ? (descr.join(' ') + ' ' + gameLabel) : gameLabel;
      // Only claim "from <set>" when the set genuinely supplied most of the strip —
      // otherwise it's a topped-up grab-bag and the honest label is the generic one.
      var fromSet = setLabel && setCount >= 3 && setCount >= recs.length / 2;
      $('cs-recs-sub').textContent = fromSet
        ? 'More in-stock ' + prefix + ' from ' + setLabel
        : 'In-stock ' + prefix + ' cards';
      renderRecs(recs);
      wrap.style.display = 'block';
    });
  }
  function renderRecs(recs){
    var strip = $('cs-recs'); strip.innerHTML = '';
    recs.forEach(function(card){
      var s = inStockSummary(card); if (!s) return;
      var tile = document.createElement('div');
      tile.style.cssText = 'flex:0 0 auto;width:132px;cursor:pointer;scroll-snap-align:start';
      tile.onclick = function(){ (card.kind === 'product' ? openProductDetail : openCart)(card); };
      var imgwrap = document.createElement('div');
      imgwrap.style.cssText = 'position:relative;border-radius:8px;overflow:hidden;background:#e9e5dd;aspect-ratio:5/7;box-shadow:0 2px 8px rgba(0,0,0,.16)';
      if (card.image){
        var img = document.createElement('img'); img.src = card.image; img.alt = card.name; img.loading = 'lazy';
        img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block';
        imgwrap.appendChild(img);
      }
      var ov = document.createElement('div');
      ov.style.cssText = 'position:absolute;left:0;right:0;bottom:0;padding:.45rem .55rem;background:linear-gradient(180deg,rgba(0,0,0,0),rgba(0,0,0,.8));color:#fff;font-family:var(--font-body,sans-serif)';
      ov.innerHTML = '<div style="font-weight:700;font-size:.82rem">' + (s.lo===s.hi?fmt(s.lo):fmt(s.lo)+'–'+fmt(s.hi)) + '</div>' +
        '<div style="font-size:.68rem;opacity:.85">' + s.qty + ' in stock</div>';
      imgwrap.appendChild(ov);
      tile.appendChild(imgwrap);
      var nm = document.createElement('div');
      nm.textContent = card.name;
      nm.style.cssText = 'font-family:var(--font-display,sans-serif);font-weight:600;font-size:.78rem;color:#1C1712;margin-top:.4rem;line-height:1.18;white-space:nowrap;overflow:hidden;text-overflow:ellipsis';
      tile.appendChild(nm);
      strip.appendChild(tile);
    });
  }

  // ── Autocomplete (predictive search: name + thumbnail) ──
  // productType lets a suggestion click align the game selector (see applyAcGame);
  // totalInventory + availableForSale power the stock label on the right of each row
  // (see acStockLabel). Both need the `unauthenticated_read_product_inventory` scope,
  // which this Storefront token holds — but note that ANY field the token can't read
  // puts `errors` on the response, and fetchAC treats that as "no suggestions at all".
  var AC_Q = 'query AC($q:String!){ predictiveSearch(query:$q, limit:8, types:PRODUCT){ products{ title handle productType availableForSale totalInventory featuredImage{ url } } } }';
  var acItems = [], acIndex = -1, acTimer = null, acMode = 'name', acGen = 0;
  // Vanity/reskin card rows ("Ifrit (Fury)") sourced from the index (/api/search) — the
  // Shopify predictiveSearch below only matches product TITLES, which never carry the
  // printed vanity name, so those hits would otherwise never appear in the typeahead.
  var acVanity = [];
  // Filter-intent rows shown ABOVE the card suggestions when the typed term matches a
  // known facet value (rarity, color, set, …) — computed synchronously on input, so
  // they render instantly while the async predictive card lookup is still in flight.
  var acBareComps = [], acLastProducts = [];
  function acCleanTerm(title){ return String(title).replace(/\s*[\[(].*$/, '').trim() || String(title); }
  // Hide the dropdown WITHOUT invalidating in-flight lookups. One keystroke fans out to
  // TWO sources (Shopify predictive + the index's vanity rows); whichever answers first
  // may legitimately have nothing to paint, and it must not cancel the other one.
  function hideAC(){ var b = $('cs-ac'); if (b){ b.classList.remove('open'); b.innerHTML = ''; } acItems = []; acIndex = -1; }
  // Bump acGen on close so a slow in-flight lookup that resolves later can't re-open
  // the dropdown over a newer query (or after the user cleared / blurred the box).
  // For user-initiated closes only (Escape / blur / picked a row / cleared the box) —
  // an empty PAINT must use hideAC, or it kills its own keystroke's other request.
  function closeAC(){ acGen++; acBareComps = []; acLastProducts = []; acVanity = []; hideAC(); }
  // Vanity rows search the real (oracle) name so the result set resolves under either
  // search source — Enter/click on "Ifrit (Fury)" runs a "Fury" search that surfaces
  // every printing, the reskin among them (shown as "Ifrit (Fury)").
  // Choosing a suggestion is a request for THAT card, not merely for its name as a
  // search term — so remember it and guarantee it ends up on screen (checkPinned).
  function chooseAC(p){
    applyAcGame(p.productType);
    var term = p.__vanity ? p.term : acCleanTerm(p.title);
    $('cs-q').value = term;
    pendingPin = term;
    closeAC(); doSearch();
  }
  // Which game a suggestion belongs to, from either source's vocabulary: the
  // Storefront productType ("MTG Single", "Star Wars: Unlimited Single") or the
  // index's shorter `game` ("MTG", "SWU"). Matched loosely on purpose — the sealed
  // and accessory product types carry the same game words.
  function gameKey(s){
    var t = String(s || '');
    if (/pokemon|pok\u00e9mon/i.test(t)) return 'pokemon';
    if (/riftbound/i.test(t))             return 'riftbound';
    if (/star wars|swu/i.test(t))         return 'swu';
    if (/\bmtg\b|magic/i.test(t))         return 'mtg';
    return null;
  }
  // The game's mark, sized to sit beside the stock count. Pokemon is drawn inline
  // (there is no single-colour pokeball asset); the rest come from theme assets via
  // CS_CONFIG. Decorative — the row already names the card, so it stays aria-hidden.
  var POKEBALL = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="10" fill="#fff" stroke="#1C1712" stroke-width="2"/>' +
    '<path d="M2.4 11.2a9.7 9.7 0 0 1 19.2 0z" fill="#EE1515"/>' +
    '<line x1="2" y1="12" x2="9" y2="12" stroke="#1C1712" stroke-width="2"/>' +
    '<line x1="15" y1="12" x2="22" y2="12" stroke="#1C1712" stroke-width="2"/>' +
    '<circle cx="12" cy="12" r="3.3" fill="#fff" stroke="#1C1712" stroke-width="2"/></svg>';
  // Always returns an element, even for an unrecognised game: the mark sits at the END
  // of the row now, so an empty slot is what keeps the stock counts lined up in a
  // column instead of jostling by 16px depending on whether we knew the game.
  function gameIconEl(src){
    var k = gameKey(src), url = k && k !== 'pokemon' ? CFG.gameIcons[k] : null;
    if (k === 'pokemon' || !url){
      var sp = document.createElement('span');
      sp.className = 'cs-ac-game'; sp.setAttribute('aria-hidden','true');
      if (k === 'pokemon') sp.innerHTML = POKEBALL;
      return sp;
    }
    var im = document.createElement('img');
    im.className = 'cs-ac-game'; im.src = url; im.alt = ''; im.setAttribute('aria-hidden','true');
    return im;
  }
  // Right-hand slot on a suggestion row: units on hand, where a price used to sit.
  // Shopify rows carry totalInventory (summed across the printing's condition
  // variants); index-sourced vanity rows bring their own `qty` from total_qty.
  //
  // availableForSale is checked FIRST so an untracked variant — inventory 0 but
  // perfectly purchasable — is never labelled "Out of stock". A count only ever
  // replaces "In stock" when we actually have one; nothing here invents a number.
  function acStockLabel(p){
    if (!p) return null;
    if (p.availableForSale === false) return { text: 'Out of stock', oos: true };
    var n = (p.qty != null) ? p.qty : p.totalInventory;
    if (n != null && n > 0) return { text: n + ' in stock', oos: false };
    if (p.availableForSale === true) return { text: 'In stock', oos: false };
    if (n === 0) return { text: 'Out of stock', oos: true };
    return null;
  }
  // Picking a specific card from the typeahead aligns the game selector — and therefore
  // the advanced Set/Rarity/Energy panel + set browser — to that card's game, so a shopper
  // who chooses a Pokémon card lands on Pokémon tools instead of the default Magic ones.
  // Only the single-game product types we have panels for switch; a missing/other type
  // leaves the current selection untouched (unchanged behavior for those).
  function applyAcGame(productType){
    if (!productType || !GAME_CODE[productType]) return;          // not one of our single-game TCGs
    if (selGames.size === 1 && selGames.has(productType)) return; // already scoped to it
    selGames = new Set([productType]);
    // A game switch is a fresh context — drop the previous game's server-side filters so a
    // stale tag (e.g. an MTG Set) can't hide everything in the newly selected game. Mirrors
    // the game-dropdown handler.
    for (var gns in facetState){ if (MTG_SERVER_NS[gns] || gns === 'Energy' || gns === 'Series') delete facetState[gns]; }
    ADV.cmode = 'or'; ADV.cexc = new Set(); ADV.submode = 'or';
    if (typeof SETB !== 'undefined'){ SETB.sel = {}; SETB.fmtSel = {}; }
    // Picking a suggestion normally hands the view choice back to the auto-picker —
    // but Sell is a mode the seller is deliberately in, not a layout preference, so
    // a game switch must not quietly drop them back into the buy-side list.
    if (!sellMode()) viewExplicit = false;
    if (typeof renderFilterUI === 'function') renderFilterUI();
    if (typeof updateSetBrowseVisibility === 'function') updateSetBrowseVisibility();   // rebuilds the advanced panel for the new game
    if (typeof syncUrl === 'function') syncUrl();
  }
  function setAcActive(i){
    acIndex = i;
    var nodes = $('cs-ac').children;
    for (var k=0;k<nodes.length;k++) nodes[k].classList.toggle('cs-ac-active', k===i);
    if (nodes[i]) nodes[i].scrollIntoView({ block:'nearest' });
  }
  // "Uppercase kind" badge shown at the right of a filter row (energy reads as "Type").
  var BARE_KIND_LABEL = { color:'Color', rarity:'Rarity', type:'Type', supertype:'Type', subtype:'Subtype', format:'Format', set:'Set', energy:'Energy', series:'Series', treatment:'Finish' };
  function bareFilterRow(o, idx){
    var it = document.createElement('div'); it.className = 'cs-ac-item cs-ac-filt'; it.setAttribute('role','option');
    var pips = o.colors ? '<span style="display:inline-flex;gap:3px">' + o.colors.map(function(c){ return '<span class="cs-pip" style="width:20px;height:20px;font-size:.62rem;border-width:1px" data-c="' + c + '">' + c + '</span>'; }).join('') + '</span>' : '';
    it.innerHTML = pips + '<span class="cs-ac-name">' + o.label + '</span>' +
      '<span class="cs-ac-kind">' + (BARE_KIND_LABEL[o.kind] || o.kind) + ' filter</span>';
    it.onmousedown = function(e){ e.preventDefault(); applyBareFilter(o); };  // mousedown beats input blur
    it.onmouseenter = function(){ setAcActive(idx); };
    return it;
  }
  // fetchAC feeds new card suggestions here; we stash the game-scoped set and repaint.
  // Kept separate from showAC so filter rows can update on their own keystroke WITHOUT
  // discarding the cards already on screen (a bare renderAC([]) used to blank them).
  function renderAC(products){
    acLastProducts = (products || []).slice(0, 8);   // all games, as before — filter rows just sit on top
    showAC();
  }
  // Paint the dropdown = current filter rows (acBareComps) + current card rows
  // (acLastProducts). Either may be empty; only fully-empty closes the box.
  function showAC(){
    var comps = acBareComps || [];
    // Vanity/reskin hits lead the card rows so a shopper typing the printed name sees it
    // first; the Shopify predictive products follow.
    var cards = (acVanity || []).concat(acLastProducts || []);
    acItems = comps.concat(cards); acIndex = -1;   // no auto-highlight: a plain Enter still text-searches
    var box = $('cs-ac'); box.innerHTML = '';
    if (!acItems.length){ hideAC(); return; }   // hide, don't close: the sibling lookup is still coming
    comps.forEach(function(o, i){ box.appendChild(bareFilterRow(o, i)); });
    cards.forEach(function(p, j){
      var i = comps.length + j;
      var it = document.createElement('div'); it.className = 'cs-ac-item cs-ac-pred' + (p.__vanity ? ' cs-ac-vanity' : ''); it.setAttribute('role','option');
      var img = document.createElement('img'); img.alt = ''; img.loading = 'lazy'; if (p.featuredImage) img.src = p.featuredImage.url;
      var nm = document.createElement('div'); nm.className = 'cs-ac-name'; nm.textContent = p.title;
      it.appendChild(img); it.appendChild(nm);
      var st = acStockLabel(p);
      if (st){ var q = document.createElement('div'); q.className = 'cs-ac-qty' + (st.oos ? ' cs-ac-oos' : ''); q.textContent = st.text; it.appendChild(q); }
      it.appendChild(gameIconEl(p.gameSrc || p.productType));
      it.onmousedown = function(e){ e.preventDefault(); chooseAC(p); };  // mousedown beats input blur
      it.onmouseenter = function(){ setAcActive(i); };
      box.appendChild(it);
    });
    box.classList.add('open');
  }
  // No card suggestions (error, or none matched) shouldn't kill the filter rows or the
  // vanity hits — keep the box open on those alone; only close when there's nothing at all.
  function acNoProducts(){ acLastProducts = []; if (acBareComps.length || acVanity.length) showAC(); else hideAC(); }
  /* Sell-mode typeahead source.
   *
   * predictiveSearch (below) only knows products that exist in the store, so it
   * silently omits exactly the cards a seller is most likely to be holding — the
   * ones we've never carried. Source the rows from the index instead, which has the
   * whole catalog, and drop the "from $X" price (a buy-side price is the wrong
   * number to show someone who is selling).
   *
   * The index is one doc per PRINTING, so dedupe by card name — a dropdown listing
   * "Sol Ring" eight times is useless. Over-fetch so there are still enough distinct
   * names left after the collapse.
   */
  function fetchSellAC(term, gen){
    if (!API_BASE){ acNoProducts(); return; }
    var url = API_BASE.replace(/\/+$/, '') + '/api/search?per_page=40&game=all&q=' + encodeURIComponent(term);
    fetch(url).then(function(r){ return r.json(); }).then(function(res){
      if (gen !== acGen) return;   // superseded by a newer keystroke
      // One shared row builder with the sell page's typeahead: collapses the index's
      // per-printing docs to one row per card and labels reskins "Ifrit (Fury)".
      var rows = window.PrintingUtils.vanityAcRows((res && res.results) || [], term, 8);
      renderAC(rows.map(function(r){
        return {
          title: r.label,
          term: r.name,          // chooseAC searches the real name → every printing
          __vanity: r.vanity,
          productType: r.game === 'Pokemon' ? 'Pokemon Single' : 'MTG Single',
          featuredImage: r.image ? { url: r.image } : null,
          gameSrc: r.game,       // true game for the icon; productType above is MTG/Pokemon only
          qty: null              // what WE hold is not the number a seller came to see
        };
      }));
    }).catch(function(){ if (gen === acGen) acNoProducts(); });
  }
  function fetchAC(term){
    var gen = ++acGen;
    // Sell mode builds vanity rows inline (its index query already matches printed
    // names), so running fetchVanityAC too would list the same reskin twice.
    if (sellMode()){ acVanity = []; fetchSellAC(term, gen); return; }
    fetchVanityAC(term, gen);   // parallel index lookup for printed/vanity names
    gql(AC_Q, { q: term }).then(function(res){
      if (gen !== acGen) return;   // a newer keystroke (or a close) superseded this lookup
      if (res.errors || !res.data || !res.data.predictiveSearch){ acNoProducts(); return; }
      renderAC(res.data.predictiveSearch.products || []);
    }).catch(function(){ if (gen === acGen) acNoProducts(); });
  }
  // Supplemental typeahead source: query the index for cards whose PRINTED (vanity) name
  // matches the term but whose real name does NOT — the rows predictiveSearch (title-only)
  // can't surface. Rendered as "Ifrit (Fury)". Needs the index API; game=all so a Magic or
  // Pokémon reskin shows regardless of the current game scope (clicking realigns the game).
  function fetchVanityAC(term, gen){
    if (!API_BASE || term.length < 3){ acVanity = []; return; }
    var url = API_BASE.replace(/\/+$/, '') + '/api/search?per_page=6&game=all&q=' + encodeURIComponent(term);
    fetch(url).then(function(r){ return r.json(); }).then(function(res){
      if (gen !== acGen) return;
      var t = term.toLowerCase(), seen = {};
      acVanity = ((res && res.results) || []).filter(function(d){
        return d.flavor_name && d.flavor_name.toLowerCase().indexOf(t) !== -1
          && String(d.name || '').toLowerCase().indexOf(t) === -1;
      }).filter(function(d){
        var k = (d.flavor_name + '|' + d.name).toLowerCase(); if (seen[k]) return false; seen[k] = 1; return true;
      }).slice(0, 4).map(function(d){
        return { __vanity: true, title: d.flavor_name + ' (' + d.name + ')', term: d.name,
          productType: d.game === 'Pokemon' ? 'Pokemon Single' : 'MTG Single',
          featuredImage: d.image_url ? { url: d.image_url } : null,
          gameSrc: d.game,       // true game for the icon (SWU/Riftbound included)
          handle: d.handle, qty: d.total_qty };
      });
      showAC();
    }).catch(function(){ if (gen === acGen){ acVanity = []; showAC(); } });
  }

  // ── Search ──
  function beginLoad(msg){
    if (!keepFilters){
      // Client-side facets (Rarity, Color…) are derived per result set, so they
      // reset on a new search. Set/Format are server-side, session-level filters
      // (the set browser) — keep them so "show me Premodern" sticks across
      // searches until cleared via a chip. Cleared on game change (see handler).
      var keep = {};
      // All server-side, session-level MTG filters persist across searches until
      // cleared (Set/Format + the advanced Color/Rarity/Type/Supertype/Subtype).
      for (var kns in facetState){ if (serverNs(kns)) keep[kns] = facetState[kns]; }
      facetState = keep;
    }
    keepFilters = false;
    $('cs-status').textContent = msg;
    $('cs-results').innerHTML = '';
    $('cs-results').appendChild(skeletonTable());
    $('cs-recs-wrap').style.display = 'none';
    // keep the drawer + Filters button on mobile (it holds the folded controls)
    $('cs-facets').style.display = isMobile() ? '' : 'none';
    $('cs-facets-toggle').style.display = isMobile() ? 'inline-flex' : 'none';
    $('cs-chips').style.display = 'none';
    $('cs-more').style.display = 'none';
    $('cs-cond-notice').style.display = 'none';
  }
  // A search (PAGE.fetchAll) pulls EVERY page up front so the whole result set can be
  // sorted — not just the first page. Browse keeps lazy "Load more" paging because those
  // sets can be huge. FETCH_ALL_MAX is a safety valve for an over-broad search term.
  var FETCH_ALL_MAX = 1500;   // max raw products pulled for one search
  var searchGen = 0;          // bumped on each fresh search/browse; in-flight pages from a superseded query are dropped
  // Fetch one page for the current PAGE query. append=false starts fresh; append=true loads the next page.
  // ── M3 API-search path (ttt-backend /api/search over Typesense) ─────────────────
  // Active only when search_source='api' and MTG singles are the sole game/category.
  // Maps the SAME filter state the Storefront path uses into /api/search params, and
  // maps index docs back into the card shape the renderer already expects (rows/cells
  // with variantId for add-to-cart; facets for display). Facet counts come from the
  // server (accurate over the whole filtered set, not just the loaded page).
  var SERVER_FACETS = null, apiPage = 1;
  var apiFallback = false;   // see checkIndexFallback / useApiSearch
  // The Sell view forces the index API regardless of the configured search source: only
  // the M3 index carries the out-of-stock catalog, and when SELLING the printings we
  // don't stock are most of the point. It also needs catalog_finishes, which the
  // Storefront path has no way to supply.
  function useApiSearch(){
    // One-shot escalation set by checkIndexFallback: the Storefront path found nothing,
    // so retry against the index, which carries the catalogue rather than just our shelf.
    if (apiFallback && API_BASE && !isProductCat()) return true;
    if (sellMode()) return !!API_BASE;
    return SEARCH_SRC === 'api' && !!API_BASE && (mtgOnly() || pokemonOnly() || allGamesSingles()) && !isProductCat();
  }
  var C2CODE = { White:'W', Blue:'U', Black:'B', Red:'R', Green:'G', Colorless:'C' };
  var CODE2C = { W:'White', U:'Blue', B:'Black', R:'Red', G:'Green' };
  function capW(s){ s = String(s); return s.charAt(0).toUpperCase() + s.slice(1); }
  function buildApiParams(page){
    var p = ['per_page=48', 'page=' + (page || 1)];
    // Selling is the one view where a not-yet-released printing is worth showing: the
    // tile explains we're not buying that set yet. Shopping keeps them hidden.
    if (sellMode()) p.push('include_unreleased=1');
    /* Don't ASK the server for a filter we've already decided to widen.
     *
     * `relaxed=` below tells the server to drop them, but that param is new — an older
     * backend ignores it and would keep filtering, so a widened search would silently
     * do nothing. Omitting the params outright makes the widening work against any
     * version of the API, and leaves `relaxed=` as the belt-and-braces signal. */
    var pk = pokemonOnly();
    if (relaxed('game')) p.push('game=all');
    else if (pk) p.push('game=Pokemon');
    else if (!mtgOnly()) p.push('game=all');   // all-games singles → mixed MTG+Pokémon index results (default MTG stays implicit)
    var term = ($('cs-q').value || '').trim();
    if (term) p.push('q=' + encodeURIComponent(term));
    var noFacets = relaxed('filters');
    var inc = noFacets ? null : facetState['Color'], cs = [];
    if (inc) inc.forEach(function(v){ if (C2CODE[v]) cs.push(C2CODE[v]); });
    if (cs.length) p.push('color=' + cs.join(','));
    if (!noFacets && (ADV.cmode === 'exact' || ADV.cmode === 'commander')) p.push('cmode=' + ADV.cmode);
    var cx = []; if (ADV.cexc && !noFacets) ADV.cexc.forEach(function(v){ if (C2CODE[v]) cx.push(C2CODE[v]); });
    if (cx.length) p.push('colorx=' + cx.join(','));
    function ns(name, key, xf){ if (noFacets) return; var s = facetState[name]; if (!s || !s.size) return; var a = []; s.forEach(function(v){ a.push(xf ? xf(v) : v); }); p.push(key + '=' + encodeURIComponent(a.join(','))); }
    // MTG rarity is stored lowercase (Scryfall); Pokémon rarity keeps its cased label
    // ("Double Rare") in the index — so only downcase for Magic.
    ns('Rarity', 'rarity', pk ? null : function(v){ return v.toLowerCase(); });
    ns('Type', 'type');
    ns('Supertype', 'supertype');
    ns('Subtype', 'subtype');
    // Pokémon-only dimensions (energy type + series/era).
    if (pk){ ns('Energy', 'energy'); ns('Series', 'series'); }
    ns('Keyword', 'keyword');
    ns('Treatment', 'treatment');
    // Sent as CODES: the chip reads "Japanese", the index stores "ja". Same shape as Set, which
    // sends the set code rather than the name for exactly the same reason.
    ns('Language', 'language', langCode);
    // Sets: send the stable set CODE when the catalog knows it (robust to name
    // variants — Storepass vs Scryfall, colon, etc.); name only for unknown sets.
    var setS = noFacets ? null : facetState['Set'];
    if (setS && setS.size){
      var setCodes = [], setNames = [];
      setS.forEach(function(v){
        var c = (typeof SETB !== 'undefined') ? ((SETB.byTagVal && SETB.byTagVal[v]) || (SETB.byNorm && SETB.byNorm[setNorm(v)])) : null;
        if (c) setCodes.push(c); else setNames.push(v);
      });
      if (setCodes.length) p.push('setcode=' + encodeURIComponent(setCodes.join(',')));
      if (setNames.length) p.push('set=' + encodeURIComponent(setNames.join(',')));
    }
    ns('Format', 'format', function(v){ return v.toLowerCase(); });
    if ($('cs-instock') && $('cs-instock').checked && !relaxed('instock')) p.push('instock=1');
    var smap = { relevance:'relevance', popularity:'popularity', released:'released', price:'price_desc', name:'name' };
    p.push('sort=' + (smap[sortMode] || 'relevance'));
    // Arm the server-side relaxation ladder, unless the shopper explicitly asked to
    // see the strict (probably empty) result.
    if (!relaxSuppress) p.push('relax=1');
    // Paging INTO an already-relaxed result set: tell the server which rungs produced
    // it so page 2 pages the same set. Without this the server would re-derive the
    // relaxation per page and rows could duplicate or vanish between pages.
    // Dimensions we're forcing off: honouring an explicit card pick (RELAX_FORCE), and
    // — when paging into an already-relaxed set — the rungs that produced it.
    var force = RELAX_FORCE.slice();
    if ((page || 1) > 1) RELAX.forEach(function(k){ if (force.indexOf(k) < 0) force.push(k); });
    if (force.length) p.push('relaxed=' + encodeURIComponent(force.join(',')));
    return p.join('&');
  }
  function docFacets(d){
    var f = {};
    var cols = (d.colors || []).map(function(c){ return CODE2C[c] || c; });
    if (d.is_colorless) cols.push('Colorless');
    if (cols.length) f.Color = cols;
    if (d.rarity) f.Rarity = [capW(d.rarity)];
    if (d.card_types && d.card_types.length) f.Type = d.card_types.slice();
    // Pokémon facets (absent on MTG docs).
    if (d.energy_types && d.energy_types.length) f.Energy = d.energy_types.slice();
    if (d.set_series) f.Series = [d.set_series];
    if (d.set_name) f.Set = [d.set_name];
    if (d.formats && d.formats.length) f.Format = d.formats.map(capW);
    // Treatment + Keyword are enforced server-side BUT cardPassesFacets re-checks
    // them client-side (unlike Type/Supertype/Subtype), so they must be present on
    // the card or every server-filtered result gets dropped. The index doc carries
    // both verbatim (e.g. treatments:["Borderless"]); supertypes/subtypes included
    // for consistency (they're skipped client-side).
    if (d.treatments && d.treatments.length) f.Treatment = d.treatments.slice();
    // ENGLISH IS INCLUDED, unlike the product tag which is foreign-only. A shopper who does not
    // want a Japanese card needs to be able to say "English only", and a facet value that is
    // absent on 99% of documents can be filtered TO but never filtered BACK OUT of.
    f.Language = [langName(d.language || 'en')];
    if (d.keywords && d.keywords.length) f.Keyword = d.keywords.slice();
    if (d.supertypes && d.supertypes.length) f.Supertype = d.supertypes.slice();
    if (d.subtypes && d.subtypes.length) f.Subtype = d.subtypes.slice();
    return f;
  }
  function docRows(d){
    // Group conditions by their finish (the index now tags each condition foil/nonfoil)
    // so foil and non-foil copies of the same condition don't clobber one cell. Older
    // index docs without a per-condition finish fall back to the doc-level finish, and a
    // '?' code (unparsed condition) still shows as Near Mint.
    var defFin = (d.finishes && d.finishes[0]) || 'nonfoil';
    var byFin = {};
    (d.conditions || []).forEach(function(c){
      if (!c.variantId) return;
      var fk = c.finish || defFin;
      var code = (c.code && c.code !== '?') ? c.code : 'NM';
      if (!byFin[fk]){
        // index finish keys may use underscores (pricing form, e.g. "reverse_holofoil");
        // FIN keys don't — try the stripped key before the generic fallback.
        var finObj = FIN[fk] || FIN[fk.replace(/_/g,'')]
          || { key: fk, foil: /foil|holo|etched/i.test(fk), label: fk === 'foil' ? 'Foil' : 'Normal' };
        byFin[fk] = { finish: finObj, cells: {} };
      }
      byFin[fk].cells[code] = { variantId: c.variantId, price: c.price, currency: 'USD', qty: c.qty };
    });
    var rows = Object.keys(byFin).map(function(k){ return byFin[k]; })
      .sort(function(a,b){ return (a.finish.foil?1:0)-(b.finish.foil?1:0); });
    if (rows.length) return rows;
    // Catalog-only / never-carried printing: no Shopify variants, so the index doc has
    // conditions:[]. Synthesize a Non-Foil row of —/0 cells (one per condition) so the card
    // renders like any out-of-stock card ("—" / "0 in stock") instead of empty "·" placeholders,
    // and so it survives the empty-conditions filter in apiFetchPage/showEmbedDefault. These
    // cells carry no variantId → buildCell shows no add-to-cart control and saveBtn returns null
    // (no broken Save). Only reached when the server returns catalog docs (in-stock filter off).
    var oosCells = {};
    COLS.forEach(function(col){ oosCells[col.code] = { variantId: null, price: null, currency: 'USD', qty: 0 }; });
    return [{ finish: FIN.nonfoil, cells: oosCells }];
  }
  // ── Live price/stock hydration (Storefront API) ────────────────────────────────
  // The index is a DERIVED projection of Shopify, so its prices are only as fresh as
  // the last webhook or rebuild — and a repricer run moves hundreds of prices in one
  // burst. Quoting an index price beside an add-to-cart button means the shopper is
  // shown one number and charged another at checkout (observed: Mana Leak PAL02 5
  // foil LP indexed at $254.99 while Shopify said $249.99).
  //
  // So the index is used for DISCOVERY only — search, facets, art, and the
  // out-of-stock catalog spine — and anything we claim is in stock gets its price and
  // quantity from the Storefront API, the same source checkout prices from. Variants
  // are fetched by id (cost: 1 point each), so a 48-card page is ~100 points against
  // the 1000-point bucket — cheaper than re-fetching whole products.
  var LIVE_Q = 'query Live($ids:[ID!]!){ nodes(ids:$ids){ id ... on ProductVariant { quantityAvailable availableForSale price{ amount } } } }';
  var LIVE_CHUNK = 200;   // Storefront caps `nodes` at 250 ids per query

  /**
   * Overwrite every in-stock price/qty on `docs` with live Shopify values, in place.
   * Resolves with the same docs so callers can chain. On any failure the docs are
   * returned untouched (index prices — degraded, but no worse than not hydrating).
   */
  function hydrateDocs(docs){
    docs = docs || [];
    var ids = [], seen = {};
    docs.forEach(function(d){
      // Catalog-only docs (no Shopify product) carry no variantId and render as "—".
      (d && d.conditions || []).forEach(function(c){
        if (!c.variantId || seen[c.variantId]) return;
        seen[c.variantId] = 1; ids.push('gid://shopify/ProductVariant/' + c.variantId);
      });
    });
    if (!ids.length) return Promise.resolve(docs);
    var chunks = [];
    for (var i = 0; i < ids.length; i += LIVE_CHUNK) chunks.push(ids.slice(i, i + LIVE_CHUNK));
    var live = {};
    // Sequential: chunks only exist for very large pages, and serializing them keeps
    // a burst from eating the per-IP cost bucket that the rest of the page shares.
    return chunks.reduce(function(chain, chunk){
      return chain.then(function(){
        return gql(LIVE_Q, { ids: chunk }).then(function(res){
          if (res && res.errors && res.errors.length) throw new Error(res.errors[0].message);
          ((res && res.data && res.data.nodes) || []).forEach(function(n){
            if (!n || !n.id) return;   // null = variant deleted or product unpublished
            var amt = parseFloat(n.price && n.price.amount);
            live[String(n.id).split('/').pop()] = {
              price: isNaN(amt) ? null : amt,
              // quantityAvailable is null when a variant isn't inventory-tracked; fall
              // back to availableForSale so it stays buyable instead of reading as 0.
              qty: (n.quantityAvailable != null) ? n.quantityAvailable : (n.availableForSale ? 1 : 0)
            };
          });
        });
      });
    }, Promise.resolve()).then(function(){
      docs.forEach(function(d){ applyLive(d, live); });
      return docs;
    }).catch(function(e){
      console.warn('[card-search] live price check failed; falling back to index prices', e);
      return docs;
    });
  }

  function applyLive(d, live){
    if (!d || !d.conditions || !d.conditions.length) return;
    var total = 0, min = null;
    d.conditions.forEach(function(c){
      var l = c.variantId ? live[String(c.variantId)] : null;
      // A variant Shopify won't return is deleted or unpublished — it can't be bought,
      // so zero it rather than leaving the index's last-known price on screen.
      if (!l){ c.qty = 0; c.price = 0; return; }
      if (l.price != null) c.price = l.price;
      c.qty = Math.max(0, l.qty || 0);
      total += c.qty;
      if (c.qty > 0 && c.price > 0 && (min == null || c.price < min)) min = c.price;
    });
    d.total_qty = total;
    d.in_stock = total > 0;
    if (min != null) d.min_price = min;   // keep the index's reference price when nothing is in stock
    d.price_live = true;
  }

  function docToCard(d){
    return {
      id: d.product_id || d.id, kind: 'single',
      key: (String(d.name) + '|' + String(d.set_name || '') + '|' + String(d.collector_number || '')).toLowerCase(),
      name: d.name, set: d.set_name || '', setCode: d.set_code || null, number: d.collector_number || '',
      price: (d.min_price != null ? d.min_price : null), game: d.game === 'Pokemon' ? 'Pokemon Single' : 'MTG Single', tags: [],
      facets: docFacets(d), image: d.image_url || null, back: d.back_image_url || null, descriptionHtml: d.description_html || '', rows: docRows(d),
      // Scryfall facets for the modal fallback when a product has no Storepass table.
      oracleId: d.oracle_id || '', typeLine: d.type_line || '', rarity: d.rarity || '', manaCost: d.mana_cost || '',
      // The raw index doc, kept by reference (not copied) for the Sell view — it needs
      // catalog_finishes / handle / conditions[].sku, which the normalized card drops.
      doc: d,
      // Printed vanity name of a reskinned printing ("Ifrit" for Fury SLD 7007). The index
      // matches on it, so show it or a hit for "Ifrit" looks like the wrong card.
      flavorName: d.flavor_name || ''
    };
  }
  // Map /api/search facet_counts → the { ns: {value:count} } shape buildFacets renders.
  function serverGroups(sf){
    var g = {};
    if (sf.colors){ g.Color = {}; Object.keys(sf.colors).forEach(function(k){ g.Color[CODE2C[k] || k] = sf.colors[k]; }); }
    if (sf.is_colorless && sf.is_colorless['true']){ g.Color = g.Color || {}; g.Color['Colorless'] = sf.is_colorless['true']; }
    if (sf.rarity){ g.Rarity = {}; Object.keys(sf.rarity).forEach(function(k){ g.Rarity[capW(k)] = sf.rarity[k]; }); }
    if (sf.card_types){ g.Type = {}; Object.keys(sf.card_types).forEach(function(k){ g.Type[k] = sf.card_types[k]; }); }
    if (sf.supertypes){ g.Supertype = {}; Object.keys(sf.supertypes).forEach(function(k){ g.Supertype[k] = sf.supertypes[k]; }); }
    if (sf.subtypes){ g.Subtype = {}; Object.keys(sf.subtypes).forEach(function(k){ g.Subtype[k] = sf.subtypes[k]; }); }
    // Pokémon facets (energy type + series/era) — kept cased as the index stores them.
    if (sf.energy_types){ g.Energy = {}; Object.keys(sf.energy_types).forEach(function(k){ g.Energy[k] = sf.energy_types[k]; }); }
    if (sf.set_series){ g.Series = {}; Object.keys(sf.set_series).forEach(function(k){ g.Series[k] = sf.set_series[k]; }); }
    if (sf.keywords){ g.Keyword = {}; Object.keys(sf.keywords).forEach(function(k){ g.Keyword[k] = sf.keywords[k]; }); }
    if (sf.treatments){ g.Treatment = {}; Object.keys(sf.treatments).forEach(function(k){ g.Treatment[k] = sf.treatments[k]; }); }
    if (sf.language){ g.Language = {}; Object.keys(sf.language).forEach(function(k){ g.Language[langName(k)] = sf.language[k]; }); }
    if (sf.set_name){ g.Set = {}; Object.keys(sf.set_name).forEach(function(k){ g.Set[k] = sf.set_name[k]; }); }
    if (sf.formats){ g.Format = {}; Object.keys(sf.formats).forEach(function(k){ g.Format[capW(k)] = sf.formats[k]; }); }
    return g;
  }
  function apiFetchPage(append){
    if (!append){ beginLoad('Searching…'); rawCards = []; apiPage = 1; PAGE.capped = false; PAGE.fetchAll = false; PAGE._gen = ++searchGen; }
    else { setLoadMore('loading'); apiPage++; }
    var gen = PAGE._gen;
    if (!append) RELAX = [];
    var url = API_BASE.replace(/\/+$/, '') + '/api/search?' + buildApiParams(apiPage);
    relaxSuppress = false;   // one-shot — consumed by the params just built
    // no-store: the in-stock/OOS result set must never be served from an HTTP cache —
    // a cached in-stock-only payload is exactly the "unchecked but OOS still hidden until
    // hard reload" symptom. The endpoint is force-dynamic, but this rules out any
    // intermediary (browser bfcache / proxy / CDN) too.
    return fetch(url, { cache: 'no-store' }).then(function(r){ return r.json(); }).then(function(res){
      if (gen !== searchGen) return;                     // superseded by a newer query
      if (!res || res.error || !res.results){ if (rawCards.length){ finishPage(); } else if (!append){ $('cs-status').textContent = 'Search error.'; } setLoadMore('idle'); return; }
      // Price-check against Shopify BEFORE the first render, so a stale index price is
      // never painted next to an add-to-cart button (not even for a frame).
      return hydrateDocs(res.results).then(function(docs){
        if (gen !== searchGen) return;                   // superseded while price-checking
        var batch = docs.map(docToCard).filter(function(c){ return c.rows[0] && Object.keys(c.rows[0].cells).length; });
        rawCards = append ? rawCards.concat(batch) : batch;
        // Which server dimensions were dropped to produce this page ([] = strict).
        // Set before render() so the client-side re-filters honour the same widening.
        if (!append) RELAX = Array.isArray(res.relaxed) ? res.relaxed.slice() : [];
        pageHasNext = !!res.has_more;
        SERVER_FACETS = res.facets || null;
        finishPage();
      });
    }).catch(function(e){ if (gen !== searchGen) return; console.error(e); if (rawCards.length){ finishPage(); } else if (!append){ $('cs-status').textContent = 'Search failed.'; } setLoadMore('idle'); });
  }

  function fetchPage(append){
    if (useApiSearch()) return apiFetchPage(append);
    // The Storefront path has no relaxation ladder of its own yet, so clear any
    // widening carried over from an API query rather than leaving a stale banner.
    if (!append){ RELAX = []; beginLoad(PAGE.statusPrefix === 'Newest' ? '' : 'Searching…'); rawCards = []; pageCursor = null; PAGE.capped = false; PAGE._gen = ++searchGen; }
    else if (!PAGE.fetchAll){ setLoadMore('loading'); }
    var gen = PAGE._gen;
    return gql(PAGE_Q, { q: PAGE.q, after: append ? pageCursor : null, sort: PAGE.sort, rev: PAGE.rev })
      .then(function(res){
        if (gen !== searchGen) return;   // a newer search/browse started — this page is stale, drop it
        if (res.errors || !res.data){ console.error(res.errors); if (rawCards.length){ finishPage(); } else if (!append){ $('cs-status').textContent = 'Search error. Check the Storefront token.'; } setLoadMore('idle'); return; }
        var conn = res.data.products;
        var batch = (conn.nodes||[]).map(normalize).filter(function(c){ return c.kind === 'product' || c.rows.length; });
        rawCards = append ? rawCards.concat(batch) : batch;
        pageCursor = conn.pageInfo.endCursor; pageHasNext = conn.pageInfo.hasNextPage;
        // keep pulling pages for a search until the catalog is exhausted or the cap is hit
        if (PAGE.fetchAll && pageHasNext && rawCards.length < FETCH_ALL_MAX){
          $('cs-status').textContent = 'Searching… ' + rawCards.length + ' loaded';
          return fetchPage(true);
        }
        if (PAGE.fetchAll && pageHasNext) PAGE.capped = true;   // stopped early at FETCH_ALL_MAX
        finishPage();
      })
      .catch(function(e){ if (gen !== searchGen) return; console.error(e); if (rawCards.length){ finishPage(); } else if (!append){ $('cs-status').textContent = 'Search failed.'; } setLoadMore('idle'); });
  }
  // Merge + sort + render everything accumulated for the current PAGE query.
  function finishPage(){
    cards = mergeCards(rawCards);
    // Genuinely nothing, even relaxed: clear the banner (this path skips render(), so
    // it would otherwise keep advertising a widening from the previous query) and fall
    // back to the remove-a-filter panel.
    if (!cards.length){
      RELAX = []; RELAX_CLIENT = []; renderRelaxBanner(false);
      $('cs-status').textContent = ''; var eb = $('cs-results'); eb.innerHTML = PAGE.empty; noResultsFilters(eb); setLoadMore('hide');
      navList = [];
      if (checkPinned()) return;
      if (checkIndexFallback()) return;
      checkWidenNeeded(); return;
    }
    buildFinishFilter(); buildFacets(); render();
    if (PAGE.fetchAll){ $('cs-more').style.display = 'none'; } else { renderLoadMore(); }
    if (PAGE.statusPrefix === 'Newest') $('cs-status').textContent = 'Newest arrivals: ' + $('cs-status').textContent;
    if (PAGE.capped) $('cs-status').textContent += ' (capped at the first ' + cards.length + '; refine your search to narrow it down)';
    if (PAGE.recs && !PAGE.recsDone){ PAGE.recsDone = true; loadRecommendations(relevanceSorted(cards)); }
    if (checkPinned()) return;
    checkWidenNeeded();
  }

  /* Last resort when the page would otherwise read as empty: re-run the query with the
   * availability filters dropped.
   *
   * The in-render ladder above can only un-hide rows we already HAVE. When the server
   * itself excluded everything — in-stock pinned server-side, nothing in stock — there
   * is nothing left to un-hide, so the only way to show the shopper their card is to
   * ask again without that filter.
   *
   * This also covers the zero-result case on a backend that predates `relax=1`: the
   * params for a widened dimension are omitted outright (see buildApiParams), so the
   * widening works regardless of which API version is deployed.
   *
   * Returns true if a refetch was started. One shot — RELAX_FORCE being non-empty
   * blocks re-entry, so this can't loop.
   */
  /* The Storefront path only knows products we have listed, so a card we've never
   * carried reads as "no such card" rather than "not in stock" — searching Mox Jet
   * under the All scope returned nothing, while the same query scoped to MTG singles
   * (which routes to the index) found it. Rather than send every All-scope search to
   * the index — that would drop sealed, accessories and board games, which the index
   * doesn't carry — retry there only once the page is already empty, where there is
   * nothing to lose.
   *
   * One shot: apiFallback stays set until the next user-initiated search.
   */
  function checkIndexFallback(){
    if (apiFallback) return false;                 // already retried
    if (!API_BASE || SEARCH_SRC !== 'api') return false;
    if (isProductCat()) return false;              // sealed/accessories aren't indexed
    if (useApiSearch()) return false;              // these results already came from the index
    if (!$('cs-q').value.trim()) return false;     // a browse, not a search
    apiFallback = true;
    fetchPage(false);
    return true;
  }
  function checkWidenNeeded(){
    if (RELAX_FORCE.length) return false;               // already widened once
    if (navList.length) return false;                   // something is on screen
    var instockOn = $('cs-instock') && $('cs-instock').checked;
    var priceOn = ($('cs-pmin') && $('cs-pmin').value) || ($('cs-pmax') && $('cs-pmax').value);
    if (!instockOn && !priceOn) return false;           // nothing left worth dropping
    RELAX_FORCE = ['instock', 'price', 'conds', 'finish'];
    fetchPage(false);
    return true;
  }

  /* ── "Show me the card I picked" ─────────────────────────────────────────────
   * Picking a suggestion is an explicit request for that card, but the filters still
   * apply — and with In stock ticked, a card we don't currently carry vanishes,
   * leaving whatever fuzzy match DID have stock ("Windswept Heath" → the one in-stock
   * "Adagia, Windswept Bastion"). That reads as the click doing nothing.
   *
   * Zero-result relaxation can't catch this: the result set isn't empty, it's just
   * missing the one card that was asked for. So check for it by name and widen until
   * it appears — availability filters first (the usual culprit, and the least
   * meaningful when someone has named a specific card), then scope.
   *
   * Two escalations max, then give up rather than loop.
   */
  var pendingPin = null;   // set by chooseAC, consumed by the doSearch it triggers
  var pinnedName = null;   // the card that must appear in the current result set
  var pinStage = 0;
  function pinMatches(c, want){
    if (baseName(c.name).toLowerCase() === want) return true;
    return !!(c.flavorName && baseName(c.flavorName).toLowerCase() === want);
  }
  // Returns true if it started a refetch. `pinnedName` deliberately SURVIVES success —
  // the banner names the card, and a later filter change that hides it again should
  // re-widen. It's cleared by the next doSearch/loadDefault.
  function checkPinned(){
    if (!pinnedName) return false;
    var want = baseName(pinnedName).toLowerCase();
    // navList is what's actually on screen after every filter, client ones included.
    if (navList.some(function(c){ return pinMatches(c, want); })){ pinStage = 0; return false; }
    if (pinStage >= 2) return false;   // genuinely not in the catalog — stop trying
    pinStage++;
    RELAX_FORCE = pinStage === 1
      ? ['instock', 'price', 'conds', 'finish']            // availability
      : ['instock', 'price', 'conds', 'finish', 'filters', 'game'];   // …then scope
    // Re-run the SAME query rather than going through doSearch(), which would consume
    // the pin and reset the escalation.
    fetchPage(false);
    return true;
  }
  function loadMore(){ if (pageHasNext && !PAGE.fetchAll) fetchPage(true); }
  // re-run the current query (e.g. after a sort change) — keeps the selected filters
  function reload(){
    var ss = serverSort(PAGE.browse);
    PAGE.sort = ss.sort; PAGE.rev = ss.rev;
    PAGE.statusPrefix = (PAGE.browse && sortMode === 'relevance') ? 'Newest' : null;
    keepFilters = true;
    fetchPage(false);
  }
  function renderLoadMore(){
    var host = $('cs-more');
    if (!pageHasNext){ host.style.display = 'none'; host.innerHTML = ''; return; }
    host.style.display = 'block';
    host.innerHTML = '<button type="button" id="cs-more-btn" class="cs-actbtn">Load more results</button>';
    $('cs-more-btn').onclick = loadMore;
  }
  function setLoadMore(state){
    var btn = $('cs-more-btn');
    if (state === 'hide'){ $('cs-more').style.display = 'none'; return; }
    if (!btn) return;
    if (state === 'loading'){ btn.disabled = true; btn.innerHTML = '<span class="cs-spinner" style="border-color:rgba(28,23,18,.35);border-top-color:#1C1712"></span> Loading…'; }
    else { btn.disabled = false; btn.textContent = 'Load more results'; }
  }

  function doSearch(e){
    if (e && e.preventDefault) e.preventDefault();
    closeAC();
    // A fresh search starts clean. chooseAC() stages `pendingPin` immediately before
    // calling this, so only a typeahead pick arrives with a card to guarantee — a
    // typed search (pendingPin null) clears any previous pin.
    pinnedName = pendingPin; pendingPin = null;
    pinStage = 0; RELAX_FORCE = []; apiFallback = false;
    var term = $('cs-q').value;
    // Generic guard: the load-everything (fetchAll) path is only ever justified by a
    // narrow search term. With an empty box — even with server-side filters applied —
    // fall back to the paginated browse so we never pull up to FETCH_ALL_MAX at once.
    if (!term.trim()){ loadDefault(); return; }
    var ss = serverSort(false);
    var empty = '<div style="text-align:center;padding:3rem 1rem;font-family:var(--font-body,sans-serif);color:#8A8378">' +
      'No cards found for <strong style="color:#1C1712">' + (term ? term.replace(/</g,'&lt;') : 'that search') + '</strong>.<br>Try a different spelling or a broader term.</div>';
    PAGE = { q: buildQuery(term), sort: ss.sort, rev: ss.rev, recs: true, browse: false, fetchAll: true, empty: empty, statusPrefix: null };
    fetchPage(false);
  }
  // On the embed, any server-side facet beyond the locked Color/Format means the user
  // is filtering — do a real search, not the recs default.
  function embedHasActiveFilters(){
    var extra = ['Type', 'Rarity', 'Set', 'Subtype', 'Supertype', 'Keyword', 'Treatment', 'Language'];
    for (var i = 0; i < extra.length; i++){ var s = facetState[extra[i]]; if (s && s.size) return true; }
    if (ADV.cexc && ADV.cexc.size) return true;
    return false;
  }
  function embedBrowse(){
    PAGE = { q: '', browse: true, fetchAll: false, recs: false, statusPrefix: null,
      empty: '<div style="text-align:center;padding:2.5rem 1rem;font-family:var(--font-body,sans-serif);color:#8A8378">No cards match these filters.</div>' };
    if ($('cs-recs-wrap')) $('cs-recs-wrap').style.display = 'none';
    fetchPage(false); // → apiFetchPage (buildApiParams sends color + type + rarity + …)
  }
  function loadDefault(){
    // Embedded (workbench): the idle/default result set is the EDHREC recommendations,
    // injected into the main results grid (not a separate carousel). But once the user
    // applies a real filter (Type, Rarity, …), browse the catalog with those filters.
    if (EMBED && EMBED_DEFAULT){
      if (embedHasActiveFilters()){ embedBrowse(); return; }
      beginLoad('');
      $('cs-status').textContent = 'Loading recommendations…';
      var g = ++searchGen;
      EMBED_DEFAULT().then(function(r){
        if (g !== searchGen) return;
        var docs = (r && r.docs) || [];
        if (docs.length) showEmbedDefault(docs, (r && r.status) || '');
        else embedFallbackBrowse(g); // no recs → recent popular in-colour cards we stock
      }).catch(function(){ if (g !== searchGen) return; embedFallbackBrowse(g); });
      return;
    }
    // A browse is not a pinned-card request — drop any guarantee from a previous pick.
    pendingPin = null; pinnedName = null; pinStage = 0; RELAX_FORCE = []; apiFallback = false;
    var inStock = $('cs-instock') && $('cs-instock').checked;
    var parts = [];
    var cf = categoryFrag(); if (cf) parts.push(cf);
    mtgFilterParts().forEach(function(p){ parts.push(p); });
    if (inStock) parts.push('available_for_sale:true');
    var q = parts.join(' AND ') || '*';
    var ss = serverSort(true);
    var empty = '<div style="text-align:center;padding:3rem 1rem;font-family:var(--font-body,sans-serif);color:#8A8378">No cards found.</div>';
    // Show the (format-aware) recs carousel when browsing any MTG server filter,
    // even with no search term — that's exactly when "more like this" is useful.
    var mtgFilter = false; if (mtgOnly()){ for (var mns in facetState){ if (MTG_SERVER_NS[mns] && facetState[mns].size){ mtgFilter = true; break; } } }
    PAGE = { q: q, sort: ss.sort, rev: ss.rev, recs: mtgFilter, browse: true, fetchAll: false, empty: empty, statusPrefix: (sortMode==='relevance' ? 'Newest' : null) };
    fetchPage(false);
  }
  // Render a provided set of index docs as the result grid (embedded default = recs).
  function showEmbedDefault(docs, statusText){
    PAGE = { q: '', browse: true, fetchAll: false, recs: false, statusPrefix: null,
      empty: '<div style="text-align:center;padding:2.5rem 1rem;font-family:var(--font-body,sans-serif);color:#8A8378">No in-stock recommendations here yet — search above to add cards, or try Deck Check.</div>' };
    hydrateDocs(docs || []).then(function(live){
      rawCards = live.map(docToCard).filter(function(c){ return c.rows[0] && Object.keys(c.rows[0].cells).length; });
      pageHasNext = false; SERVER_FACETS = null;
      cards = mergeCards(rawCards);
      if ($('cs-recs-wrap')) $('cs-recs-wrap').style.display = 'none';
      if (!cards.length){ $('cs-status').textContent = ''; var eb = $('cs-results'); eb.innerHTML = PAGE.empty; setLoadMore('hide'); return; }
      buildFinishFilter(); buildFacets(); render();
      setLoadMore('hide'); if ($('cs-more')) $('cs-more').style.display = 'none';
      $('cs-status').textContent = statusText || '';
    });
  }
  // Fallback when EDHREC has no in-stock recs: recent (~12mo) cards in the commander's
  // colour identity, by EDHREC rank, in stock, minus what's already in the deck.
  function embedFallbackBrowse(gen){
    var p = ['per_page=60', 'format=commander', 'cmode=commander', 'instock=1', 'sort=popularity'];
    var codes = []; if (facetState['Color']) facetState['Color'].forEach(function(n){ if (C2CODE[n]) codes.push(C2CODE[n]); });
    if (codes.length) p.push('color=' + codes.join(','));
    p.push('relmin=' + (Math.floor(Date.now() / 1000) - 365 * 24 * 3600));
    p.push('noreprint=1'); // genuinely-new cards only, not recent reprints of old staples
    fetch(API_BASE.replace(/\/+$/, '') + '/api/search?' + p.join('&')).then(function(r){ return r.json(); }).then(function(res){
      if (gen !== searchGen) return;
      var docs = ((res && res.results) || []).filter(function(d){ return !(EMBED_CB && EMBED_CB.isInDeck && EMBED_CB.isInDeck(d.name)); });
      showEmbedDefault(docs, docs.length ? ('Recent cards in your colours (' + docs.length + ')') : '');
    }).catch(function(){ if (gen !== searchGen) return; showEmbedDefault([], ''); });
  }
  // Clear the search box and re-show the default (recs) — used by the rec-mode toggle.
  function reloadDefault(){ if ($('cs-q')) $('cs-q').value = ''; loadDefault(); }
  // Re-run after a set/format filter change. A search term wants the
  // load-everything path (narrow, client-side sortable); a pure set/format
  // browse wants the paginated "Load more" path — a broad format (Legacy,
  // Commander) far exceeds the fetchAll cap, so we must NOT load it all at once.
  function refilter(){ if ($('cs-q').value.trim()) doSearch(); else loadDefault(); }

  // ════════════════════ MTG set browser modal ════════════════════
  // Loads assets/mtg-sets.json on first open. Selection (by set CODE) is mapped
  // to facetState['Set'] (set NAMES) on Apply, so the modal and the legacy Set
  // facet share one source of truth and the server query (mtgSetFrag) filters by
  // the live tag. Lazy: nothing loads until the user opens it.
  var SETB = { loaded:false, loading:null, error:false, sets:[], byCode:{}, byNorm:{}, byTagVal:{}, groups:{}, tab:'traditional', q:'', sel:null, fmtSel:null, collapsed:{} };
  var SET_TABS = [
    { key:'traditional', label:'Standard & Eternal' },
    { key:'commander',   label:'Commander' },
    { key:'supplemental',label:'Supplemental' },
  ];
  // Formats we have set-level data for (so a pill can filter the displayed sets,
  // not just the per-card results). Other whitelisted formats (Arena/Brawl/etc.)
  // still apply as a per-card result filter but don't narrow the set list.
  var SET_LEVEL_FORMATS = { standard:1, pioneer:1, modern:1, premodern:1, pauper:1, legacy:1, vintage:1, commander:1 };
  // Rotation zones for the expansion timeline (newest→oldest), with the breaks
  // at the common rotation boundaries.
  var ZONES = [
    { key:'standard', label:'Standard',                sub:'in rotation' },
    { key:'pioneer',  label:'Pioneer',                 sub:'rotated out of Standard' },
    { key:'modern',   label:'Modern',                  sub:'pre-2012' },
    { key:'older',    label:'Legacy &amp; Vintage only', sub:'pre-2003' },
  ];
  function zoneOf(s){
    var f = s.formats || [];
    if (f.indexOf('standard') >= 0) return 'standard';
    if (f.indexOf('pioneer')  >= 0) return 'pioneer';
    if (f.indexOf('modern')   >= 0) return 'modern';
    return 'older';
  }
  // Supplemental sub-grouping (Secret Lair is just one of these — no own tab).
  var SUPP_ORDER = ['Masters & Reprints','Modern Horizons','Jumpstart','Secret Lair','Boxed Sets & Decks','Collector Reprints','Un-sets','Casual & Other','Art Series & Oversized'];
  function suppGroup(s){
    if (s.category === 'secret-lair') return 'Secret Lair';
    var n = s.name.toLowerCase();
    if (/jumpstart/.test(n)) return 'Jumpstart';
    if (/horizons/.test(n)) return 'Modern Horizons';
    if (s.setType === 'masters' || s.setType === 'masterpiece' || /master|remastered/.test(n)) return 'Masters & Reprints';
    if (s.setType === 'memorabilia') return s.category === 'supplemental'
      ? 'Collector Reprints'              // CED/CEI, WC decks, 30A — gold-bordered, not tournament legal
      : 'Art Series & Oversized';         // the rest of Scryfall's memorabilia: art cards, oversized, scene boxes, prizes
    if (s.category === 'un-set') return 'Un-sets';
    if (s.category === 'other') return 'Casual & Other';
    return 'Boxed Sets & Decks';
  }

  // Mirror loyalty-app/src/lib/set-match.ts normalizeSetName for name↔tag matching.
  function setNorm(s){
    return String(s).normalize('NFKD').replace(/[̀-ͯ]/g,'').toLowerCase()
      .replace(/['’ʼ`´]/g,'').replace(/&/g,' and ').replace(/^the\s+/,'').replace(/[^a-z0-9]+/g,' ').trim();
  }
  function setIconUrl(file){ return file ? (CS_ICON_BASE + file) : ''; }

  function loadSets(){
    // The browser serves whichever game is active; reload when the game switches.
    var game = advGame();
    if (SETB.loaded && SETB.game === game) return Promise.resolve();
    if (SETB.loading && SETB.game === game) return SETB.loading;
    SETB.game = game; SETB.loaded = false; SETB.error = false;
    SETB.sets = []; SETB.byCode = {}; SETB.byNorm = {}; SETB.byTagVal = {}; SETB.groups = {};
    SETB.tab = game === 'pokemon' ? 'series' : 'traditional';
    var url = game === 'pokemon' ? CS_PSETS_URL : CS_SETS_URL;
    SETB.loading = fetch(url).then(function(r){ return r.json(); }).then(function(d){
      SETB.sets = d.sets || []; SETB.groups = d.groups || {};
      // The bake froze `upcoming` at its build date; a set released since must not
      // keep saying so. Local date, matching what the shopper's calendar says.
      var now = new Date(), today = now.getFullYear() + '-' + ('0' + (now.getMonth() + 1)).slice(-2) + '-' + ('0' + now.getDate()).slice(-2);
      SETB.sets.forEach(function(s){
        if (s.upcoming && s.released && s.released <= today) s.upcoming = false;
        SETB.byCode[s.code] = s;
        SETB.byNorm[setNorm(s.name)] = s.code;
        if (s.inventoryTag){ var tv = s.inventoryTag.replace(/^Set_/,''); s.tagValue = tv; SETB.byTagVal[tv] = s.code; SETB.byNorm[setNorm(tv)] = s.code; }
      });
      // Only treat "none in stock" as meaningful once we have a stock signal (else
      // every set is inStock:false and the whole grid would look greyed-out).
      SETB.haveStock = SETB.sets.some(function(s){ return s.inStock; });
      SETB.loaded = true;
      // Deliberately NOT chained into SETB.loading: the modal paints from the artifact
      // immediately and the counts land a beat later, rather than holding the grid
      // closed on a second round-trip.
      hydrateSetStock(game);
      if (game !== 'pokemon') hydrateSetFormats(game);
    }).catch(function(e){ console.error('set data load failed', e); SETB.error = true; });
    return SETB.loading;
  }

  /* Live per-set stock counts.
   *
   * The artifact's baked `inStock` comes from a weekly job that matches Shopify tag
   * NAMES to Scryfall names. It goes stale between bakes, and sets the two sources
   * name differently ("Avatar: The Last Airbender: Eternal-Legal" vs Scryfall's
   * "… Eternal") never match at all — so sets holding dozens of cards rendered as
   * "not stocked", which read like a buying decision rather than an empty shelf.
   *
   * /api/sets/stock answers it from the index by set CODE: no name matching, no
   * staleness. Same split as live price hydration — the artifact is discovery, the
   * volatile number comes from the server. Best-effort: on any failure we keep the
   * baked flags, so the modal degrades to its old behaviour rather than breaking.
   */
  function hydrateSetStock(game){
    if (!API_BASE) return;
    var url = API_BASE.replace(/\/+$/, '') + '/api/sets/stock?game=' + encodeURIComponent(game === 'pokemon' ? 'Pokemon' : 'MTG');
    return fetch(url).then(function(r){ return r.ok ? r.json() : null; }).then(function(d){
      // Don't apply a late response to a grid the shopper has since switched away from.
      if (!d || !d.counts || SETB.game !== game) return;
      var counts = d.counts;
      SETB.sets.forEach(function(s){
        var n = counts[String(s.code).toLowerCase()] || 0;
        s.stockCount = n;
        s.inStock = n > 0;
      });
      SETB.haveStock = true;   // the server answered, so zero really means zero
      SETB.stockLive = true;
      // The modal may already be painted (the fetch is off the critical path).
      var modal = $('cs-setmodal');
      if (modal && modal.classList.contains('open')) renderSetBody();
    }).catch(function(e){ console.warn('set stock hydrate failed, using baked flags', e); });
  }
  /* Live Standard/Pioneer/Modern per set.
   *
   * The artifact's formats come from date rules run at bake time, so a set released
   * after the bake sat under "Legacy & Vintage only" (Reality Fracture, 2026-10) and a
   * rotation needed a hand edit. /api/sets/formats counts each set's cards' own
   * legality in the index. Only core/expansion sets take it: those are the ones the
   * date rules bin, and Masters/Commander products would otherwise jump zones on
   * reprint legality. Eternal formats stay as baked. Best-effort, like stock.
   *
   * The index only holds printings we carry, so an old set is judged on a few docs —
   * often reprinted staples or basics. Unguarded, that put Alpha and Theros in
   * Standard. So live data may only grant a format to a set released inside it:
   * Pioneer and Modern have fixed first sets, and no set stays in Standard 5 years.
   */
  var LIVE_FORMATS = ['standard', 'pioneer', 'modern'];
  var LIVE_FORMAT_TYPES = { core: 1, expansion: 1 };
  var LIVE_FORMAT_FLOOR = { modern: '2003-07-28', pioneer: '2012-10-05' };
  function liveFormatFloor(f){
    if (f !== 'standard') return LIVE_FORMAT_FLOOR[f];
    var d = new Date(); d.setFullYear(d.getFullYear() - 5);
    return d.toISOString().slice(0, 10);
  }
  function hydrateSetFormats(game){
    if (!API_BASE) return;
    return fetch(API_BASE.replace(/\/+$/, '') + '/api/sets/formats').then(function(r){ return r.ok ? r.json() : null; }).then(function(d){
      if (!d || !d.formats || SETB.game !== game) return;
      SETB.sets.forEach(function(s){
        var live = d.formats[String(s.code).toLowerCase()];
        // Previewed cards carry legality before release; the set isn't playable yet.
        if (!live || !LIVE_FORMAT_TYPES[s.setType] || s.upcoming) return;
        var rest = (s.formats || []).filter(function(f){ return LIVE_FORMATS.indexOf(f) < 0; });
        s.formats = LIVE_FORMATS.filter(function(f){
          return live.indexOf(f) >= 0 && !!s.released && s.released >= liveFormatFloor(f);
        }).concat(rest);
      });
      var modal = $('cs-setmodal');
      if (modal && modal.classList.contains('open')) renderSetBody();
    }).catch(function(e){ console.warn('set formats hydrate failed, using baked formats', e); });
  }
  // the facet value (set name / tag value) to store for a selected code
  function setFacetValue(code){ var s = SETB.byCode[code]; return s ? (s.tagValue || s.name) : code; }
  // seed modal selection (codes) from the shared facetState['Set'] (names)
  function setSelFromFacets(){
    SETB.sel = {};
    var sel = facetState['Set']; if (sel) sel.forEach(function(name){ var c = SETB.byTagVal[name] || SETB.byNorm[setNorm(name)]; if (c) SETB.sel[c] = 1; });
    SETB.fmtSel = {};
    var fsel = facetState['Format']; if (fsel) fsel.forEach(function(f){ SETB.fmtSel[f] = 1; });
  }
  function setSelSize(){ return SETB.sel ? Object.keys(SETB.sel).length : 0; }
  function fmtSelSize(){ return SETB.fmtSel ? Object.keys(SETB.fmtSel).length : 0; }

  function openSetBrowser(){
    // The Sets button lives INSIDE the filters drawer on mobile, and the drawer paints
    // above the modal — leaving it open buries the set browser behind it. Closing here
    // rather than at the click site so every entry point into the browser is covered;
    // it's a no-op on desktop, where the drawer isn't open.
    closeFacets();
    $('cs-setmodal').classList.add('open');
    loadSets().then(function(){
      if (SETB.error){ $('cs-setbody').innerHTML = setMsg('Couldn’t load set data.'); return; }
      var title = $('cs-setmodal-title'); if (title) title.textContent = (SETB.game === 'pokemon' ? 'Pokémon Expansions' : 'Magic Sets');
      setSelFromFacets(); renderSetTabs(); renderSetBody(); renderSetFoot();
      var q = $('cs-setmodal-q'); if (q) q.focus();
    });
  }
  function closeSetBrowser(){ $('cs-setmodal').classList.remove('open'); }
  function setMsg(t){ return '<div style="padding:2.5rem 1rem;text-align:center;font-family:var(--font-body,sans-serif);color:#8A8378">' + t + '</div>'; }

  function renderSetTabs(){
    var host = $('cs-settabs'); host.innerHTML = '';
    var searching = setSearching();
    host.classList.toggle('searching', searching);
    if (SETB.game === 'pokemon') return;   // Pokémon shows all series in one scrolling view
    SET_TABS.forEach(function(t){
      var b = document.createElement('button'); b.type = 'button';
      b.className = 'cs-settab' + (!searching && SETB.tab === t.key ? ' active' : ''); b.textContent = t.label;
      // While a term is typed the body spans every tab, so nothing is "active";
      // picking a tab clears the term and drops back into browsing that tab.
      b.onclick = function(){
        SETB.tab = t.key;
        if (searching){ var qEl = $('cs-setmodal-q'); if (qEl) qEl.value = ''; setSetQuery(''); return; }
        renderSetTabs(); renderSetBody();
      };
      host.appendChild(b);
    });
    if (searching){
      var note = document.createElement('span'); note.className = 'cs-settab-note';
      note.textContent = 'searching all tabs';
      host.appendChild(note);
    }
  }
  // Multi-term: every whitespace-separated token has to hit the name, the code or the
  // inventory tag value ("modern horizons 3" -> MH3). Substring, not prefix, so
  // "horizons" finds every Horizons set wherever it lives.
  function setMatchesQ(s){
    var toks = SETB.qToks || [];
    if (!toks.length) return true;
    var hay = (s.name + ' ' + s.code + ' ' + (s.tagValue || '')).toLowerCase();
    for (var i = 0; i < toks.length; i++){ if (hay.indexOf(toks[i]) < 0) return false; }
    return true;
  }
  function setSearching(){ return !!(SETB.qToks && SETB.qToks.length); }
  // One entry point for the modal's filter box. A term flips the body to the all-tabs
  // search view, so the tab strip repaints too (no tab is "active" while searching).
  function setSetQuery(v){
    SETB.q = String(v || '').trim().toLowerCase();
    SETB.qToks = SETB.q ? SETB.q.split(/\s+/).filter(Boolean) : [];
    renderSetTabs(); renderSetBody();
  }
  // Which tab/section a set came from - shown on the chip in the flattened search
  // list so a result still tells you where it lives.
  function setSectionLabel(s){
    if (SETB.game === 'pokemon') return s.series || '';
    if (s.category === 'expansion'){
      var z = zoneOf(s);
      for (var i = 0; i < ZONES.length; i++){ if (ZONES[i].key === z) return ZONES[i].label.replace(/&amp;/g, '&'); }
      return 'Expansion';
    }
    if (s.category === 'commander') return 'Commander';
    return suppGroup(s);
  }
  // Rank inside the search list: exact code, then name-prefix, then the rest.
  function setRank(s){
    if (String(s.code).toLowerCase() === SETB.q) return 0;
    if (s.name.toLowerCase().indexOf(SETB.q) === 0) return 1;
    return 2;
  }

  // Narrow the displayed sets only by selected formats we have set-level data for.
  function displayFmtOk(s){
    var keys = Object.keys(SETB.fmtSel || {}).filter(function(k){ return SET_LEVEL_FORMATS[k.toLowerCase()]; });
    if (!keys.length) return true;
    for (var i = 0; i < keys.length; i++){ if ((s.formats || []).indexOf(keys[i].toLowerCase()) >= 0) return true; }
    return false;
  }
  // Build the [{key,title,sub,codes}] groups for the active tab.
  function setGroupsForTab(){
    // Pokémon: one view grouped by series/era (Mega Evolution … Base), newest first.
    if (SETB.game === 'pokemon'){
      return ((SETB.groups && SETB.groups.bySeries) || []).map(function(g){ return { key:g.series, title:g.series, codes:g.codes.slice() }; });
    }
    var tab = SETB.tab, groups = [];
    if (tab === 'traditional'){
      // Expansion/core timeline, split into rotation zones, newest→oldest.
      var byZone = {};
      SETB.sets.forEach(function(s){ if (s.category === 'expansion' && displayFmtOk(s)){ var z = zoneOf(s); (byZone[z] = byZone[z] || []).push(s.code); } });
      ZONES.forEach(function(z){ if (byZone[z.key] && byZone[z.key].length) groups.push({ key:z.key, title:z.label, sub:z.sub, codes:byZone[z.key] }); });
    } else if (tab === 'commander'){
      groups.push({ key:'cmd', title:'Commander', codes:SETB.sets.filter(function(s){ return s.category === 'commander'; }).map(function(s){ return s.code; }) });
    } else { // supplemental — everything that isn't an expansion or a Commander set
      var bySub = {};
      SETB.sets.forEach(function(s){ if (s.category !== 'expansion' && s.category !== 'commander'){ var g = suppGroup(s); (bySub[g] = bySub[g] || []).push(s.code); } });
      SUPP_ORDER.forEach(function(name){ if (bySub[name] && bySub[name].length) groups.push({ key:name, title:name, codes:bySub[name] }); });
    }
    return groups;
  }
  // Format pills atop the traditional tab: clicking one filters the displayed
  // sets to that legality AND applies it as a per-card result filter on Apply.
  function renderFmtPills(host){
    var box = document.createElement('div'); box.className = 'cs-setfmt';
    var lab = document.createElement('div'); lab.className = 'cs-setfmt-lab';
    lab.textContent = 'Filter by format (sets shown + card legality):';
    box.appendChild(lab);
    var row = document.createElement('div'); row.className = 'cs-setfmt-row';
    FORMAT_TAGS.forEach(function(f){
      var p = document.createElement('button'); p.type = 'button';
      p.className = 'cs-setfmt-pill' + (SETB.fmtSel[f] ? ' on' : ''); p.textContent = f;
      p.onclick = function(){ if (SETB.fmtSel[f]) delete SETB.fmtSel[f]; else SETB.fmtSel[f] = 1; renderSetBody(); renderSetFoot(); };
      row.appendChild(p);
    });
    box.appendChild(row); host.appendChild(box);
  }
  function renderSetBody(){
    var host = $('cs-setbody'); if (SETB.error){ host.innerHTML = setMsg('Couldn’t load set data.'); return; }
    host.innerHTML = '';
    if (setSearching()){ renderSetSearch(host); return; }
    var shown = 0;
    if (SETB.tab === 'traditional') renderFmtPills(host);
    setGroupsForTab().forEach(function(g){
      var codes = g.codes.filter(function(c){ var s = SETB.byCode[c]; return s && setMatchesQ(s); });
      codes.sort(function(a,b){ return (SETB.byCode[b].released || '').localeCompare(SETB.byCode[a].released || ''); });
      if (!codes.length) return; shown += codes.length;
      var ckey = SETB.tab + ':' + g.key, collapsed = !!SETB.collapsed[ckey];
      var wrap = document.createElement('div'); wrap.className = 'cs-setgroup';
      var h = document.createElement('div'); h.className = 'cs-setgroup-h';
      var toggle = document.createElement('button'); toggle.type = 'button'; toggle.className = 'cs-setgroup-toggle';
      toggle.innerHTML = '<span class="cs-setgroup-caret">' + (collapsed ? '▸' : '▾') + '</span>' +
        '<b>' + g.title + '</b>' + (g.sub ? ' <span class="cs-setgroup-sub">' + g.sub + '</span>' : '') +
        ' <span class="cs-setgroup-n">' + codes.length + '</span>';
      toggle.onclick = function(){ SETB.collapsed[ckey] = !collapsed; renderSetBody(); };
      h.appendChild(toggle);
      var allSel = codes.every(function(c){ return SETB.sel[c]; });
      var allBtn = document.createElement('button'); allBtn.type = 'button'; allBtn.className = 'cs-setgroup-all'; allBtn.textContent = allSel ? 'Clear' : 'Select all';
      allBtn.onclick = function(e){ e.stopPropagation(); codes.forEach(function(c){ if (allSel) delete SETB.sel[c]; else SETB.sel[c] = 1; }); renderSetBody(); renderSetFoot(); };
      h.appendChild(allBtn); wrap.appendChild(h);
      if (!collapsed){
        var grid = document.createElement('div'); grid.className = 'cs-setgrid';
        codes.forEach(function(c){ grid.appendChild(setChip(c)); });
        wrap.appendChild(grid);
      }
      host.appendChild(wrap);
    });
    if (!shown){ var m = document.createElement('div'); m.innerHTML = setMsg(SETB.q ? ('No sets match “' + SETB.q + '”.') : 'No sets here.'); host.appendChild(m); }
  }
  // Search view: ONE list of every set that matches, drawn from every tab, so a term
  // like "horizons" or "commander" is never hidden behind the tab you happen to be on.
  // Format pills still narrow it (they carry set-level legality for every category),
  // and the header's Select all checks the whole match set in one go.
  function renderSetSearch(host){
    if (SETB.game !== 'pokemon') renderFmtPills(host);
    var matches = SETB.sets.filter(function(s){ return setMatchesQ(s) && displayFmtOk(s); });
    if (!matches.length){
      var m = document.createElement('div'); m.innerHTML = setMsg('No sets match “' + SETB.q + '”.');
      host.appendChild(m); return;
    }
    matches.sort(function(a, b){
      return setRank(a) - setRank(b) ||
        (b.released || '').localeCompare(a.released || '') ||
        byName(a.name, b.name);
    });
    var codes = matches.map(function(s){ return s.code; });
    var wrap = document.createElement('div'); wrap.className = 'cs-setgroup';
    var h = document.createElement('div'); h.className = 'cs-setgroup-h';
    var lab = document.createElement('div'); lab.className = 'cs-setgroup-lab';
    lab.innerHTML = '<b>Matching sets</b> <span class="cs-setgroup-sub">across every tab</span>' +
      ' <span class="cs-setgroup-n"></span>';
    lab.querySelector('.cs-setgroup-n').textContent = codes.length;
    h.appendChild(lab);
    var allSel = codes.every(function(c){ return SETB.sel[c]; });
    var allBtn = document.createElement('button'); allBtn.type = 'button'; allBtn.className = 'cs-setgroup-all';
    allBtn.textContent = allSel ? 'Clear all' : ('Select all ' + codes.length);
    allBtn.onclick = function(e){
      e.stopPropagation();
      codes.forEach(function(c){ if (allSel) delete SETB.sel[c]; else SETB.sel[c] = 1; });
      renderSetBody(); renderSetFoot();
    };
    h.appendChild(allBtn); wrap.appendChild(h);
    var grid = document.createElement('div'); grid.className = 'cs-setgrid';
    codes.forEach(function(c){ grid.appendChild(setChip(c, true)); });
    wrap.appendChild(grid); host.appendChild(wrap);
  }
  function setChip(code, showSection){
    var s = SETB.byCode[code];
    var unstocked = SETB.haveStock && !s.inStock;
    var b = document.createElement('button'); b.type = 'button';
    b.className = 'cs-setchip' + (SETB.sel[code] ? ' sel' : '') + (unstocked ? ' unstocked' : '');
    var ic = document.createElement('span'); ic.className = 'cs-setchip-ic';
    if (s.icon){ var img = document.createElement('img'); img.src = setIconUrl(s.icon); img.alt = ''; img.loading = 'lazy'; ic.appendChild(img); }
    /* "not stocked" read as a buying decision — as though we'd chosen not to carry the
     * set — when all it ever meant was that the shelf is empty today. With live counts
     * we can say the true thing instead, and say the useful half out loud: a shopper
     * scanning the grid wants to know a set has 57 cards waiting, not merely that it
     * isn't empty. Falls back to the plain phrase when only the baked flag is available. */
    var stock = s.upcoming ? ' · upcoming'
      : unstocked ? ' · none in stock'
      : (SETB.stockLive && s.stockCount) ? ' · ' + s.stockCount + ' in stock'
      : '';
    var meta = s.code.toUpperCase() + (s.year ? ' · ' + s.year : '') + stock;
    if (showSection){ var sec = setSectionLabel(s); if (sec) meta += ' · ' + sec; }
    var tx = document.createElement('span'); tx.className = 'cs-setchip-tx';
    tx.innerHTML = '<span class="cs-setchip-nm"></span><span class="cs-setchip-meta"></span>';
    tx.querySelector('.cs-setchip-nm').textContent = s.name;
    tx.querySelector('.cs-setchip-meta').textContent = meta;
    b.appendChild(ic); b.appendChild(tx);
    if (s.blockCode){ var bl = document.createElement('span'); bl.className = 'cs-setchip-block'; bl.textContent = s.blockCode.toUpperCase(); bl.title = (s.block || s.blockCode) + ' block'; b.appendChild(bl); }
    b.onclick = function(){ if (SETB.sel[code]) delete SETB.sel[code]; else SETB.sel[code] = 1; b.classList.toggle('sel'); renderSetFoot(); };
    return b;
  }
  function renderSetFoot(){
    var n = setSelSize(), fn = fmtSelSize(), parts = [];
    if (fn) parts.push(fn + ' format' + (fn > 1 ? 's' : ''));
    if (n) parts.push(n + ' set' + (n > 1 ? 's' : ''));
    $('cs-setcount').textContent = parts.length ? (parts.join(' · ') + ' selected') : 'Nothing selected';
  }

  function applySetBrowser(){
    var vals = new Set();
    // Preserve any existing Set filter the modal can't represent (a store set name
    // with no catalog match yet) so Apply never silently drops a user's filter.
    var prev = facetState['Set'];
    if (prev) prev.forEach(function(name){ if (!(SETB.byTagVal[name] || SETB.byNorm[setNorm(name)])) vals.add(name); });
    Object.keys(SETB.sel || {}).forEach(function(c){ vals.add(setFacetValue(c)); });
    if (vals.size) facetState['Set'] = vals; else delete facetState['Set'];
    // Format selection → its own facet dimension (per-card legality tags).
    var fvals = new Set(); Object.keys(SETB.fmtSel || {}).forEach(function(f){ fvals.add(f); });
    if (fvals.size) facetState['Format'] = fvals; else delete facetState['Format'];
    commitGame();   // engage the API path for the game the browser is showing
    closeSetBrowser(); updateSetBrowseCount(); syncUrl();
    refilter();   // mtgSetFrag/mtgFmtFrag filter server-side; paginated unless a search term is set
  }
  function clearSetBrowser(){ SETB.sel = {}; SETB.fmtSel = {}; renderSetBody(); renderSetFoot(); }
  // Button badge reflects both dimensions the modal manages.
  function updateSetBrowseCount(){
    var n = ((facetState['Set'] && facetState['Set'].size) || 0) + ((facetState['Format'] && facetState['Format'].size) || 0);
    var el = $('cs-setbrowse-cnt'); if (el) el.textContent = n ? ('(' + n + ')') : '';
  }
  function updateSetBrowseVisibility(){
    // A definite game context: an explicit single-game pick, or one inferred from the
    // current results (so a Pokémon search on "All" still offers the Sets browser +
    // Pokémon panel). The advanced panel is also available on a bare "All" (defaults
    // to Magic) and commits the game once a control is used — see commitGame.
    var single = mtgOnly() || pokemonOnly();
    var haveCtx = single || resultsGame() != null;
    var btn = $('cs-setbrowse-btn'); if (btn) btn.style.display = haveCtx ? 'inline-flex' : 'none';
    var adv = $('cs-adv-btn'); if (adv){ var showAdv = haveCtx || selGames.size === 0; adv.style.display = showAdv ? 'inline-flex' : 'none'; if (!showAdv) advClose(); }
    // Rebuild the advanced panel when the game context flips (MTG ↔ Pokémon).
    if (typeof advBuild === 'function' && advBuiltGame !== advGame()){ advBuiltGame = advGame(); advBuild(); }
    if (typeof advRender === 'function') advRender();
  }

  // ── Init ──
  document.addEventListener('DOMContentLoaded', function(){
    $('cs-form').addEventListener('submit', doSearch);
    // autocomplete typeahead on the search input
    var qEl = $('cs-q');
    // Nudge shoppers toward the typed-filter language.
    var basePh = qEl.getAttribute('placeholder') || '';
    if (basePh.indexOf('?') === -1) qEl.setAttribute('placeholder', basePh + '   ·   type ? for help');
    qEl.addEventListener('input', function(){
      clearTimeout(acTimer);
      // "?" opens the command cheat-sheet; the typed filter language (c:rg, t:elf, r:m…)
      // takes over when the active token is a filter; otherwise card-name predictive search.
      if (advMaybeHelp()) return;
      if (advMaybeFilterAC()) return;
      acMode = 'name';
      var term = qEl.value.trim();
      if (term.length < 2){ closeAC(); return; }
      // Filter-intent rows are synchronous → show them now, on TOP of whatever cards
      // are already in the dropdown (showAC keeps acLastProducts); the card lookup below
      // then refreshes those cards. Don't blank the box here — that caused the flicker.
      acBareComps = bareFilterAllowed() ? bareFilterCompletions(term) : [];
      if (acBareComps.length) showAC();
      acTimer = setTimeout(function(){ fetchAC(term); }, 180);
    });
    qEl.addEventListener('keydown', function(e){
      if (!$('cs-ac').classList.contains('open')) return;
      if (e.key === 'ArrowDown'){ e.preventDefault(); setAcActive(Math.min(acIndex+1, acItems.length-1)); }
      else if (e.key === 'ArrowUp'){ e.preventDefault(); setAcActive(Math.max(acIndex-1, 0)); }
      else if (e.key === 'Enter'){
        if (acMode === 'filter'){ if (acIndex>=0 && acItems[acIndex]){ e.preventDefault(); advChooseToken(acItems[acIndex]); } }
        else if (acIndex>=0 && acItems[acIndex]){
          e.preventDefault();
          var sel = acItems[acIndex];
          // Filter rows (from bareFilterCompletions) carry a .kind; card suggestions don't.
          if (sel.kind) applyBareFilter(sel); else chooseAC(sel);
        }
      }
      else if (e.key === 'Escape'){ closeAC(); }
    });
    qEl.addEventListener('blur', function(){ setTimeout(closeAC, 120); });
    // ⌘K / Ctrl+K focuses the search bar from anywhere on the page.
    document.addEventListener('keydown', function(e){
      if ((e.metaKey || e.ctrlKey) && !e.altKey && (e.key === 'k' || e.key === 'K')){ e.preventDefault(); qEl.focus(); qEl.select(); }
    });
    // sort dropdown (single-select; re-fetches with a server sortKey)
    document.querySelectorAll('#cs-sort-dd [data-sort]').forEach(function(b){
      b.addEventListener('click', function(){
        sortMode = b.dataset.sort;
        $('cs-sort-label').textContent = b.textContent.trim().replace(/^Sort:\s*/, '');
        $('cs-sort-dd').open = false;
        reload();
      });
    });
    // list / grid / sell view toggle (manual choice suppresses auto-switch)
    // Sell has no index API to read from without a backend base, so hide it rather
    // than offer a view that can only render an error.
    if (!API_BASE){ var sbtn = document.querySelector('#cs-view-toggle [data-view="sell"]'); if (sbtn) sbtn.style.display = 'none'; }
    // Which sets we're not buying — the Sell view greys those printings out. Fetched
    // once here (fails open) so the first sell render already has it.
    else if (window.TTT && TTT.buylist) TTT.buylist.load(API_BASE);
    document.querySelectorAll('#cs-view-toggle .cs-vt-btn').forEach(function(b){
      b.addEventListener('click', function(){
        var was = sellMode();
        viewMode = b.dataset.view; viewExplicit = true;
        var now = sellMode();
        if (was !== now){ toggleSellMode(now); return; }   // refetches
        if (cards.length) render();
        else updateFilterVisibility();
      });
    });
    // combined Game + Product-Type filter (multi-select checkboxes, one dropdown).
    // Clicking a row toggles it; the "All X" row clears that dimension. The menu
    // stays open so several can be ticked, and each toggle re-runs the query.
    document.querySelectorAll('#cs-filter-dd .cs-fil').forEach(function(b){
      b.addEventListener('click', function(e){
        e.preventDefault();
        var dim = b.dataset.dim, val = b.dataset.val, set = (dim === 'game') ? selGames : selTypes;
        if (val === '') set.clear();
        else if (set.has(val)) set.delete(val);
        else set.add(val);
        if (dim === 'game'){
          // A game switch is a fresh context — drop the previous game's server-side
          // filters (MTG Set/Format/Color/Rarity/Type/Supertype/Subtype + Pokémon
          // Energy/Series) so a stale tag from one game can't hide everything in the
          // newly selected game (they share namespaces like Rarity with different vocab).
          for (var gns in facetState){ if (MTG_SERVER_NS[gns] || gns === 'Energy' || gns === 'Series') delete facetState[gns]; }
          ADV.cmode = 'or'; ADV.cexc = new Set(); ADV.submode = 'or';
          if (typeof SETB !== 'undefined'){ SETB.sel = {}; SETB.fmtSel = {}; }
        }
        viewExplicit = false;   // let the new selection auto-pick list vs grid
        renderFilterUI();
        updateSetBrowseVisibility();   // "Sets" button is MTG-only
        updateSetBrowseCount();
        syncUrl();
        refilter();
      });
    });
    // client-side filters → re-render
    // Touching one of these filters is the shopper taking the wheel back — drop any
    // forced widening first, or their change would appear to do nothing (the widened
    // dimension is neutralised in activeFilters).
    function userFilterChange(){ RELAX_FORCE = []; apiFallback = false; pinnedName = null; pinStage = 0; render(); }
    ['cs-finish-menu','cs-cond-menu'].forEach(function(id){ $(id).addEventListener('change', userFilterChange); });
    ['cs-pmin','cs-pmax'].forEach(function(id){ $(id).addEventListener('change', userFilterChange); });
    // In-stock changes the SERVER query (available_for_sale), so a toggle must always
    // trigger a fresh fetch — the currently-loaded set is in-stock-only after checking
    // (or lacks OOS cards until we refetch after unchecking), so client-side re-filtering
    // alone can't honour the new state. syncUrl first so the URL matches the checkbox,
    // then force a refetch. Guarding refetches with searchGen already drops any stale
    // in-flight response, so the newest toggle always wins.
    $('cs-instock').addEventListener('change', function(){
      syncUrl();
      if ($('cs-q').value.trim()) doSearch(); else loadDefault();
    });
    // close dropdowns on outside click
    document.addEventListener('click', function(e){
      if (!e.target.closest('#cs-app details')) {
        document.querySelectorAll('#cs-app details[open]').forEach(function(d){ d.open = false; });
      }
    });
    document.addEventListener('keydown', function(e){ if (e.key==='Escape'){ closeDetail(); closeCart(); closeFacets(); closeSell(); closeSetBrowser(); } });
    // Arrow keys browse the open detail modal through the result list (desktop).
    document.addEventListener('keydown', function(e){
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var dir = e.key === 'ArrowRight' ? 1 : -1;
      if ($('cs-detail').style.display === 'flex'){ e.preventDefault(); detailNav(dir); }
      else if ($('cs-cart').style.display === 'flex'){ e.preventDefault(); cartNav(dir); }
    });
    // Whole combined cart sheet is swipeable left/right → next/prev card. Bound once;
    // a horizontal-dominant swipe navigates, vertical gestures still scroll the sheet.
    (function(){
      var x0 = null, y0 = null;
      var sheet = $('cs-cart-card');
      sheet.addEventListener('touchstart', function(e){ var t = e.changedTouches[0]; x0 = t.clientX; y0 = t.clientY; }, { passive:true });
      sheet.addEventListener('touchend', function(e){
        if (x0 == null) return;
        var t = e.changedTouches[0], dx = t.clientX - x0, dy = t.clientY - y0;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.4) cartNav(dx < 0 ? 1 : -1);
        x0 = y0 = null;
      }, { passive:true });
    })();
    // copy a shareable link to the current search
    $('cs-copylink').addEventListener('click', function(){
      var btn = this;
      var linkIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 15 15 9"/><path d="M10.5 6.5 12 5a4 4 0 0 1 6 6l-1.5 1.5"/><path d="M13.5 17.5 12 19a4 4 0 0 1-6-6l1.5-1.5"/></svg>';
      var checkIcon = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';
      function done(){ btn.innerHTML = checkIcon; btn.classList.add('copied'); setTimeout(function(){ btn.innerHTML = linkIcon; btn.classList.remove('copied'); }, 1500); }
      if (navigator.clipboard && navigator.clipboard.writeText){
        navigator.clipboard.writeText(location.href).then(done).catch(function(){ fallback(); });
      } else { fallback(); }
      function fallback(){
        var i = document.createElement('input'); i.value = location.href; document.body.appendChild(i); i.select();
        try { document.execCommand('copy'); } catch(e){} i.remove(); done();
      }
    });
    // facet drawer (mobile off-canvas)
    $('cs-facets-toggle').addEventListener('click', function(){ $('cs-facets').classList.add('open'); $('cs-facets-backdrop').classList.add('open'); });
    $('cs-facets-close').addEventListener('click', closeFacets);
    $('cs-facets-backdrop').addEventListener('click', closeFacets);
    // set browser modal
    $('cs-setbrowse-btn').addEventListener('click', openSetBrowser);
    $('cs-setapply').addEventListener('click', applySetBrowser);
    $('cs-setclear').addEventListener('click', clearSetBrowser);
    $('cs-setmodal-q').addEventListener('input', function(){ setSetQuery(this.value); });
    // re-render only when crossing the mobile/desktop breakpoint
    var wasMobile = isMobile();
    window.addEventListener('resize', function(){
      var m = isMobile();
      if (m !== wasMobile){ wasMobile = m; placeFilters(); if (cards.length) render(); }
    });
    updateCounts();
    placeFilters();
    parseUrl();
    applySellUi();   // ?v=sell must dress the controls before the first fetch, not after
    loadBanlists();                // format ban lists (small JSON, loads in background)
    updateSetBrowseVisibility();   // show "Sets" if the URL seeded game=mtg
    updateSetBrowseCount();        // reflect any ?set= seeded selection
    keepFilters = true;   // preserve URL-seeded facetState through the first fetch
    // Embedded (workbench): don't auto-load the whole MTG catalog — wait for
    // CardSearch.embedSetup() once the commander (and its colours) are known.
    if (!EMBED){ if ($('cs-q').value.trim()) doSearch(); else loadDefault(); }
    refreshCart();
    if (window.SellDraft) window.SellDraft.mountDrawer('/pages/sell-cards');
  });
  function closeFacets(){ $('cs-facets').classList.remove('open'); $('cs-facets-backdrop').classList.remove('open'); }

  // ── Advanced MTG filter panel (the sliders button in the search bar) ──
  var ADV_COLORS = [['W','White'],['U','Blue'],['B','Black'],['R','Red'],['G','Green'],['C','Colorless']];
  var ADV_C2NAME = { W:'White', U:'Blue', B:'Black', R:'Red', G:'Green', C:'Colorless' };
  var ADV_RARITY = ['Common','Uncommon','Rare','Mythic','Special'];
  var ADV_TYPES = ['Creature','Instant','Sorcery','Artifact','Enchantment','Land','Planeswalker','Battle'];
  var ADV_SUPERS = ['Legendary','Snow','Basic'];
  // Curated subtype suggestions (ordered roughly by stock frequency). Server matches
  // any typed value via flat tags, so this list only needs to aid discovery.
  var ADV_SUBVOCAB = ['Human','Wizard','Warrior','Soldier','Elf','Zombie','Goblin','Spirit','Elemental','Dragon','Cleric','Knight','Vampire','Beast','Angel','Druid','Cat','Merfolk','Demon','Rogue','Shaman','Phyrexian','Bird','Ninja','Eldrazi','Construct','Artificer','Sliver','Dwarf','Giant','Hydra','Phoenix','Snake','Spider','Wolf','Bear','Cleric','Faerie','Dinosaur','Horror','Insect','Golem','Avatar','God','Devil','Imp','Treefolk','Sphinx','Hag','Kithkin','Kor','Minotaur','Ooze','Pirate','Rat','Samurai','Satyr','Scarecrow','Serpent','Shapeshifter','Skeleton','Specter','Thopter','Troll','Wall','Werewolf','Wraith','Wurm','Zombie','Aura','Saga','Equipment','Vehicle','Curse','Shrine','Background','Food','Treasure','Clue','Blood'];
  var ADV_SUBSEEN = {}; var ADV_SUB = []; ADV_SUBVOCAB.forEach(function(s){ if (!ADV_SUBSEEN[s]){ ADV_SUBSEEN[s]=1; ADV_SUB.push(s); } });
  // ── Pokémon advanced-filter vocab (parallels the MTG lists above) ──
  var ADV_ENERGY = ['Grass','Fire','Water','Lightning','Psychic','Fighting','Darkness','Metal','Fairy','Dragon','Colorless'];
  // Canonical (pokemontcg.io) rarities, ordered by the modern chase ladder + classics.
  var ADV_PK_RARITY = ['Common','Uncommon','Rare','Double Rare','Ultra Rare','Illustration Rare','Special Illustration Rare','Hyper Rare','ACE SPEC Rare','Rare Holo','Radiant Rare','Amazing Rare','Rare Secret','Rare Rainbow','Promo'];
  var ADV_PK_SUPERS = ['Pokémon','Trainer','Energy'];
  // High collector-value mechanics + stages + trainer kinds (ordered by discovery value).
  var ADV_PK_SUB = ['ex','V','VMAX','VSTAR','V-UNION','GX','EX','Radiant','Tera','TAG TEAM','BREAK','Prime','Basic','Stage 1','Stage 2','MEGA','Baby','Supporter','Item','Stadium','Pokémon Tool','ACE SPEC','Ultra Beast','Amazing','Single Strike','Rapid Strike','Fusion Strike','Ancient','Future'];

  function advColState(name){ var inc = facetState['Color']; if (inc && inc.has(name)) return 'in'; if (ADV.cexc.has(name)) return 'not'; return 'off'; }
  function advFacetAdd(ns, val, on){ if (on){ if (!facetState[ns]) facetState[ns] = new Set(); facetState[ns].add(val); } else if (facetState[ns]){ facetState[ns].delete(val); if (!facetState[ns].size) delete facetState[ns]; } }
  // Using an advanced (MTG) filter from any other game context flips the shopper to
  // Magic — without clearing the filter they're applying (unlike the dropdown switch).
  function switchToMagic(){
    if (mtgOnly()) return;
    // Make Magic the sole game so the MTG-only frags apply (keeps the filter being set).
    selGames = new Set(['MTG Single']);
    if (typeof renderFilterUI === 'function') renderFilterUI();
    if (typeof updateSetBrowseVisibility === 'function') updateSetBrowseVisibility();
  }
  // Using an advanced/typed/set filter from a mixed ("All") context commits to the game
  // the controls are showing (advGame — inferred from the results), so the server (API)
  // filter engages. Generalizes switchToMagic to Pokémon.
  function commitGame(){
    if (mtgOnly() || pokemonOnly()) return;
    selGames = new Set([advGame() === 'pokemon' ? 'Pokemon Single' : 'MTG Single']);
    if (typeof renderFilterUI === 'function') renderFilterUI();
    if (typeof updateSetBrowseVisibility === 'function') updateSetBrowseVisibility();
  }
  function advChanged(){ commitGame(); if (typeof syncUrl === 'function') syncUrl(); advRender(); if ((mtgOnly() || pokemonOnly()) && SET_SERVER_FILTER) refilter(); else render(); }

  function advBuild(){ if (advGame() === 'pokemon') return advBuildPokemon(); return advBuildMtg(); }

  // Pokémon advanced panel: energy-type + rarity + card-supertype chips + a subtype box.
  function advBuildPokemon(){
    var host = $('cs-adv'); if (!host) return;
    host.innerHTML =
      '<button class="cs-adv-clear" id="cs-adv-clear" type="button">Clear filters</button>' +
      '<div class="cs-adv-grid">' +
        '<div class="cs-adv-lab">Energy</div><div class="cs-adv-ctl" id="cs-adv-energy"></div>' +
        '<div class="cs-adv-lab">Rarity</div><div class="cs-adv-ctl" id="cs-adv-rarity"></div>' +
        '<div class="cs-adv-lab">Card</div><div class="cs-adv-ctl" id="cs-adv-super"></div>' +
      '</div>' +
      '<div style="max-width:560px;margin:.5rem auto 0">' +
        '<div style="display:flex;align-items:center;gap:.6rem;margin-bottom:.3rem">' +
          '<div class="cs-adv-lab" style="text-align:left;margin:0">Subtype</div>' +
          '<div class="cs-seg2" id="cs-submode" title="How multiple subtypes combine">' +
            '<button type="button" data-sm="or">Any</button>' +
            '<button type="button" data-sm="and">All</button>' +
          '</div>' +
        '</div>' +
        '<div class="cs-subbox" id="cs-subbox"><span id="cs-subchips" style="display:contents"></span>' +
        '<input id="cs-subin" autocomplete="off" placeholder="search subtypes: ex, V, VMAX, Supporter…">' +
        '<div class="cs-subpop" id="cs-subpop"></div></div>' +
      '</div>';
    var ec = $('cs-adv-energy');
    ADV_ENERGY.forEach(function(en){ var e = document.createElement('span'); e.className = 'cs-tc cs-epip'; e.setAttribute('data-e', en); e.innerHTML = '<i class="cs-edot"></i>' + en;
      e.onclick = function(){ var on = !(facetState['Energy'] && facetState['Energy'].has(en)); advFacetAdd('Energy', en, on); advChanged(); }; ec.appendChild(e); });
    var rr = $('cs-adv-rarity');
    ADV_PK_RARITY.forEach(function(r){ var e = document.createElement('span'); e.className = 'cs-gem cs-prare'; e.setAttribute('data-r', r); e.innerHTML = '<i class="cs-psym"></i>' + r;
      e.onclick = function(){ var on = !(facetState['Rarity'] && facetState['Rarity'].has(r)); advFacetAdd('Rarity', r, on); advChanged(); }; rr.appendChild(e); });
    var tt = $('cs-adv-super');
    ADV_PK_SUPERS.forEach(function(t){ var e = document.createElement('span'); e.className = 'cs-tc'; e.setAttribute('data-super','1'); e.textContent = t;
      e.onclick = function(){ var on = !(facetState['Supertype'] && facetState['Supertype'].has(t)); advFacetAdd('Supertype', t, on); advChanged(); }; tt.appendChild(e); });
    $('cs-adv-clear').onclick = clearAllFilters;
    advBindSub();
  }

  function advBuildMtg(){
    var host = $('cs-adv'); if (!host) return;
    host.innerHTML =
      '<button class="cs-adv-clear" id="cs-adv-clear" type="button">Clear filters</button>' +
      '<div class="cs-adv-grid">' +
        '<div class="cs-adv-lab">Color</div><div class="cs-adv-ctl" id="cs-adv-color"></div>' +
        '<div class="cs-adv-lab">Rarity</div><div class="cs-adv-ctl" id="cs-adv-rarity"></div>' +
        '<div class="cs-adv-lab">Type</div><div class="cs-adv-ctl" id="cs-adv-type"></div>' +
      '</div>' +
      '<div style="max-width:560px;margin:.5rem auto 0">' +
        '<div style="display:flex;align-items:center;gap:.6rem;margin-bottom:.3rem">' +
          '<div class="cs-adv-lab" style="text-align:left;margin:0">Subtype</div>' +
          '<div class="cs-seg2" id="cs-submode" title="How multiple subtypes combine">' +
            '<button type="button" data-sm="or">Any</button>' +
            '<button type="button" data-sm="and">All</button>' +
          '</div>' +
        '</div>' +
        '<div class="cs-subbox" id="cs-subbox"><span id="cs-subchips" style="display:contents"></span>' +
        '<input id="cs-subin" autocomplete="off" placeholder="search subtypes: Elf, Goblin, Aura…">' +
        '<div class="cs-subpop" id="cs-subpop"></div></div>' +
      '</div>';
    // colors
    var cc = $('cs-adv-color');
    ADV_COLORS.forEach(function(pair){ var e = document.createElement('div'); e.className = 'cs-pip'; e.setAttribute('data-c', pair[0]); e.textContent = pair[0]; e.title = pair[1];
      e.onclick = function(){ var name = pair[1], st = advColState(name); advFacetAdd('Color', name, false); ADV.cexc.delete(name);
        if (st === 'off') advFacetAdd('Color', name, true); else if (st === 'in') ADV.cexc.add(name); advChanged(); }; cc.appendChild(e); });
    var seg = document.createElement('div'); seg.className = 'cs-seg2'; seg.id = 'cs-cmode';
    [['or','Any'],['exact','Exact'],['commander','Commander']].forEach(function(m){ var b = document.createElement('button'); b.type='button'; b.setAttribute('data-m', m[0]); b.textContent = m[1]; b.title = (m[0]==='commander' ? 'Color identity: any subset of these colors, excluding off-color cards' : ''); b.onclick = function(){ ADV.cmode = m[0]; advChanged(); }; seg.appendChild(b); });
    cc.appendChild(seg);
    // rarity
    var rr = $('cs-adv-rarity');
    ADV_RARITY.forEach(function(r){ var e = document.createElement('span'); e.className = 'cs-gem'; e.setAttribute('data-r', r); e.innerHTML = '<i class="d"></i>' + r;
      e.onclick = function(){ var on = !(facetState['Rarity'] && facetState['Rarity'].has(r)); advFacetAdd('Rarity', r, on); advChanged(); }; rr.appendChild(e); });
    // type + supertype (one row)
    var tt = $('cs-adv-type');
    ADV_TYPES.forEach(function(t){ var e = document.createElement('span'); e.className = 'cs-tc'; e.textContent = t;
      e.onclick = function(){ var on = !(facetState['Type'] && facetState['Type'].has(t)); advFacetAdd('Type', t, on); advChanged(); }; tt.appendChild(e); });
    ADV_SUPERS.forEach(function(t){ var e = document.createElement('span'); e.className = 'cs-tc'; e.setAttribute('data-super','1'); e.textContent = t;
      e.onclick = function(){ var on = !(facetState['Supertype'] && facetState['Supertype'].has(t)); advFacetAdd('Supertype', t, on); advChanged(); }; tt.appendChild(e); });
    $('cs-adv-clear').onclick = clearAllFilters;
    advBindSub();
  }

  function advBindSub(){
    var subin = $('cs-subin'), pop = $('cs-subpop'), box = $('cs-subbox'); if (!subin) return;
    var VOCAB = advGame() === 'pokemon' ? ADV_PK_SUB : ADV_SUB;
    var subItems = [], subIdx = -1;
    box.addEventListener('mousedown', function(e){ if (e.target === box || e.target.id === 'cs-subchips') subin.focus(); });
    function highlight(i){
      subIdx = i;
      var nodes = pop.children;
      for (var k = 0; k < nodes.length; k++) nodes[k].classList.toggle('cs-subactive', k === i);
      if (nodes[i]) nodes[i].scrollIntoView({ block:'nearest' });
    }
    // Add a subtype, then keep the popup open with the cursor in the field so the
    // shopper can immediately add another (advChanged re-renders results + chips,
    // but never rebuilds this input, so focus survives).
    function addSub(s){
      advFacetAdd('Subtype', s, true);
      subin.value = ''; advChanged();
      suggest(); subin.focus();
    }
    function suggest(){
      var q = subin.value.toLowerCase();
      subItems = VOCAB.filter(function(s){ return (!q || s.toLowerCase().indexOf(q) >= 0) && !(facetState['Subtype'] && facetState['Subtype'].has(s)); }).slice(0, 12);
      pop.innerHTML = '';
      subItems.forEach(function(s, i){
        var d = document.createElement('div');
        d.appendChild(document.createTextNode(s));
        var c = document.createElement('span'); c.className = 'c'; c.textContent = 'subtype'; d.appendChild(c);
        d.onmousedown = function(e){ e.preventDefault(); addSub(s); };
        d.onmouseenter = function(){ highlight(i); };
        pop.appendChild(d);
      });
      subIdx = subItems.length ? 0 : -1;
      highlight(subIdx);
      pop.classList.toggle('open', subItems.length > 0);
    }
    subin.onfocus = suggest;
    subin.oninput = suggest;
    subin.onkeydown = function(e){
      if (!pop.classList.contains('open')){ if (e.key === 'ArrowDown') suggest(); return; }
      if (e.key === 'ArrowDown'){ e.preventDefault(); highlight(Math.min(subIdx + 1, subItems.length - 1)); }
      else if (e.key === 'ArrowUp'){ e.preventDefault(); highlight(Math.max(subIdx - 1, 0)); }
      else if (e.key === 'Enter'){ if (subIdx >= 0 && subItems[subIdx]){ e.preventDefault(); addSub(subItems[subIdx]); } }
      else if (e.key === 'Escape'){ pop.classList.remove('open'); }
    };
    subin.onblur = function(){ setTimeout(function(){ pop.classList.remove('open'); }, 160); };
    // And/Or join toggle
    var sm = $('cs-submode');
    if (sm) Array.prototype.forEach.call(sm.querySelectorAll('button'), function(b){
      b.onclick = function(){ ADV.submode = b.getAttribute('data-sm'); advRender(); if (facetState['Subtype'] && facetState['Subtype'].size) advChanged(); subin.focus(); };
    });
  }

  // Shared submode toggle + subtype chip render (identical for both games).
  function advRenderSubShared(){
    var sm = $('cs-submode'); if (sm){ Array.prototype.forEach.call(sm.querySelectorAll('button'), function(b){ b.classList.toggle('sel', b.getAttribute('data-sm') === ADV.submode); }); }
    var chips = $('cs-subchips'); if (chips){ chips.innerHTML = '';
      if (facetState['Subtype']) facetState['Subtype'].forEach(function(s){ var e = document.createElement('span'); e.className = 'cs-subt'; e.innerHTML = s + '<span class="x">✕</span>';
        e.querySelector('.x').onclick = function(ev){ ev.stopPropagation(); advFacetAdd('Subtype', s, false); advChanged(); }; chips.appendChild(e); }); }
  }

  function advRender(){ if (advGame() === 'pokemon') return advRenderPokemon(); return advRenderMtg(); }

  function advRenderPokemon(){
    if (!$('cs-adv-energy')) return;
    document.querySelectorAll('#cs-adv-energy .cs-tc').forEach(function(e){ e.classList.toggle('sel', !!(facetState['Energy'] && facetState['Energy'].has(e.getAttribute('data-e')))); });
    document.querySelectorAll('#cs-adv-rarity .cs-gem').forEach(function(e){ e.classList.toggle('sel', !!(facetState['Rarity'] && facetState['Rarity'].has(e.getAttribute('data-r')))); });
    document.querySelectorAll('#cs-adv-super .cs-tc').forEach(function(e){ e.classList.toggle('sel', !!(facetState['Supertype'] && facetState['Supertype'].has(e.textContent))); });
    advRenderSubShared();
    var n = 0; ['Energy','Rarity','Supertype','Subtype','Series'].forEach(function(ns){ if (facetState[ns]) n += facetState[ns].size; });
    var cnt = $('cs-adv-count'); if (cnt) cnt.innerHTML = n ? '<span class="cs-advdot">' + n + '</span>' : '';
    var clr = $('cs-adv-clear'); if (clr){ var any = n > 0 || (facetState['Set'] && facetState['Set'].size); clr.style.display = any ? '' : 'none'; }
  }

  function advRenderMtg(){
    if (!$('cs-adv-color')) return;
    document.querySelectorAll('#cs-adv-color .cs-pip').forEach(function(e){ var st = advColState(ADV_C2NAME[e.getAttribute('data-c')]); e.classList.toggle('on', st==='in'); e.classList.toggle('not', st==='not'); e.classList.toggle('off', st==='off'); });
    document.querySelectorAll('#cs-cmode button').forEach(function(b){ b.classList.toggle('sel', b.getAttribute('data-m') === ADV.cmode); });
    document.querySelectorAll('#cs-adv-rarity .cs-gem').forEach(function(e){ e.classList.toggle('sel', !!(facetState['Rarity'] && facetState['Rarity'].has(e.getAttribute('data-r')))); });
    document.querySelectorAll('#cs-adv-type .cs-tc').forEach(function(e){ var ns = e.getAttribute('data-super') ? 'Supertype' : 'Type'; e.classList.toggle('sel', !!(facetState[ns] && facetState[ns].has(e.textContent))); });
    advRenderSubShared();
    var n = 0; ['Color','Rarity','Type','Supertype','Subtype'].forEach(function(ns){ if (facetState[ns]) n += facetState[ns].size; }); n += ADV.cexc.size;
    var cnt = $('cs-adv-count'); if (cnt) cnt.innerHTML = n ? '<span class="cs-advdot">' + n + '</span>' : '';
    var clr = $('cs-adv-clear'); if (clr){ var any = n > 0 || ADV.cmode !== 'or' || (facetState['Set'] && facetState['Set'].size) || (facetState['Format'] && facetState['Format'].size); clr.style.display = any ? '' : 'none'; }
  }

  function advClose(){ var p = $('cs-adv'); if (p) p.classList.remove('open'); var b = $('cs-adv-btn'); if (b) b.classList.remove('active'); }
  function advToggle(){ var p = $('cs-adv'); if (!p) return; var open = p.classList.toggle('open'); $('cs-adv-btn').classList.toggle('active', open); if (open) advRender(); }

  // ── Typed filter language in the search box (c:rg, t:elf, r:m, legendary:true) ──
  var ADV_ORD = 'WUBRG';
  function advSortC(s){ return s.split('').sort(function(a,b){ return ADV_ORD.indexOf(a) - ADV_ORD.indexOf(b); }).join(''); }
  var ADV_GUILDS = {W:'White',U:'Blue',B:'Black',R:'Red',G:'Green',C:'Colorless',WU:'Azorius',WB:'Orzhov',WR:'Boros',WG:'Selesnya',UB:'Dimir',UR:'Izzet',UG:'Simic',BR:'Rakdos',BG:'Golgari',RG:'Gruul',WUB:'Esper',WUR:'Jeskai',WUG:'Bant',WBR:'Mardu',WBG:'Abzan',WRG:'Naya',UBR:'Grixis',UBG:'Sultai',URG:'Temur',BRG:'Jund',WUBR:'Yore',WUBG:'Witch',WURG:'Ink',WBRG:'Dune',UBRG:'Glint',WUBRG:'Five-color'};
  var ADV_NAME2C = {azorius:'WU',dimir:'UB',rakdos:'BR',gruul:'RG',selesnya:'WG',orzhov:'WB',izzet:'UR',golgari:'BG',boros:'WR',simic:'UG',esper:'WUB',grixis:'UBR',jund:'BRG',naya:'WRG',bant:'WUG',abzan:'WBG',jeskai:'WUR',sultai:'UBG',mardu:'WBR',temur:'URG'};
  var ADV_NAME1 = {white:'W',blue:'U',black:'B',red:'R',green:'G',colorless:'C'};
  function advColorCompletions(val, exact){
    var low = val.toLowerCase(), typed = '';
    if (ADV_NAME1[low] != null) typed = ADV_NAME1[low];
    else if (ADV_NAME2C[low]) typed = ADV_NAME2C[low];
    else { var gm = null; for (var g in ADV_NAME2C){ if (g.indexOf(low) === 0 && low.length >= 2){ gm = g; break; } } if (gm) typed = ADV_NAME2C[gm];
      else typed = val.toUpperCase().split('').filter(function(ch,i,a){ return 'WUBRGC'.indexOf(ch) >= 0 && a.indexOf(ch) === i; }).join(''); }
    var set = advSortC(typed.replace(/C/g,''));
    function mk(code){ return { kind:'color', code:code, exact:exact, label:(ADV_GUILDS[code]||code)+(exact?' (exact)':''), colors:code.split('') }; }
    if (set){
      // colors typed → that combo first, then each one-color superset
      var out = [mk(set)];
      for (var i=0;i<ADV_ORD.length;i++){ var ch = ADV_ORD[i]; if (set.indexOf(ch) < 0){ var sup = advSortC(set+ch); if (sup.length <= 5) out.push(mk(sup)); } }
      return out.slice(0,7);
    }
    if (typed === 'C' || low === 'colorless') return [mk('C')];
    // nothing typed yet → the five mono colors + colorless, then the ten 2-color pairs
    var monos = ['W','U','B','R','G','C'].map(mk);
    var pairs = ['WU','WB','WR','WG','UB','UR','UG','BR','BG','RG'].map(mk);
    return monos.concat(pairs);
  }
  // Pokémon typed filters: type:→energy, r:→rarity, super:, sub:, set:, series:.
  function advCompletionsPokemon(t){
    var m = t.match(/^(t|type|r|rarity|super|sub|subtype|set|s|e|series)([:=])(.*)$/i);
    if (!m) return null;
    var key = m[1].toLowerCase(), val = m[3], out = [];
    var q = val.toLowerCase();
    if (key === 't' || key === 'type'){ out = ADV_ENERGY.filter(function(x){ return !q || x.toLowerCase().indexOf(q) === 0; }).map(function(x){ return { kind:'energy', label:x, value:x }; }); }
    else if (key === 'r' || key === 'rarity'){ out = ADV_PK_RARITY.filter(function(r){ return !q || r.toLowerCase().indexOf(q) >= 0; }).slice(0, 10).map(function(r){ return { kind:'rarity', label:r, value:r }; }); }
    else if (key === 'super'){ out = ADV_PK_SUPERS.filter(function(x){ return !q || x.toLowerCase().indexOf(q) >= 0; }).map(function(x){ return { kind:'supertype', label:x, value:x }; }); }
    else if (key === 'sub' || key === 'subtype'){ out = ADV_PK_SUB.filter(function(x){ return !q || x.toLowerCase().indexOf(q) >= 0; }).slice(0, 10).map(function(x){ return { kind:'subtype', label:x, value:x }; }); }
    else if (key === 'series'){ out = advSeriesCompletions(val); }
    else if (key === 'set' || key === 's' || key === 'e'){ out = advSetCompletions(val); }
    return out;
  }
  // series:scarlet → the set browser's series list (from pokemon-sets.json groups).
  function advSeriesCompletions(val){
    if (!SETB.loaded || SETB.game !== 'pokemon'){ loadSets().then(function(){ if (acMode === 'filter') advMaybeFilterAC(); }); return [{ kind:'loading', label:'Loading series…' }]; }
    var q = val.toLowerCase().trim();
    return ((SETB.groups && SETB.groups.bySeries) || [])
      .filter(function(g){ return !q || g.series.toLowerCase().indexOf(q) >= 0; })
      .slice(0, 12).map(function(g){ return { kind:'series', label:g.series + '  (' + g.codes.length + ')', value:g.series }; });
  }
  function advCompletions(tok){
    var neg = tok.charAt(0) === '-', t = neg ? tok.slice(1) : tok;
    if (advGame() === 'pokemon') return advCompletionsPokemon(t);
    var m = t.match(/^(c|color|t|type|r|rarity|super|sub|subtype|legendary|set|s|e|format|f|fmt|sort|kw|keyword|treatment|version)([:=])(.*)$/i);
    if (!m) return null;
    var key = m[1].toLowerCase(), op = m[2], val = m[3], out = [];
    if (key === 'c' || key === 'color'){ out = advColorCompletions(val, op === '=').map(function(o){ o.neg = neg; return o; }); }
    else if (key === 't' || key === 'type' || key === 'super' || key === 'sub' || key === 'subtype'){
      var q = val.toLowerCase(), want = function(x){ return x.toLowerCase().indexOf(q) === 0 || (q.length >= 2 && x.toLowerCase().indexOf(q) >= 0); };
      ADV_SUPERS.filter(want).forEach(function(x){ out.push({ kind:'supertype', label:x, value:x }); });
      ADV_TYPES.filter(want).forEach(function(x){ out.push({ kind:'type', label:x, value:x }); });
      ADV_SUB.filter(want).forEach(function(x){ if (ADV_TYPES.indexOf(x) < 0 && ADV_SUPERS.indexOf(x) < 0) out.push({ kind:'subtype', label:x, value:x }); });
      out = out.slice(0,8);
    }
    else if (key === 'r' || key === 'rarity'){ var rq = val.toLowerCase(); out = ADV_RARITY.filter(function(r){ return r.toLowerCase().indexOf(rq) === 0; }).map(function(r){ return { kind:'rarity', label:r, value:r }; }); }
    else if (key === 'legendary'){ out = [['true','Legendary'],['false','Non-legendary']].filter(function(p){ return p[0].indexOf(val.toLowerCase()) === 0; }).map(function(p){ return { kind:'legendary', label:p[1], value:p[0] }; }); }
    else if (key === 'format' || key === 'f' || key === 'fmt'){ out = advFormatCompletions(val); }
    else if (key === 'set' || key === 's' || key === 'e'){ out = advSetCompletions(val); }
    else if (key === 'sort'){ out = advSortCompletions(val); }
    else if (key === 'kw' || key === 'keyword'){ out = advKeywordCompletions(val); }
    else if (key === 'treatment' || key === 'version'){ out = advTreatmentCompletions(val); }
    return out;
  }
  // sort:popularity / sort:price → set the sort mode (index-search only).
  var SORT_OPTS = [['relevance','Relevance'],['popularity','Popularity (EDHREC)'],['released','Release date'],['price','Price: High → Low'],['name','Name: A → Z']];
  var SORT_ALIAS = { edhrec:'popularity', pop:'popularity', commander:'popularity', date:'released', release:'released', newest:'released', new:'released', 'high-to-low':'price', abc:'name', az:'name' };
  function advSortCompletions(val){
    var q = val.toLowerCase();
    return SORT_OPTS.filter(function(o){ return !q || o[0].indexOf(q) === 0 || o[1].toLowerCase().indexOf(q) >= 0 || SORT_ALIAS[q] === o[0]; })
      .map(function(o){ return { kind:'sort', label:o[1], value:o[0] }; });
  }
  var ADV_KEYWORDS = ['Flying','Deathtouch','Trample','Lifelink','Vigilance','Haste','First Strike','Double Strike','Menace','Reach','Hexproof','Indestructible','Flash','Defender','Ward','Prowess','Cascade','Convoke','Delve','Flashback','Cycling','Kicker','Equip','Protection','Shroud','Regenerate','Infect','Annihilator','Storm','Affinity','Suspend','Morph','Embalm','Explore','Adapt','Amass','Mentor','Riot','Escape','Mutate','Companion','Foretell','Disturb','Cleave','Blitz','Casualty','Connive','Enlist','Backup','Prototype','Unearth','Toxic','Bargain'];
  function advKeywordCompletions(val){
    var q = val.toLowerCase();
    return ADV_KEYWORDS.filter(function(k){ return !q || k.toLowerCase().indexOf(q) === 0 || (q.length >= 2 && k.toLowerCase().indexOf(q) >= 0); }).slice(0, 8).map(function(k){ return { kind:'keyword', label:k, value:k }; });
  }
  // The canonical vocabulary (assets/printing-utils.js, mirroring loyalty-app's
  // lib/treatments.ts). Was a hand-maintained copy that had drifted out of sync with what
  // the index actually stores. The literal fallback is only for a page that somehow loads
  // the engine without printing-utils; snippets/card-search-engine.liquid loads both.
  var ADV_TREATMENTS = (window.PrintingUtils && window.PrintingUtils.TREATMENT_ORDER)
    || ['Showcase','Borderless','Extended Art','Retro Frame','Full Art','Promo','Foil Etched','Reserved List'];
  function advTreatmentCompletions(val){
    var q = val.toLowerCase();
    return ADV_TREATMENTS.filter(function(t){ return !q || t.toLowerCase().indexOf(q) >= 0; }).map(function(t){ return { kind:'treatment', label:t, value:t }; });
  }
  // format:modern → the whitelisted MTG format tags (mtgFmtFrag turns these into tag: filters).
  function advFormatCompletions(val){
    var q = val.toLowerCase();
    return FORMAT_TAGS.filter(function(f){ return !q || f.toLowerCase().indexOf(q) === 0; })
      .slice(0, 10).map(function(f){ return { kind:'format', label:f, value:f }; });
  }
  // set:bloomburrow → autocompletes against the set browser's mtg-sets.json (loaded
  // lazily). Matches set name (prefix or contains) or exact set code.
  function advSetCompletions(val){
    if (!SETB.loaded){
      loadSets().then(function(){ if (acMode === 'filter') advMaybeFilterAC(); });
      return [{ kind:'loading', label:'Loading sets…' }];
    }
    var q = val.toLowerCase().trim();
    var list = SETB.sets.filter(function(s){
      if (!q) return s.inStock;
      var n = (s.name || '').toLowerCase(), c = (s.code || '').toLowerCase();
      return c === q || n.indexOf(q) === 0 || c.indexOf(q) === 0 || (q.length >= 3 && n.indexOf(q) >= 0);
    });
    list.sort(function(a, b){
      var ap = (a.name || '').toLowerCase().indexOf(q) === 0 ? 0 : 1, bp = (b.name || '').toLowerCase().indexOf(q) === 0 ? 0 : 1;
      return ap - bp || (b.released || '').localeCompare(a.released || '');
    });
    return list.slice(0, 8).map(function(s){ return { kind:'set', code:s.code, label:s.name + '  (' + (s.code || '').toUpperCase() + ')' }; });
  }
  function advApplyToken(o){
    if (o.kind === 'color'){
      if (o.neg){ o.colors.forEach(function(c){ var n = ADV_C2NAME[c]; if (n){ ADV.cexc.add(n); if (facetState['Color']){ facetState['Color'].delete(n); if (!facetState['Color'].size) delete facetState['Color']; } } }); }
      else { var s = new Set(); o.colors.forEach(function(c){ var n = ADV_C2NAME[c]; if (n) s.add(n); }); if (s.size){ facetState['Color'] = s; if (o.exact) ADV.cmode = 'exact'; } }
    }
    else if (o.kind === 'supertype') advFacetAdd('Supertype', o.value, true);
    else if (o.kind === 'type') advFacetAdd('Type', o.value, true);
    else if (o.kind === 'energy') advFacetAdd('Energy', o.value, true);
    else if (o.kind === 'series') advFacetAdd('Series', o.value, true);
    else if (o.kind === 'subtype') advFacetAdd('Subtype', o.value, true);
    else if (o.kind === 'rarity') advFacetAdd('Rarity', o.value, true);
    else if (o.kind === 'legendary') advFacetAdd('Supertype', 'Legendary', o.value !== 'false');
    else if (o.kind === 'format') advFacetAdd('Format', o.value, true);
    else if (o.kind === 'keyword') advFacetAdd('Keyword', o.value, true);
    else if (o.kind === 'treatment') advFacetAdd('Treatment', o.value, true);
    else if (o.kind === 'sort'){ sortMode = o.value; if (typeof setSortLabel === 'function') setSortLabel(); }
    // Use the same facet value the Sets modal stores (tagValue||name) so they stay mirrored.
    else if (o.kind === 'set') advFacetAdd('Set', setFacetValue(o.code), true);
  }
  function advActiveToken(){ var el = $('cs-q'), v = el.value, c = el.selectionStart != null ? el.selectionStart : v.length; var s = v.lastIndexOf(' ', c-1) + 1; return { start:s, end:c, text:v.slice(s,c) }; }
  function advRenderACFilter(comps){
    acGen++;   // invalidate any in-flight name lookup so it can't overwrite these filter completions
    acMode = 'filter'; acItems = comps; acIndex = comps.length ? 0 : -1;
    var box = $('cs-ac'); box.innerHTML = '';
    if (!comps.length){ closeAC(); return; }
    comps.forEach(function(o, i){
      var it = document.createElement('div'); it.className = 'cs-ac-item' + (i === 0 ? ' cs-ac-active' : ''); it.setAttribute('role','option');
      var pips = o.colors ? '<span style="display:inline-flex;gap:3px">' + o.colors.map(function(c){ return '<span class="cs-pip" style="width:20px;height:20px;font-size:.62rem;border-width:1px" data-c="'+c+'">'+c+'</span>'; }).join('') + '</span>' : '';
      it.innerHTML = pips + '<span class="cs-ac-name">' + (o.neg ? 'NOT ' : '') + o.label + '</span><span style="margin-left:auto;font-size:.66rem;text-transform:uppercase;letter-spacing:.06em;color:#8A8378">' + o.kind + '</span>';
      it.onmousedown = function(e){ e.preventDefault(); advChooseToken(o); };
      it.onmouseenter = function(){ setAcActive(i); };
      box.appendChild(it);
    });
    box.classList.add('open');
  }
  function advChooseToken(o){
    if (o.kind === 'loading') return;   // placeholder while the set list loads — not selectable
    var tok = advActiveToken(), el = $('cs-q');
    advApplyToken(o);
    el.value = (el.value.slice(0, tok.start) + el.value.slice(tok.end)).replace(/\s+/g,' ').replace(/^\s+|\s+$/g,'');
    closeAC(); advRender(); commitGame(); if (typeof syncUrl === 'function') syncUrl();
    if (typeof updateSetBrowseCount === 'function') updateSetBrowseCount();   // set/format feed the Sets badge
    if ((mtgOnly() || pokemonOnly()) && SET_SERVER_FILTER) refilter();
    el.focus();
  }
  // ── Bare-term filter detection (typed value with NO key: prefix) ──────────────
  // When a plain term matches a known facet value ("mythic", "azorius", "modern",
  // "bloomburrow", "rainbow foil", "ex"…) we offer it as a FILTER row atop the card
  // suggestions, reusing the same completion objects advApplyToken already consumes.
  // Available wherever the typed-filter language is (Magic + Pokémon + All).
  function bareFilterAllowed(){ return mtgOnly() || pokemonOnly() || selGames.size === 0; }
  // Finish/treatment vocab. This used to append a hand-written premium-foil list to
  // ADV_TREATMENTS, and two of those entries ("Textured Foil", "Step-and-Repeat Foil")
  // were spellings the backend never emits — so they showed in the dropdown and then
  // returned nothing, the exact bug that list was added to fix. ADV_TREATMENTS is now
  // the canonical vocabulary, premium foils included, so the two lists are one.
  var BARE_TREATMENTS = ADV_TREATMENTS;
  // Match strength: 2 = exact, 1 = the term is a ≥4-char prefix of the value. Anything
  // looser is too noisy for a bare word (it must look like the whole facet value).
  function bareScore(term, value){
    var v = String(value).toLowerCase();
    if (v === term) return 2;
    if (term.length >= 4 && v.indexOf(term) === 0) return 1;
    return 0;
  }
  // Exact color word ("blue") or guild/wedge name ("azorius") → a Color facet row.
  function bareColorMatch(term){
    var letters = ADV_NAME1[term] || ADV_NAME2C[term];
    if (!letters) return null;
    var code = letters === 'C' ? 'C' : advSortC(letters);
    var colors = code.split('');
    return { kind:'color', code:code, colors:colors, label:(ADV_GUILDS[code] || code), _score:2 };
  }
  // Sets/series need the (lazy) set catalog; kick a load so the NEXT keystroke includes
  // them, and match only strongly (exact code, or a ≥4-char name prefix) to stay quiet.
  function bareSetMatches(term){
    if (!SETB.loaded){ loadSets().then(function(){ if (document.activeElement === $('cs-q')) { var t = $('cs-q').value.trim(); if (t){ acBareComps = bareFilterAllowed() ? bareFilterCompletions(t) : []; showAC(); } } }); return []; }
    if (term.length < 4) return [];
    var res = [];
    SETB.sets.forEach(function(s){
      var n = (s.name || '').toLowerCase(), c = (s.code || '').toLowerCase();
      var sc = (c === term) ? 2 : (n.indexOf(term) === 0 ? 1 : 0);
      if (sc) res.push({ kind:'set', code:s.code, label:s.name + '  (' + (s.code || '').toUpperCase() + ')', _score:sc, _instock:!!s.inStock });
    });
    res.sort(function(a, b){ return (b._score - a._score) || (b._instock - a._instock); });
    return res.slice(0, 2);
  }
  function bareSeriesMatches(term){
    if (!SETB.loaded || SETB.game !== 'pokemon'){ loadSets(); return []; }
    if (term.length < 4) return [];
    return ((SETB.groups && SETB.groups.bySeries) || [])
      .filter(function(g){ var s = g.series.toLowerCase(); return s === term || s.indexOf(term) === 0; })
      .slice(0, 2).map(function(g){ return { kind:'series', value:g.series, label:g.series + '  (' + g.codes.length + ')', _score:g.series.toLowerCase() === term ? 2 : 1 }; });
  }
  function bareFilterCompletions(rawTerm){
    var term = String(rawTerm || '').toLowerCase().trim();
    if (term.length < 3) return [];   // too short to confidently be a facet value
    var out = [];
    function scan(vocab, kind){ vocab.forEach(function(v){ var s = bareScore(term, v); if (s) out.push({ kind:kind, value:v, label:v, _score:s }); }); }
    if (advGame() === 'pokemon'){
      scan(ADV_ENERGY, 'energy');
      scan(ADV_PK_RARITY, 'rarity');
      scan(ADV_PK_SUPERS, 'supertype');
      scan(ADV_PK_SUB, 'subtype');
      bareSeriesMatches(term).forEach(function(o){ out.push(o); });
    } else {
      var cc = bareColorMatch(term); if (cc) out.push(cc);
      scan(ADV_RARITY, 'rarity');
      scan(ADV_TYPES, 'type');
      scan(ADV_SUPERS, 'supertype');
      scan(ADV_SUB, 'subtype');
      scan(FORMAT_TAGS, 'format');
      scan(BARE_TREATMENTS, 'treatment');
    }
    bareSetMatches(term).forEach(function(o){ out.push(o); });
    out.sort(function(a, b){ return (b._score || 0) - (a._score || 0); });
    return out.slice(0, 5);
  }
  // Apply a detected filter: the whole term WAS the facet, so clear the box and run the
  // (now filtered) browse. Mirrors advChooseToken's tail but drops the entire query.
  function applyBareFilter(o){
    if (!o || o.kind === 'loading') return;
    advApplyToken(o);
    $('cs-q').value = '';
    closeAC(); advRender(); commitGame();
    if (typeof syncUrl === 'function') syncUrl();
    if (typeof updateSetBrowseCount === 'function') updateSetBrowseCount();
    refilter();
    $('cs-q').focus();
  }

  // Typing "?" (as a token) opens a cheat-sheet of the search-command language.
  function advMaybeHelp(){
    var tok = advActiveToken();
    if (tok.text !== '?' && $('cs-q').value.trim() !== '?') return false;
    renderHelpPanel();
    return true;
  }
  var HELP_CMDS = [
    ['c:rg   ·   color:gruul', 'By color or guild. Use = for exact (c=wu); prefix - to exclude (-c:b).'],
    ['t:elf   ·   type:creature', 'Card type, supertype, or creature subtype.'],
    ['r:mythic', 'Rarity: common, uncommon, rare, mythic, special.'],
    ['set:bloomburrow   ·   set:blb', 'Filter to a set by name or set code.'],
    ['format:modern   ·   f:commander', 'Cards legal in a format.'],
    ['super:legendary', 'Supertype (legendary, snow, basic).'],
    ['sub:dragon', 'Creature / permanent subtype.'],
    ['legendary:true', 'Quick legendary / non-legendary toggle.'],
    ['kw:flying   ·   keyword:trample', 'Filter by a keyword ability.'],
    ['treatment:borderless', 'Special versions: showcase, borderless, extended art, retro, foil etched, promo, reserved list.'],
    ['sort:popularity   ·   sort:price', 'Sort: relevance, popularity (EDHREC), released, price, name.'],
  ];
  var HELP_CMDS_PK = [
    ['type:fire   ·   type:water', 'By energy type: grass, fire, water, lightning, psychic, fighting, darkness, metal, fairy, dragon, colorless.'],
    ['r:illustration   ·   rarity:double rare', 'Rarity: common … double rare, illustration rare, special illustration rare, hyper rare, ACE SPEC.'],
    ['set:surging   ·   set:ssp', 'Filter to an expansion by name or set code.'],
    ['series:scarlet', 'Filter to a whole series/era (Scarlet & Violet, Sword & Shield, …).'],
    ['super:trainer', 'Card category: Pokémon, Trainer, Energy.'],
    ['sub:ex   ·   sub:vmax', 'Subtype: ex, V, VMAX, VSTAR, GX, Supporter, Item, Stadium, Basic, Stage 1/2…'],
  ];
  function renderHelpPanel(){
    acGen++;                       // cancel any in-flight name lookup
    acMode = 'help'; acItems = []; acIndex = -1;
    var pk = pokemonOnly();
    var cmds = pk ? HELP_CMDS_PK : HELP_CMDS;
    var box = $('cs-ac');
    box.innerHTML = '<div class="cs-help">' +
      '<div class="cs-help-h">Type a filter, then pick from the list. Combine several with spaces' + (pk ? '.' : '; prefix <b>-</b> to exclude.') + '</div>' +
      cmds.map(function(r){
        var ex = r[0].split(' ')[0];   // first token = the example to insert
        return '<button type="button" class="cs-help-row" data-ex="' + ex + '"><code>' + r[0] + '</code><span class="cs-help-d">' + r[1] + '</span></button>';
      }).join('') +
      '<div class="cs-help-f">Expansions: use the <b>Sets</b> button. These filters apply to ' + (pk ? 'Pokémon' : 'Magic') + '.</div>' +
    '</div>';
    box.classList.add('open');
    Array.prototype.forEach.call(box.querySelectorAll('.cs-help-row'), function(btn){
      btn.onmousedown = function(e){ e.preventDefault(); var el = $('cs-q'); el.value = btn.getAttribute('data-ex'); el.focus(); advMaybeFilterAC(); };
    });
  }
  // Returns true if it handled the input as a filter token (so name search is skipped).
  function advMaybeFilterAC(){
    if (!mtgOnly() && !pokemonOnly() && selGames.size !== 0) return false;   // available on Magic + Pokémon + All
    var tok = advActiveToken(); if (!tok.text) return false;
    var comps = advCompletions(tok.text);
    if (comps == null) return false;          // not a filter prefix
    if (comps.length) advRenderACFilter(comps); else closeAC();
    return true;
  }

  (function advInit(){
    advBuild(); advBuiltGame = advGame();
    var btn = $('cs-adv-btn'); if (btn) btn.addEventListener('click', function(e){ e.preventDefault(); advToggle(); });
    document.addEventListener('mousedown', function(e){ var p = $('cs-adv'), b = $('cs-adv-btn'); if (p && p.classList.contains('open') && !p.contains(e.target) && b && !b.contains(e.target)) advClose(); });
    advRender();
  })();

  // ── Embed API (Commander Workbench) ──────────────────────────────────────
  // Lock the engine to MTG singles + Commander format + the commander's colour
  // identity, wire the add-to-deck callbacks, and (re)load. Call again when the
  // commander changes to update colours. Requires search_source:'api'.
  function embedSetup(opts){
    opts = opts || {};
    EMBED_CB = { onAdd: opts.onAdd, isInDeck: opts.isInDeck };
    EMBED_DEFAULT = opts.defaultProvider || null;
    selGames = new Set(['MTG Single']);
    selTypes = new Set(['singles']);
    facetState['Format'] = new Set(['Commander']);
    ADV.cmode = 'commander';
    var names = (opts.colorIdentity || []).map(function(c){ return CODE2C[c] || c; }).filter(Boolean);
    if (names.length) facetState['Color'] = new Set(names); else delete facetState['Color'];
    keepFilters = true;
    if ($('cs-q')) $('cs-q').value = '';
    loadDefault();
  }
  // Update the locked colour identity without a full reload (e.g. once EDHREC gives
  // the authoritative identity). Re-filters any results currently shown.
  function setColorIdentity(ci){
    ADV.cmode = 'commander';
    var names = (ci || []).map(function(c){ return CODE2C[c] || c; }).filter(Boolean);
    if (names.length) facetState['Color'] = new Set(names); else delete facetState['Color'];
    if (cards && cards.length) render();
  }
  // Open the unified card modal (variant explorer + add-to-deck) for a card name.
  function openCard(name){
    if (!API_BASE || !name) return;
    // Typesense ranks near-matches first (e.g. "Tony Stark" can surface "Iron Man,
    // Tony Stark"), so pull several hits and require an exact face-name match rather
    // than blindly opening results[0]. Mirror the normalization used by openVariants.
    var want = String(name).toLowerCase().split('//')[0].replace(/[^a-z0-9]+/g, ' ').trim();
    fetch(API_BASE.replace(/\/+$/, '') + '/api/search?per_page=30&q=' + encodeURIComponent(name))
      .then(function(r){ return r.json(); })
      .then(function(res){
        var docs = (res.results || []).filter(function(d){ return String(d.name).toLowerCase().split('//')[0].replace(/[^a-z0-9]+/g, ' ').trim() === want; });
        // Price-check first: this opens the cart modal, whose subtotal must match checkout.
        return hydrateDocs(docs).then(function(live){
          var d = live.filter(function(x){ return x.in_stock; })[0] || live[0];
          if (d) openCart(docToCard(d));
        });
      })
      .catch(function(){});
  }
  // Re-render current results (e.g. after the deck changes, to refresh + / ✓ state).
  function refresh(){ if (cards && cards.length) render(); }
  // Printing picker: every in-stock printing of a card name as an image grid. "+ Add"
  // adds that printing to the deck (embed) via EMBED_CB.onAdd. opts.onPick(doc) overrides
  // the action (used for the commander's printing). Reuses the #cs-cart modal shell.
  function openVariants(name, opts){
    opts = opts || {};
    if (!API_BASE || !name) return;
    cartCard = null;
    var ce = $('cs-cart-card'); if (ce) ce.classList.add('cs-varmode'); // full-width grid, no left image column
    $('cs-cart-title').textContent = name;
    var sub2 = $('cs-cart-sub2'); if (sub2) sub2.textContent = opts.subtitle || 'Pick a printing for your deck';
    var left = $('cs-cart-left'); if (left) left.innerHTML = '';
    ['cs-cart-arrow-prev','cs-cart-arrow-next','cs-cart-prev','cs-cart-next'].forEach(function(id){ var e = $(id); if (e) e.style.display = 'none'; });
    var body = $('cs-cart-body');
    body.innerHTML = '<div style="padding:1.1rem;color:#8A8378;font-family:var(--font-body,sans-serif)"><span class="cs-spinner" style="display:inline-block;width:14px;height:14px;border:2px solid rgba(28,23,18,.3);border-top-color:#1C1712;border-radius:50%;vertical-align:middle"></span> Finding printings…</div>';
    $('cs-cart').style.display = 'flex';
    var want = String(name).toLowerCase().split('//')[0].replace(/[^a-z0-9]+/g, ' ').trim();
    // Fetch ALL printings (not just in-stock) so we can offer an out-of-stock toggle.
    fetch(API_BASE.replace(/\/+$/, '') + '/api/search?per_page=60&q=' + encodeURIComponent(name)).then(function(r){ return r.json(); }).then(function(res){
      var found = (res.results || []).filter(function(d){ return String(d.name).toLowerCase().split('//')[0].replace(/[^a-z0-9]+/g, ' ').trim() === want; });
      // Tiles quote a "from $" per printing and feed openCart/onAdd — all live-priced.
      return hydrateDocs(found);
    }).then(function(docs){
      if (!docs.length){ body.innerHTML = '<div style="padding:1.1rem;color:#8A8378;font-family:var(--font-body,sans-serif)">No printings found.</div>'; return; }
      var anyStock = docs.some(function(d){ return d.in_stock; });
      var showOOS = !anyStock; // if nothing's in stock, show everything so a printing can still be picked
      function tileFor(d){
        var tile = document.createElement('div'); tile.className = 'cs-var-tile' + (d.in_stock ? '' : ' cs-var-oos');
        var cap = sellEsc(d.set_name || '?') + (d.collector_number ? (' · #' + sellEsc(d.collector_number)) : '');
        tile.innerHTML =
          (d.image_url
            ? '<img src="' + sellEsc(d.image_url) + '" alt="' + sellEsc(d.name) + '" loading="lazy">'
            : (TTT.cardBack(d.game)
                ? '<img class="cs-var-back" src="' + sellEsc(TTT.cardBack(d.game)) + '" alt="" loading="lazy">'
                : '<div class="cs-var-noimg">' + sellEsc(d.name) + '</div>')) +
          '<div class="cs-var-cap">' + cap + '</div>' +
          '<div class="cs-var-price">' + (d.in_stock ? (d.min_price != null ? ('from ' + fmt(d.min_price)) : '') : 'Out of stock') + '</div>';
        var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'cs-var-add';
        if (opts.onPick){ btn.textContent = opts.addLabel || 'Use this'; btn.onclick = function(){ opts.onPick(d); btn.textContent = '✓'; }; }
        else if (EMBED && EMBED_CB && EMBED_CB.onAdd){ btn.textContent = '+ Add'; btn.onclick = function(){ EMBED_CB.onAdd(docToCard(d)); btn.textContent = '✓ Added'; }; }
        else { btn.textContent = 'View'; btn.onclick = function(){ openCart(docToCard(d)); }; }
        tile.appendChild(btn);
        return tile;
      }
      function draw(){
        var list = showOOS ? docs : docs.filter(function(d){ return d.in_stock; });
        body.innerHTML = '<label class="cs-var-toggle"><input type="checkbox" id="cs-var-oos"' + (showOOS ? ' checked' : '') + (anyStock ? '' : ' disabled') + '> Show out-of-stock printings</label>' +
          (!anyStock ? '<div class="cs-var-note">No printings in stock right now — you can still pick one for your deck.</div>' : '') +
          '<div class="cs-var-grid" id="cs-var-grid"></div>';
        var grid = $('cs-var-grid');
        list.forEach(function(d){ grid.appendChild(tileFor(d)); });
        var t = $('cs-var-oos'); if (t) t.onchange = function(){ showOOS = t.checked; draw(); };
      }
      body.innerHTML = ''; draw();
    }).catch(function(){ body.innerHTML = '<div style="padding:1.1rem;color:#8A8378;font-family:var(--font-body,sans-serif)">Couldn’t load printings.</div>'; });
  }

  // Programmatically apply a server-side facet (e.g. a commander's theme → Subtype /
  // Keyword / Type) and run the filtered browse. Passing value=null clears that facet
  // (→ back to recs). Surfaces as a removable chip like any manual filter.
  function applyFacet(ns, value){
    if (value == null){ if (facetState[ns]) delete facetState[ns]; }
    else facetState[ns] = new Set([value]);
    if (typeof switchToMagic === 'function') switchToMagic();
    if (typeof syncUrl === 'function') syncUrl();
    refilter();
  }
  return { closeDetail:closeDetail, closeCart:closeCart, closeSell:closeSell, submitCart:submitCart,
           closeSetBrowser:closeSetBrowser, openSetBrowser:openSetBrowser,
           detailNav:detailNav, cartNav:cartNav,
           embedSetup:embedSetup, openCard:openCard, openVariants:openVariants, refresh:refresh, reloadDefault:reloadDefault, setColorIdentity:setColorIdentity, applyFacet:applyFacet,
           // Shared with any other surface that renders /api/search docs (printing
           // picker, Commander Workbench) so they quote live Shopify prices too.
           hydrateDocs:hydrateDocs };
})();
